/**
 * Mocking client-server processing
 */

const _data = [
  {
    keyword: "cloud computing",
    meaning:
      "บริการประมวลผลด้วยการใช้ทรัพยากรคอมพิวเตอร์ร่วมกันผ่านเครือข่ายตามความต้องการได้อย่างสะดวก โดยมีรูปแบบ ดังนี้\r\n1. การให้บริการโครงสร้างพื้นฐานหลัก (Infrastructure as a Service: IaaS) ประกอบด้วยระบบประมวลผลข้อมูล ระบบการจัดเก็บข้อมูล ระบบเครือข่าย และทรัพยากรพื้นฐานอื่นๆที่เกี่ยวข้องกับระบบประมวลผล ผู้ใช้บริการสามารถใช้งานซอฟต์แวร์บนโครงสร้างพื้นฐานและทรัพยากรที่ผู้ให้บริการจัดหาให้ได้อย่างมีประสิทธิภาพ โดยไม่ต้องบริหารจัดการโครงสร้างพื้นฐานที่จำเป็นด้วยตนเอง \r\n2. การให้บริการแพลตฟอร์ม (Platform as a Service: PaaS) ประกอบด้วย ระบบโปรแกรมงานคอมพิวเตอร์ ระบบฐานข้อมูล และระบบจัดการหรืองานบริการจากคอมพิวเตอร์ ผู้ใช้บริการสามารถพัฒนา ติดตั้ง และปรับแต่งซอฟต์แวร์ได้ โดยไม่ต้องบริหารจัดการในส่วนที่เกี่ยวข้องกับโครงสร้างพื้นฐาน เครือข่าย ระบบปฏิบัติการ และระบบจัดการฐานข้อมูล \r\n3. การให้บริการซอฟต์แวร์ (Software as a Service: SaaS) ผู้ให้บริการจัดเตรียมซอฟต์แวร์สำเร็จรูปแล้ว โดยผู้ใช้บริการสามารถกำหนดค่าความต้องการ พารามิเตอร์ ปริมาณหน่วยประมวลผลข้อมูล หน่วยเก็บข้อมูล และบริหารจัดการเพื่อให้ได้บริการตามวัตถุประสงค์ \r\n4. การให้บริการใดที่เป็นการรวมกันของสองบริการขึ้นไป จาก ข้อ 1 ถึง 3 \r\n5. การให้บริการอื่นที่ประกาศกำหนด",
    source:
      "ประกาศคณะกรรมการธุรกรรมทางอิเล็กทรอนิกส์ เรื่อง แนวทางการใช้บริการคลาวด์ พ.ศ. 2562. (2562, 11 มิถุนายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนพิเศษ 149 ง.http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/E/149/T_0039.PDF",
    sappear: "",
    mappear: "",
    rappear: "4,9",
    type: "กฎหมาย",
    firstalpha: "c"
  },
  {
    keyword: "เขตทางทะเล",
    meaning:
      "ชายฝั่งทะเลและพื้นที่ทางทะเลที่ประเทศไทยมีอำนาจอธิปไตย\r\nหรือสิทธิอธิปไตย หรือมีสิทธิหรือเสรีภาพในการใช้หรือจะใช้ หรือมีหน้าที่รับผิดชอบตามกฎหมายระหว่างประเทศหรือตามสนธิสัญญาหรือด้วยประการใด ๆ ได้แก่ น่านน้ำภายใน ทะเลอาณาเขตเขตต่อเนื่อง เขตเศรษฐกิจจำเพาะ ไหล่ทวีป และทะเลหลวง และให้หมายความรวมถึงเกาะเทียมสิ่งติดตั้ง และสิ่งปลูกสร้างในทะเล รวมทั้งห้วงอากาศเหนือทะเล พื้นดินท้องทะเล ใต้พื้นดินท้องทะเลและพื้นที่ทางทะเลอื่นตามที่คณะกรรมการประกาศกำหนดในราชกิจจานุเบกษา",
    source:
      "พระราชบัญญัติการรักษาผลประโยชน์ของชาติทางทะเล พ.ศ. 2562. (2562, 12 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 30 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/030/T_0001.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "ข"
  },
  {
    keyword: "เขตพัฒนาพิเศษภาคตะวันออก",
    meaning:
      "พื้นที่จังหวัดฉะเชิงเทรา ชลบุรี และระยอง และพื้นที่อื่นใดที่อยู่ในภาคตะวันออกที่กำหนดเพิ่มเติมโดยพระราชกฤษฎีกาเป็นเขตพัฒนาพิเศษภาคตะวันออก",
    source:
      "พระราชบัญญัติเขตพัฒนาพิเศษภาคตะวันออก พ.ศ.2561. (2561, 14 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 34 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/034/1.PDF",
    sappear: "",
    mappear: 9,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ข"
  },
  {
    keyword: "เขตอนุรักษ์",
    meaning:
      "เขตอุทยานแห่งชาติ เขตรักษาพันธุ์สัตว์ป่า เขตสงวนเพื่อการท่องเที่ยว และเขตพื้นที่คุ้มครองอย่างอื่นเพื่อสงวนและรักษาสภาพธรรมชาติตามที่มีกฎหมายกำหนด",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ\r\nพ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 3.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "ข"
  },
  {
    keyword: "เครือข่ายบริการปฐมภูมิ",
    meaning:
      "หน่วยบริการปฐมภูมิที่รวมตัวกัน โดยประกอบด้วยหน่วยบริการ ประจำหนึ่งหน่วยเป็นแกนกลาง รวมตัวกับหน่วยบริการที่รับส่งต่อและหน่วยบริการปฐมภูมิ ทั้งนี้ อาจมี เครือข่ายหน่วยบริการร่วมให้บริการเข้าร่วมก็ได้ และได้ขึ้นทะเบียนเป็นเครือข่ายหน่วยบริการตามที่สำนักงาน หลักประกัน-สุขภาพแห่งชาติประกาศ โดยเครือข่ายหน่วยบริการมีสิทธิได้รับค่าใช้จ่ายเพื่อบริการสาธารณสุข จากหน่วยบริการ หรือจากกองทุน ตามที่คณะกรรมการกำหนด",
    source:
      "ระบบสุขภาพปฐมภูมิ พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจนาบุเษก. เล่ม 136 ตอนที่ 56 ก หน้า 165-185.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0165.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    type: "กฎหมาย",
    firstalpha: "ค"
  },
  {
    keyword: "เชื้อพันธุ์",
    meaning:
      "กลุ่มเซลล์ที่มีหน่วยพันธุกรรมหลากหลาย ซึ่งถ่ายทอดได้ ที่รวมตัวกันเป็นชิ้นส่วนของพืชที่ยังมีชีวิตและขยายพันธุ์ได้ ไม่ว่าจะอยู่ในรูปของเมล็ด เนื้อเยื่อหรือส่วนหนึ่งส่วนใดของพืช และให้หมายความรวมถึงสารพันธุกรรม ซึ่งสามารถถ่ายทอดลักษณะที่สารพันธุกรรมนั้นควบคุมอยู่ได้  ทั้งนี้ เฉพาะที่ใช้ประโยชน์ในการปรับปรุงพันธุ์",
    source:
      "พระราชบัญญัติกักพืช พ.ศ. 2507. (2507, 21 มีนาคม). ราชกิจจานุเบกษา. เล่ม 81 ตอนที่ 27. http://www.ratchakitcha.soc.go.th/DATA/PDF/2507/A/027/1.PDF",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ช"
  },
  {
    keyword: "เอกสารสิทธิ์",
    meaning:
      "เอกสารที่เป็นหลักฐานแห่งการก่อ เปลี่ยนแปลง โอน สงวนหรือระงับซึ่งสิทธิ",
    source:
      "ประมวลพระราชบัญญัติให้ใช้ประมวลกฎหมายอาญา พ.ศ.2499. (2499, 19 พฤศจิกายน). ราชกิจจานุเบกษา. เล่มที่ 73 ตอนที่ 95 หน้า 14.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2499/A/095/12.PDF",
    sappear: 4,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "แพทย์เวชศาสตร์ครอบครัว",
    meaning:
      "แพทย์ที่ได้รับหนังสืออนุมัติหรือวุฒิบัตรเพื่อแสดงความรู้ความชำนาญในการประกอบวิชาชีพเวชกรรมสาขาเวชศาสตร์ครอบครัว",
    source:
      "พระราชบัญญัติระบบสุขภาพปฐม พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก หน้า 166. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0165.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    type: "กฎหมาย",
    firstalpha: "พ"
  },
  {
    keyword: "แหล่งกำเนิดมลพิษ",
    meaning:
      "โรงงานอุตสาหกรรม อาคาร สิ่งก่อสร้าง ยานพาหนะและสถานที่ประกอบกิจการใด ๆ ซึ่งเป็นแหล่งที่มาของมลพิษ",
    source:
      "พระราชบัญญัติควบคุมโรคจากการประกอบอาชีพและโรคจากสิ่งแวดล้อม พ.ศ. 2562. (2562, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 217. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0215.PDF",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ห"
  },
  {
    keyword: "ไต่สวน",
    meaning:
      "การแสวงหา รวบรวม และการดําเนินการอื่นใด เพื่อให้ได้มา ซึ่งข้อเท็จจริงและพยานหลักฐาน ",
    source:
      "พระราชบัญญัติประกอบรัฐธรรมนูญว่าด้วยการป้องกันและปราบปรามการทุจริต พ.ศ. 2561. (2561, 21 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 52 ก หน้า 4. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/052/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "กฎหมาย",
    firstalpha: "ต"
  },
  {
    keyword: "กลุ่มจังหวัดภาคเหนือตอนบน",
    meaning:
      "กลุ่มจังหวัดภาคเหนือตอนบน 1 ประกอบด้วย จังหวัดเชียงใหม่ จังหวัดแม่ฮ่องสอน จังหวัดลําปาง และจังหวัดลําพูน โดยให้จังหวัดเชียงใหม่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด\r\nกลุ่มจังหวัดภาคเหนือตอนบน 2 ประกอบด้วย จังหวัดเชียงราย จังหวัดน่าน จังหวัดพะเยาและจังหวัดแพร่ โดยให้จังหวัดเชียงรายเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคเหนือตอนล่าง",
    meaning:
      "กลุ่มจังหวัดภาคเหนือตอนล่าง 1 ประกอบด้วย จังหวัดตาก จังหวัดพิษณุโลก จังหวัดเพชรบูรณ์ จังหวัดสุโขทัย และจังหวัดอุตรดิตถ์ โดยให้จังหวัดพิษณุโลกเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด\r\nกลุ่มจังหวัดภาคเหนือตอนล่าง 2 ประกอบด้วย จังหวัดกําแพงเพชร จังหวัดนครสวรรค์ จังหวัดพิจิตร และจังหวัดอุทัยธานี โดยให้จังหวัดนครสวรรค์เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคใต้ชายแดน",
    meaning:
      "จังหวัดนราธิวาส จังหวัดปัตตานี จังหวัดยะลา โดยให้จังหวัดยะลาเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคใต้ฝั่งอันดามัน",
    meaning:
      "จังหวัดกระบี่ จังหวัดตรัง จังหวัดพังงา จังหวัดภูเก็ต จังหวัดระนอง และจังหวัดสตูล โดยให้จังหวัดภูเก็ตเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคใต้ฝั่งอ่าวไทย",
    meaning:
      "จังหวัดชุมพร จังหวัดนครศรีธรรมราช จังหวัดพัทลุง จังหวัดสุราษฎร์ธานี และจังหวัดสงขลา โดยให้จังหวัดสุราษฎร์ธานีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคกลางตอนกลาง",
    meaning:
      "จังหวัดนนทบุรี จังหวัดปทุมธานี จังหวัดนครปฐมและจังหวัดสมุทรปราการ โดยให้จังหวัดนครปฐมเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคกลางตอนบน",
    meaning:
      "จังหวัดชัยนาท จังหวัดพระนครศรีอยุธยา จังหวัดลพบุรี จังหวัดสระบุรี จังหวัดสิงห์บุรี และจังหวัดอ่างทอง โดยให้จังหวัดพระนครศรีอยุธยาเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคตะวันออก",
    meaning:
      "กลุ่มจังหวัดภาคตะวันออก 1 ประกอบด้วย จังหวัดฉะเชิงเทรา จังหวัดชลบุรี และจังหวัดระยอง โดยให้จังหวัดชลบุรีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด\r\nกลุ่มจังหวัดภาคตะวันออก 2 ประกอบด้วย จังหวัดจันทบุรี จังหวัดตราด จังหวัดนครนายกจังหวัดปราจีนบุรี และจังหวัดสระแก้ว โดยให้จังหวัดปราจีนบุรีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนกลาง",
    meaning:
      "จังหวัดกาฬสินธุ์ จังหวัดขอนแก่น จังหวัดมหาสารคาม และจังหวัดร้อยเอ็ด โดยให้จังหวัดขอนแก่นเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน",
    meaning:
      "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 1 ประกอบด้วย จังหวัดบึงกาฬ จังหวัดเลย จังหวัดหนองคาย จังหวัดหนองบัวลําภู และจังหวัดอุดรธานี โดยให้จังหวัดอุดรธานีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 2 ประกอบด้วย จังหวัดนครพนม จังหวัดมุกดาหาร และจังหวัดสกลนคร โดยให้จังหวัดสกลนครเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง",
    meaning:
      "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 1 ประกอบด้วย จังหวัดชัยภูมิจังหวัดนครราชสีมา จังหวัดบุรีรัมย์ และจังหวัดสุรินทร์ โดยให้จังหวัดนครราชสีมาเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด\r\nกลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 2 ประกอบด้วย จังหวัดยโสธรจังหวัดศรีสะเกษ จังหวัดอํานาจเจริญ และจังหวัดอุบลราชธานี โดยให้จังหวัดอุบลราชธานีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซเรือนกระจก",
    meaning:
      "บรรดาก๊าซอันเป็นส่วนประกอบหนึ่งของบรรยากาศทั้งที่มีอยู่ตามธรรมชาติหรือที่มนุษย์สร้างขึ้น ซึ่งดูดซึมและปล่อยซ้ำรังสีอินฟาเรด",
    source:
      "พระราชกฤษฎีกาจัดตั้งองค์การบริหารจัดการก๊าซเรือนกระจก (องค์การมหาชน) พ.ศ. 2550, (2550, 6 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 124 ตอนที่ 31 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/031/53.PDF",
    sappear: 5,
    mappear: 18,
    rappear: 2,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การเฝ้าระวัง",
    meaning:
      "การสังเกต การเก็บรวบรวม และการวิเคราะห์ข้อมูล ตลอดจน\r\nการรายงาน และการติดตามผลของโรคจากการประกอบอาชีพและโรคจากสิ่งแวดล้อมอย่างต่อเนื่อง\r\nด้วยกระบวนการที่เป็นระบบ เพื่อประโยชน์ในการป้องกันและการควบคุมโรค",
    source:
      "พระราชบัญญัติควบคุมโรคจากการประกอบอาชีพและโรคจากสิ่งแวดล้อม พ.ศ. 2562. (2562, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 217. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0215.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การแพทย์ฉุกเฉิน",
    meaning:
      "การปฏิบัติการฉุกเฉิน การศึกษา การฝึกอบรม การค้นคว้าและการวิจัยเกี่ยวกับการประเมินการจัดการ \r\nการบําบัดรักษาผู้ป่วยฉุกเฉิน และการป้องกันการเจ็บป่วยที่เกิดขึ้นฉุกเฉิน",
    source:
      "พระราชบัญญัติการแพทย์ฉุกเฉิน พ.ศ. 2551. (2551, 6 มีนาคม). ราชกิจจานุเบกษา. เล่ม 125 ตอนที่ 44 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/044/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดรูปที่ดิน",
    meaning:
      "การดําเนินงานพัฒนาที่ดินที่ใช้เพื่อเกษตรกรรมให้สมบูรณ์ทั่วถึงที่ดินทุกแปลง เพื่อเพิ่มผลผลิตและลดต้นทุนการผลิต โดยทําการรวบรวมที่ดินหลายแปลงในบริเวณเดียวกัน เพื่อวางผังจัดรูปที่ดินเสียใหม่ การจัดระบบชลประทาน การจัดสร้างถนนหรือทางลําเลียงในไร่นา การปรับระดับพื้นที่ดิน การบํารุงดิน การวางแผนการผลิตและการจําหน่ายผลิตผลการเกษตร รวมตลอดถึงการแลกเปลี่ยน การโอน การรับโอนสิทธิในที่ดิน การให้เช่าซื้อที่ดิน และการอื่น ๆ ที่เกี่ยวกับการจัดรูปที่ดินเพื่อเกษตรกรรม",
    source:
      "พระราชบัญญัติจัดรูปที่ดินเพื่อเกษตรกรรม พ.ศ. 2558. (2558, 2 มีนาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 14 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/014/1.PDF ",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การท่องเที่ยวอย่างยั่งยืน",
    meaning:
      "การจัดการรูปแบบการท่องเที่ยวเพื่อตอบสนองความจำเป็นทางเศรษฐกิจ สังคม วัฒนธรรม และสุนทรียภาพ โดยคำนึงถึงการใช้ทรัพยากรที่มีคุณค่าอย่างสมเหตุสมผลและสามารถรักษาเอกลักษณ์ของธรรมชาติ วัฒนธรรม เพื่อการใช้ประโยชน์อย่างยั่งยืน",
    source:
      "พระราชกฤษฎีกาจัดตั้งองค์การบริหารพัฒนาพื้นที่พิเศษเพื่อการท่องเที่ยวอย่างยั่งยืน (องค์การมหาชน) พ.ศ. 2546. (2546, 24 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 120 ตอนที่ 49 ก หน้า 282. http://web.krisdika.go.th/data/law/law2/%CD17/%CD17-2a-2546-a0003.htm",
    sappear: "",
    mappear: 5,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารงานยุติธรรม",
    meaning:
      "การดําเนินการที่เกี่ยวกับการบริหารจัดการในการอํานวยความยุติธรรม การป้องกันและแก้ไขปัญหาอาชญากรรม การคุ้มครองความปลอดภัยในชีวิตและทรัพย์สิน การคุ้มครองสิทธิเสรีภาพให้กับประชาชน \r\nการบังคับการตามกฎหมายและการอํานวยความสะดวกแก่ประชาชน แต่ไม่รวมถึงอํานาจอิสระในการพิจารณาพิพากษาอรรถคดีของศาล\r\nและการดําเนินการของหน่วยงานอิสระตามรัฐธรรมนูญ",
    source:
      "พระราชบัญญัติพัฒนาการบริหารงานยุติธรรมแห่งชาติ พ.ศ. 2549. (2549, 15 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 123 ตอนที่ 26 ก หน้า 6. http://www.ratchakitcha.soc.go.th/DATA/PDF/2549/00184410.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารจัดการที่ดิน",
    meaning:
      "การบูรณาการในการดูแลรักษา การสงวนหวงห้าม การอนุรักษ์ การฟื้นฟูและพัฒนาซึ่งที่ดิน การกระจายการถือครองที่ดิน การใช้ประโยชน์อย่างสมดุลหรือการแก้ไขปัญหาด้านที่ดิน รวมทั้งการอื่นใดที่จ าเป็นเพื่อให้การใช้ที่ดินมีประสิทธิภาพ เกิดผลสัมฤทธิ์\r\nเป็นธรรม และยั่งยืน",
    source:
      "พระราชบัญญัติคณะกรรมการนโยบายที่ดินแห่งชาติ พ.ศ.2562. (2562, 14 เมษายน). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 49 ก หน้าที่ 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/049/T_0001.PDF. ",
    sappear: "",
    mappear: 16,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การระงับข้อพิพาท",
    meaning:
      "“ข้อตกลงระงับข้อพิพาท” หมายความว่า ข้อตกลงที่คู่กรณีตกลงให้มีผลผูกพันโดยชอบด้วยกฎหมายเพื่อระงับข้อพิพาทหรือข้อเรียกร้องใด ๆ ที่แต่ละฝ่ายมีอยู่ และให้คู่กรณีแต่ละฝ่ายต่างมีสิทธิหน้าที่ หรือความรับผิดเพียงเท่าที่กำหนดไว้ในข้อตกลงนั้น",
    source:
      "พระราชบัญญัติการไกล่เกลี่ยข้อพิพาท พ.ศ. 2562. (2562, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0001.PDF",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การรักษาความมั่นคงภายในราชอาณาจักร",
    meaning:
      "การดำเนินการเพื่อป้องกัน ควบคุม แก้ไข และฟื้นฟูสถานการณ์ใดที่เป็นภัยหรืออาจเป็นภัยอันเกิดจากบุคคลหรือกลุ่มบุคคลที่ก่อให้เกิดความไม่สงบสุข ทำลาย หรือทำความเสียหายต่อชีวิต ร่างกาย หรือทรัพย์สินของประชาชนหรือของรัฐ รวมถึงในกรณีที่เกิดหรือคาดว่าจะเกิดสาธารณภัยตามกฎหมายว่าด้วยการป้องกันและบรรเทาสาธารณภัย ให้กลับสู่สภาวะปกติเพื่อให้เกิดความสงบเรียบร้อยของประชาชน หรือความมั่นคงของรัฐ",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงภายในราชอาณาจักร พ.ศ. 2551. (2551, 27 กุมภาพันธ์). ราชกิจานุเบกษา. เล่มที่125 ตอนที่ 29 ก หน้าที่ 34.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/039/33.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การวิจัย",
    meaning:
      "การศึกษาค้นคว้า วิเคราะห์ หรือทดลองอย่างเป็นระบบ อันจะทำให้ได้มาซึ่งข้อเท็จจริง ความรู้ใหม่ หรือหลักการไปใช้ในการตั้งกฎ ทฤษฎี แนวทางในการปฏิบัติ เพื่อเป็นพื้นฐานของการพัฒนาด้านวิทยาศาสตร์ เทคโนโลยี สังคมศาสตร์ มนุษยศาสตร์ และศิลปวิทยาการแขนงต่าง ๆ รวมทั้งเพื่อสร้างนวัตกรรม อันจะสามารถนำมาใช้ประโยชน์ได้",
    source:
      "พระราชบัญญัติสภานโยบายการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมแห่งชาติ\r\nพ.ศ. 2562. (2562, 1 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 57 ก หน้า 9. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/057/T_0008.PDF",
    sappear: "",
    mappear: 23,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การศึกษา",
    meaning:
      "กระบวนการเรียนรู้เพื่อความเจริญงอกงามของบุคคลและสังคม    \r\nโดยการถ่ายทอดความรู้ การฝึก การอบรม การสืบสานทางวัฒนธรรม การสร้างสรรค์จรรโลงความก้าวหน้าทางวิชาการ การสร้างองค์ความรู้อันเกิดจากการจัดสภาพแวดล้อม สังคม การเรียนรู้และปัจจัย\r\nเกื้อหนุนให้บุคคลเรียนรู้อย่างต่อเนื่องตลอดชีวิต",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF                                                                       ",
    sappear: "",
    mappear: "",
    rappear: 12,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การศึกษาตลอดชีวิต",
    meaning:
      "การศึกษาที่เกิดจากการผสมผสานระหว่างการศึกษาใน\r\nระบบ การศึกษานอกระบบและการศึกษาตามอัธยาศัย เพื่อให้สามารถพัฒนาคุณภาพชีวิตได้อย่าง\r\nต่อเนื่องตลอดชีวิต",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF   ",
    sappear: "",
    mappear: "",
    rappear: 12,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การสืบเสาะและพินิจ",
    meaning:
      "การแสวงหาข้อเท็จจริงและรายละเอียดเกี่ยวกับผู้ถูกสืบเสาะและพินิจเพื่อประมวลข้อเท็จจริง จัดทํารายงานและความเห็นเสนอประกอบการพิจารณาของศาลหรือเจ้าพนักงานผู้มีอํานาจ",
    source:
      "พระราชบัญญัติคุมประพฤติ พ.ศ. 2559. (2559, 3 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 88 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/088/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "กิจกรรมทางทะเล",
    meaning:
      "การดำเนินการเพื่อใช้ประโยชน์ในเขตทางทะเลใน\r\nรูปแบบต่าง ๆ เช่น การพาณิชยนาวี การประมง การท่องเที่ยว การแสวงประโยชน์จากทรัพยากร\r\nที่ไม่มีชีวิต การวางสายเคเบิลหรือท่อใต้ทะเล การอนุรักษ์และการจัดการทรัพยากรธรรมชาติและ\r\nสิ่งแวดล้อมทางทะเลและชายฝั่ง การป้องกันและบรรเทาสาธารณภัย หรือการสำรวจและวิจัย\r\nวิทยาศาสตร์ทางทะเล ",
    source:
      "พระราชบัญญัติการรักษาผลประโยชน์ของชาติทางทะเล พ.ศ. 2562. (2562, 12 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 30 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/030/T_0001.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "ของเสีย",
    meaning:
      "ขยะมูลฝอย สิ่งปฏิกูล น้ำเสีย อากาศเสีย มลสาร หรือ\r\nวัตถุอันตรายอื่นใด ซึ่งถูกปล่อยทิ้งหรือมีที่มาจากแหล่งกำเนิดมลพิษ รวมทั้งกาก ตะกอน หรือสิ่ง\r\nตกค้างจากสิ่งเหล่านั้น ที่อยู่ในสภาพของแข็ง ของเหลว หรือก๊าซ",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลข่าวสาร",
    meaning:
      "สิ่งที่สื่อความหมายให้รู้เรื่องราวข้อเท็จจริง ข้อมูลหรือสิ่งใดๆไม่ว่าการสื่อความหมายนั้น จะทำได้โดย\r\nสภาพของสิ่งนั้นเองหรือโดยผ่านวิธีการใดๆและไม่ว่าจะได้จัดทำไว้ในรูปของเอกสาร แฟ้ม รายงาน หนังสือ แผนผัง แผนที่ ภาพวาด\r\nภาพถ่ายฟิล์ม การบันทึกภาพหรือเสียง การบันทึกโดยเครื่องคอมพิวเตอร์หรือวิธีอื่นใดที่ทำให้สิ่งที่บันทึกไว้ปรากฏได้",
    source:
      "พระราชบัญญัติข้อมูลข่าวสารของราชการ พ.ศ. 2540. (2540, 10 กันยายน) ราชกิจจานุเบกษา. เล่ม 114 ตอนที่ 46 ก หน้าที่ 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2540/A/046/1.PDF",
    sappear: "",
    mappear: "1,10,16,20",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ข"
  },
  {
    keyword: "คนพิการ",
    meaning:
      "บุคคลซึ่งมีข้อจํากัดในการปฏิบัติกิจกรรมในชีวิตประจําวันหรือเข้าไปมีส่วนร่วมทางสังคม เนื่องจากมีความบกพร่องทางการเห็น การได้ยิน การเคลื่อนไหว การ\r\nสื่อสาร จิตใจ อารมณ์พฤติกรรม สติปัญญา การเรียนรู้หรือความบกพร่องอื่นใด ประกอบกับมีอุปสรรคในด้านต่าง ๆ และมีความจําเป็นเป็นพิเศษที่จะต้องได้รับความช่วยเหลือด้านหนึ่งด้านใด\r\nเพื่อให้สามารถปฏิบัติกิจกรรมในชีวิตประจําวันหรือเข้าไปมีส่วนร่วมทางสังคมได้อย่างบุคคลทั่วไปทั้งนี้ตามประเภทและหลักเกณฑ์ที่รัฐมนตรีว่าการกระทรวงการพัฒนาสังคมและความมั่นคงของ\r\nมนุษย์ประกาศกําหนด",
    source:
      "พระราชบัญญัติส่งเสริมและพัฒนาคุณภาพชีวิตคนพิการ พ.ศ. 2550. (2550, 27 กันยายน). ราชกิจจานุเบกษา. เล่ม 124 ตอนท ี่ 61 ก หน้า 9. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/061/8.PDF",
    sappear: "",
    mappear: 17,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ค"
  },
  {
    keyword: "คุณภาพสิ่งแวดล้อม",
    meaning:
      "ดุลยภาพของธรรมชาติ อันได้แก่ สัตว์ พืช\r\nและทรัพยากรธรรมชาติต่าง ๆ และสิ่งที่มนุษย์ได้ทำขึ้น ทั้งนี้ เพื่อประโยชน์ต่อการดำรงชีพของ\r\nประชาชน และความสมบูรณ์สืบไปของมนุษยชาติ",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "ค"
  },
  {
    keyword: "ทนาย",
    meaning: "ผู้ที่สภาทนายความได้รับจดทะเบียนและออกใบอนุญาตให้เป็นทนายความ",
    source:
      "พระราชบัญญัติทนายความ พ.ศ. 2528. (2528, 19 กันยายน). ราชกิจจานุเบกษา. เล่ม 102 ตอนที่ 129 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2528/A/129/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ท"
  },
  {
    keyword: "ทรัพยากรทางทะเลและชายฝั่ง",
    meaning:
      "สิ่งที่มีอยู่หรือเกิดขึ้นตามธรรมชาติในบริเวณทะเล\r\nและชายฝั่ง รวมถึงพรุชายฝั่ง พื้นที่ชุ่มน้ําชายฝั่ง คลอง คูแพรก ทะเลสาบ และบริเวณพื้นที่ปากแม่น้ํา\r\nที่มีพื้นที่ติดต่อกับทะเลหรืออิทธิพลของน้ําทะเลเข้าถึง เช่น ป่าชายเลน ป่าชายหาด หาด ที่ชายทะเล\r\nเกาะ หญ้าทะเล ปะการัง ดอนหอย พืชและสัตว์ทะเล หรือสิ่งที่มนุษย์สร้างขึ้นเพื่อประโยชน์แก่ระบบนิเวศ\r\nทางทะเลและชายฝั่ง เช่น ปะการังเทียม แนวลดแรงคลื่น และการป้องกันการกัดเซาะชายฝั่ง",
    source:
      "พระราชบัญญัติส่งเสริมการบริหารจัดการทรัพยากรทางทะเลและชายฝั่ง พ.ศ. 2558. (2558, 26 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 132 ตอนที่ 21 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/021/49.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ท"
  },
  {
    keyword: "ที่สาธารณะ",
    meaning:
      "สาธารณสมบัติของแผ่นดินนอกจากที่รกร้างว่าง\r\nเปล่า และหมายความรวมถึงถนนและทางน้ําด้วย",
    source:
      "พระราชบัญญัติรักษาความสะอาดและความเป็นระเบียบเรียบร้อยของบ้านเมือง พ.ศ. 2534. (2534, 28 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่มที่109 ตอนที่ 15 หน้า 29. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/015/28.PDF",
    sappear: "",
    mappear: 12,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ท"
  },
  {
    keyword: "ทุจริตต่อหน้าที่",
    meaning:
      "ปฏิบัติหรือละเว้นการปฏิบัติอย่างใดในตําแหน่งหรือหน้าที่ หรือปฏิบัติหรือละเว้นการปฏิบัติอย่างใดในพฤติการณ์ที่อาจทําให้ผู้อื่นเชื่อว่ามีตําแหน่งหรือหน้าที่ ทั้งที่ตนมิได้มีตําแหน่งหรือหน้าที่นั้น หรือใช้อํานาจในตําแหน่งหรือหน้าที่ ทั้งนี้ เพื่อแสวงหาประโยชน์ ที่มิควรได้โดยชอบสําหรับตนเองหรือผู้อื่น หรือกระทําการอันเป็นความผิดต่อตําแหน่งหน้าที่ราชการหรือความผิดต่อตําแหน่งหน้าที่ในการยุติธรรมตามประมวลกฎหมายอาญาหรือตามกฎหมายอื่น",
    source:
      "พระราชบัญญัติประกอบรัฐธรรมนูญว่าด้วยการป้องกันและปราบปรามการทุจริต พ.ศ. 2561. (2561, 21 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 52 ก หน้า 4. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/052/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "กฎหมาย",
    firstalpha: "ท"
  },
  {
    keyword: "ทุพพลภาพ",
    meaning:
      "การสูญเสียอวัยวะหรือสูญเสียสมรรถภาพของอวัยวะหรือของร่างกาย หรือสูญเสียสภาวะปกติของจิตใจ จนทําให้ความสามารถในการทํางานลดลงถึงขนาดไม่อาจประกอบการงานตามปกติได้ ทั้งนี้ ตามหลักเกณฑ์ที่เลขาธิการประกาศกําหนดโดยคําแนะนําของคณะกรรมการการแพทย์",
    source:
      "พระราชบัญญัติประกันสังคม (ฉบับที่ 4) พ.ศ. 2558. (2558, 22 มิถุนายน). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 53 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/053/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    type: "กฎหมาย",
    firstalpha: "ท"
  },
  {
    keyword: "บริการสาธารณสุข",
    meaning:
      "บริการต่าง ๆ อันเกี่ยวกับการสร้างเสริมสุขภาพการป้องกันและควบคุมโรคและปัจจัยที่คุกคามสุขภาพ การตรวจวินิจฉัยและบําบัดสภาวะความเจ็บป่วย และการฟื้นฟูสมรรถภาพของบุคคล ครอบครัวและชุมชน",
    source:
      "พระราชบัญญัติสุขภาพแห่งชาติ พ.ศ. 2550. (2550, 19 มีนาคม). ราชกิจจานุเบกษา. เล่ม 124 ตอนที่ 16 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/016/1.PDF",
    sappear: "",
    mappear: 13,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "บ"
  },
  {
    keyword: "ปฏิบัติการฉุกเฉิน",
    meaning:
      "การปฏิบัติการด้านการแพทย์ฉุกเฉินนับแต่การรับรู้ถึงภาวะการเจ็บป่วยฉุกเฉินจนถึงการดําเนินการให้ผู้ป่วยฉุกเฉินได้รับการบําบัดรักษาให้\r\nพ้นภาวะฉุกเฉินซึ่งรวมถึงการประเมิน การจัดการ การประสานงาน การควบคุม ดูแลการติดต่อสื่อสาร การลําเลียงหรือขนส่งการตรวจวินิจฉัย และการบําบัดรักษาพยาบาลผู้ป่วยฉุกเฉินทั้งนอกสถานพยาบาลและในสถานพยาบาล\r\n",
    source:
      "พระราชบัญญํติการแพทย์ฉุกเฉิน พ.ศ. 2551. (2551, 6 มีนาคม).\r\nราชกิจนาบุเษก. เล่ม 125 ตอนที่ 44 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/044/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    type: "กฎหมาย",
    firstalpha: "ป"
  },
  {
    keyword: "ปฐมวัย",
    meaning:
      "เด็กซึ่งมีอายุต่ำกว่าหกปีบริบูรณ์ และให้ความหมายรวมถึงเด็กซึ่งต้องได้รับการพัฒนาก่อนเข้ารับการศึกษาในระดับปฐมศึกษา",
    source:
      "พระราชบัญญัติการพัฒนาเด็กปฐมวัย พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 หน้า 5. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0005.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ป"
  },
  {
    keyword: "ประมวลจริยธรรม",
    meaning:
      "ให้ข้าราชการทั้งหลายเกิดสำนึกลึกซึ้งและเที่ยงธรรมในหน้าที่ ผดุงเกียรติและศักดิ์ศรีข้าราชการควรแก่ความไว้วางใจและเชื่อมั่นของปวงชน และดำรงตนตั้งมั่นเป็นแบบอย่างที่ดีงาม สมกับความเป็นข้าราชการ",
    source:
      "ประมวลจริยธรรมข้าราชการพลเรือน. (2552, 5 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 126 ตอนพิเศษ 162 ง หน้า 74. http://www.ratchakitcha.soc.go.th/DATA/PDF/2552/E/162/73.PDF",
    sappear: 6,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ป"
  },
  {
    keyword: "ผลประโยชน์ของชาติทางทะเล",
    meaning:
      "ผลประโยชน์ของประเทศไทยอันพึงได้รับจากกิจกรรมทางทะเล หรือประโยชน์อื่นใดในเขตทางทะเล ไม่ว่าโดยตรงหรือโดยอ้อม เพื่อให้เกิดประโยชน์ในทุก ๆ ด้าน เช่น ด้านความมั่นคง ด้านเศรษฐกิจ ด้านสังคม ด้านวิทยาศาสตร์และเทคโนโลยี ด้านทรัพยากร หรือด้านสิ่งแวดล้อม",
    source:
      "พระราชบัญญัติการรักษาผลประโยชน์ของชาติทางทะเล พ.ศ. 2562. (2562). ผลประโยชน์ของชาติทางทะเล, 7 ตุลาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/030/T_0001.PDF",
    sappear: 1,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้เสียหาย",
    meaning:
      "บุคคลซึ่งได้รับความเสียหายถึงแก่ชีวิตหรือร่างกายหรือจิตใจเนื่องจากการกระทำความผิดอาญาของผู้อื่น โดยตนมิได้มีส่วนเกี่ยวข้องกับการกระทำความผิดนั้น",
    source:
      "พระราชบัญญัติค่าตอบแทนผู้เสียหายและค่าทดแทนและค่าใช้จ่ายแก่จำเลยในคดีอาญา\r\nพ.ศ. 2544. (2544, 31 ตุลาคม). มาตรา 3. http://web.krisdika.go.th/lawHeadContent.jsp?fromPage=lawHeadContent&formatFile=htm&hID=0",
    sappear: "",
    mappear: 1,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ชี้เบาะแส",
    meaning:
      "บุคคลซึ่งมิได้เป็นเจ้าหน้าที่ของสำนักงาน ที่ชี้เบาะแสเกี่ยวกับการกระทำการอันไม่สุจริตหรือเที่ยงธรรม",
    source:
      "ระเบียบคณะกรรมการการเลือกตั้งว่าด้วยค่าใช้จ่ายในการแสวงหาข้อมูลข่าวสารและการให้รางวัลแก่ผู้ชี้เบาะแสการกระทำการอันไม่สุจริตหรือเที่ยงธรรมในการเลือกตั้ง พ.ศ. 2562. (2562, 22 มีนาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 37 ก หน้า 7. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/037/T_0006.PDF",
    sappear: "",
    mappear: 21,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ตรวจราชการของรัฐ",
    meaning:
      "ผู้ตรวจราชการสํานักนายกรัฐมนตรีผู้ตรวจ ราชการกระทรวง ผู้ตรวจราชการกรม หรือผู้ดํารงตําแหน่งที่เรียกชื่ออย่างอื่นที่มีหน้าที่ในการตรวจราชการแต่ไม่รวมถึงผู้ทําหน้าที่ตรวจสอบภายใน",
    source:
      "ระเบียบสํานักนายกรัฐมนตรีว่าด้วยการตรวจราชการ พ.ศ. 2548. (2548, 5 กันยายน). ราชกิจจานุเบกษา. เล่ม 122 ตอนพิเศษ 76 ง หน้า 7. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2548/00169842.PDF",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ถูกคุมความประพฤติ",
    meaning:
      "ผู้ต้องหา จําเลย นักโทษเด็ดขาด หรือบุคคลอื่นที่ศาลหรือเจ้าพนักงานผู้มีอํานาจ กําหนดให้ปฏิบัติตามเงื่อนไขที่กฎหมายบัญญัติภายใต้การคุมความประพฤติของพนักงานคุมประพฤติ\r\n",
    source:
      "พระราชบัญญัติคุมประพฤติ พ.ศ. 2559. (2559, 3 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 88 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/088/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ป่วยฉุกเฉิน",
    meaning:
      "บุคคลซึ่งได้รับบาดเจ็บหรือมีอาการป่วยกะทันหัน ซึ่งเป็น\r\nภยันตรายต่ออการดํารงชีวิตหรือการทํางานของอวัยวะสําคัญ จําเป็น\r\nต้องได้รับการประเมิน การจัดการและการบําบัดรักษาอย่างทันท่วงทีเพื่อป้องกันการเสียชีวิตหรือการรุนแรงขึ้นของการบาดเจ็บหรืออาการป่วยนั้น",
    source:
      "พระราชบัญญัติการแพทย์ฉุกเฉิน พ.ศ. 2551. (2551, 6 มีนาคม.). ราชกิจนาบุเษก.เล่ม 125 ตอนที่ 44 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/044/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้หลบหนีเข้าเมือง",
    meaning: "คนต่างด้าวซึ่งเข้ามาในราชอาณาจักร",
    source:
      "พระราชบัญญัติคนเข้าเมืองพุทธศักราช 2522. (2522, กุมภาพันธ์ 24). http://web.krisdika.go.th/data/law/law2/%A402/%A402-20-9999-update.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "พยาน",
    meaning:
      "พยานบุคคลซึ่งจะมาให้หรือได้ให้ข้อเท็จจริง ต่อพนักงานผู้มีอำนาจสืบสวนคดีอาญา พนักงานผู้มีอำนาจสอบสวนคดีอาญา พนักงานผู้มีอำนาจฟ้องคดีอาญา หรือศาลในการดำเนินคดี\r\nอาญา รวมทั้งผู้ชำนาญการพิเศษ แต่มิให้หมายความรวมถึงจำเลยที่อ้างตนเอง เป็นพยาน",
    source:
      "พระราชบัญญัติคุ้มครองพยานในคดีอาญา พ.ศ. 2546 . (2546, 20 มิถุนายน). ราชกิจจานุเบกษา. เล่ม 120 ตอน 58 ก หน้า 4.  http://www.ratchakitcha.soc.go.th/DATA/PDF/00124899.PDF",
    sappear: "",
    mappear: 21,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานหมุนเวียน",
    meaning:
      "พลังงานที่ได้จากไม้ ฝืน แกลบ กาก อ้อย ชีวมวล น้ำ แสงอาทิตย์ ความร้อนใต้พิภพ ลม และคลื่น",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษษ์พลังงาน พ.ศ. 2535, (2535, 2 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 33 หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF ",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "พ"
  },
  {
    keyword: "ภัยคุกคาม",
    meaning:
      "ภาวะหรือสถานการณ์ที่ก่อให้เกิดความไม่มั่นคงซึ่งเป็นปัญหาที่มีความรุนแรง สลับซับซ้อน หากไม่ดำเนินการแก้ไขจะเกิดผลกระทบในวงกว้างต่อความมั่นคงแห่งชาติ",
    source:
      "พระราชบัญญัติสภาความมั่นคงแห่งชาติ พ.ศ. 2559. (2559, 26 กันยายน). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 85 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/085/1.PDF",
    sappear: 1,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ภ"
  },
  {
    keyword: "มาตรฐานการวิจัย",
    meaning:
      "ข้อกำหนดเกี่ยวกับคุณลักษณะและคุณภาพที่พึงประสงค์\r\nของการวิจัยและนวัตกรรมที่ต้องการให้เกิดขึ้นในทุกกระบวนการของการวิจัยและนวัตกรรมอย่างเป็นระบบและสอดคล้องกับมาตรฐานสากล ทั้งนี้ รวมถึงจริยธรรมที่นักวิจัยพึงปฏิบัติด้วย",
    source:
      "พระราชบัญญัติการส่งเสริมวิทยาศาสตร์ การวิจัยและนวัตกรรม พ.ศ. 2562. (2562, 25 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 68 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/068/T_0001.PDF",
    sappear: "",
    mappear: 23,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐานการศึกษา",
    meaning:
      "ข้อกำหนดเกี่ยวกับคุณลักษณะ คุณภาพ ที่พึงประสงค์\r\nและมาตรฐานที่ต้องการให้เกิดขึ้นในสถานศึกษาทุกแห่ง และเพื่อใช้เป็นหลักในการเทียบเคียงสำหรับ\r\nการส่งเสริมและกำกับดูแล การตรวจสอบ การประเมินผลและการประกันคุณภาพทางการศึกษา",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา เล่ม 113 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF   ",
    sappear: "",
    mappear: "",
    rappear: 12,
    type: "กฎหมาย",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐานสินค้า",
    meaning:
      "คุณภาพ ชั้น ประเภท หรือชนิดของสินค้ามาตรฐานที่กำหนดขึ้นโดยใช้ปริมาณ หน่วย น้ำหนัก ปริมาตร ขนาด ส่วนผสม ส่วนประกอบ ส่วนสัด สี ตัวอย่าง และอื่น ๆ ทั้งนี้แต่อย่างใดอย่างหนึ่งหรือหลายอย่างเป็นเกณฑ์รวมตลอดถึงวิธีการบรรจุ หุ้มห่อ หรือผูกมัด และวัตถุที่ใช้ในการนั้นด้วย",
    source:
      "พระราชบัญญัติมาตรฐานสินค้าขาออก (ฉบับที่ 2)  พ.ศ. 2522. (2522, 9 พฤษภาคม). ราชกิจจานุเบกษา. เล่มที่ 96 ตอนที่ 74 หน้า 15.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/074/14.PDF ",
    sappear: "",
    mappear: 3,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรวิทยา",
    meaning:
      "ศาสตร์เกี่ยวกับการวัดปริมาณและการประยุกต์ใช้ศาสตร์นั้น และให้หมายความรวมถึงกิจกรรมทางวิทยาศาสตร์ที่เกี่ยวกับการสอบเทียบ ปรับตั้งความถูกต้องของเครื่องมือและอุปกรณ์ที่ใช้ในการวัดปริมาณหรือวิเคราะห์ทดสอบ",
    source:
      "พระราชบัญญัติพัฒนาระบบมาตรวิทยาแห่งชาติ (ฉบับที่ 2) พ.ศ. 2559. (2559, 5 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 67 ก หน้า 51. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/067/51.PDF",
    sappear: "",
    mappear: 8,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ม"
  },
  {
    keyword: "มูลฝอย",
    meaning:
      "เศษกระดาษ เศษผ้า เศษอาหาร เศษสินค้า\r\nถุงพลาสติก ภาชนะที่ใส่อาหาร เถ้า มูลสัตว์หรือซากสัตว์รวมตลอดถึงสิ่งอื่นใดที่เก็บกวาดจาก\r\nถนน ตลาด ที่เลี้ยงสัตว์หรือที่อื่น",
    source:
      "พระราชบัญญัติรักษาความสะอาดและความเป็นระเบียบเรียบร้อยของบ้านเมือง พ.ศ. 2534. (2534, 28 กุมภาพันธ์). เล่มที่ 109 ตอนที่ 15 หน้า 29. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/015/28.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ม"
  },
  {
    keyword: "มูลฝอยติดเชื้อ",
    meaning:
      "มูลฝอยที่มีเชื้อโรคปะปนอยู่ในปริมาณหรือมีความเข้มข้นซึ่งถ้ามีการสัมผัสหรือใกล้ชิดกับมูลฝอยนั้นแล้วสามารถทำให้เกิดดรคได้",
    source:
      "กฎกระทรวงว่าด้วยการกำจัดมูลฝอยติดเชื้อ พ.ศ. 2545. (2545, 5 กันยายน). ราชกิจจานุเบกษา. เล่ม 119 ตอนที่ 86 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/00099809.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ม"
  },
  {
    keyword: "ระบบการเรียนรู้ตลอดชีวิต",
    meaning:
      "การศึกษาที่เกิดจากการผสมผสานระหว่างการศึกษาในระบบ การศึกษานอกระบบและการศึกษาตามอัธยาศัย เพื่อให้สามารถพัฒนาคุณภาพชีวิตได้อย่างต่อเนื่องตลอดชีวิต",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบบริการปฐมภูมิ",
    meaning:
      "บริการทางการแพทย์และสาธารณสุขที่มุ่งหมาย\r\nดูแลสุขภาพของบุคคลในเขตพื้นที่รับผิดชอบในลักษณะองค์รวม ตั้งแต่แรก ต่อเนื่อง และผสมผสานครอบคลุมทั้งการส่งเสริมสุขภาพ \r\nการควบคุมโรค การป้องกันโรค การตรวจวินิจฉัยโรค การรักษาพยาบาลและการฟื้นฟูสุขภาพ โดยหน่วยบริการปฐมภูมิหรือเครือข่ายหน่วยบริการปฐมภูมิที่ประกอบด้วยแพทย์ เวชศาสตร์ครอบครัวและคณะผู้ให้บริการสุขภาพปฐมภูมิ รวมทั้งเชื่อมโยงกับครอบครัว ชุมชนและบริการทางการแพทย์และสาธารณสุขระดับ\r\nทุติยภูมิและตติยภูม",
    source:
      "พระราชบัญญัติระบบสุขภาพปฐมภูมิ พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก หน้า 165-185.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0165.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    type: "กฎหมาย",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบบริหารจัดการศึกษา",
    meaning:
      "กระทรวงมีอำนาจหน้าที่เกี่ยวกับการส่งเสริม และกำกับดูแลการศึกษาทุกระดับและทุกประเภท กำหนดนโยบาย แผน และมาตรฐานการศึกษา สนับสนุนทรัพยากรเพื่อการศึกษา ส่งเสริมและประสานงานการศาสนา ศิลปะ วัฒนธรรม และการกีฬาเพื่อการศึกษา รวมทั้งการติดตาม ตรวจสอบ และประเมินผลการจัดการศึกษาและราชการอื่นตามที่มีกฎหมายกำหนดให้เป็นอำนาจหน้าที่ของกระทรวงหรือส่วนราชการที่สังกัดกระทรวง",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 74 ก หน้า 9. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสุขภาพปฐมภูมิ",
    meaning:
      "กลไกและกระบวนการในการประสานความร่วมมือ\r\nเพื่อจัดบริการสุขภาพปฐมภูมิ โดยการมีส่วนร่วมระหว่างภาครัฐ องค์กรปกครองส่วนท้องถิ่น ภาคเอกชน\r\nและภาคประชาชน รวมทั้งการส่งต่อผู้รับบริการและการเชื่อมโยงข้อมูลระหว่างหน่วยบริการทั้งระดับ\r\nปฐมภูมิ ทุติยภูมิ และตติยภูมิ ",
    source:
      "พระราชบัญญํติระบบสุขภาพปฐมภูมิ พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจาบุเษก. เล่ม 136 ตอนที่ 56 ก หน้า 166.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0165.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    type: "กฎหมาย",
    firstalpha: "ร"
  },
  {
    keyword: "วัฒนธรรม",
    meaning:
      "วิถีการดําเนินชีวิต ความคิด ความเชื่อ คานิยม จารีตประเพณีพิธีกรรม และภูมิปญญา ซึ่งกลุมชนและสังคมได  รวมสรางสรรค สั่งสม ปลูกฝง สืบทอด เรียนรูปรับปรุง และเปลี่ยนแปลง เพื่อใหเกิดความเจริญงอกงาม ทั้งด้านจิตใจและวัตถุ อยางสันติสุขและยั่งยืน",
    source:
      "พระราชบัญญัติวัฒนธรรมแห่งชาติ พ.ศ. 2553. (2553, 12 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 127 ตอนที่ 69 ก หน้า 30. http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/A/069/29.PDF",
    sappear: 5,
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ว"
  },
  {
    keyword: "วัตถุอันตราย",
    meaning:
      "วัตถุระเบิดได้ วัตถุไวไฟ วัตถุออกซิไดซ์ และวัตถุ\r\nเปอร์ออกไซด์ วัตถุมีพิษ วัตถุที่ทำให้เกิดโรค วัตถุกัมมันตรังสี วัตถุที่ก่อให้เกิดการเปลี่ยนแปลงทาง\r\nพันธุกรรม วัตถุกัดกร่อน วัตถุที่ก่อให้เกิดการระคายเคือง วัตถุอย่างอื่นไม่ว่าจะเป็นเคมีภัณฑ์ หรือสิ่ง\r\nอื่นใดที่อาจทำให้เกิดอันตรายแก่บุคคล สัตว์ พืช ทรัพย์ หรือสิ่งแวดล้อม",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 3.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "ว"
  },
  {
    keyword: "ศัตรูพืช",
    meaning:
      "หมายความว่า สิ่งซึ่งเป็นอันตรายแก่พืช เช่น เชื้อโรคพืช แมลง สัตว์ หรือพืชที่อาจก่อให้เกิดความเสียหายแก่พืช",
    source:
      "พระราชบัญญัติกักพืช พ.ศ. 2507. (2507, 21 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 81 ตอนที่ 27 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2507/A/027/1.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ศ"
  },
  {
    keyword: "ศาลชํานัญพิเศษ",
    meaning:
      "1. ศาลทรัพย์สินทางปัญญาและการค้าระหว่างประเทศตามกฎหมายว่าด้วยการจัดตั้งศาลทรัพย์สินทางปัญญาและการค้าระหว่างประเทศและวิธีการพิจารณาคดีทรัพย์สินทางปัญญาและการค้าระหว่างประเทศ\r\n2. ศาลภาษีอากรตามกฎหมายว่าด้วยการจัดตั้งศาลภาษีอากรและวิธีพิจารณาคดีภาษีอากร\r\n3. ศาลแรงงานตามกฎหมายว่าด้วยการจัดตั้งศาลแรงงานและวิธีพิจารณาคดีแรงงาน\r\n4. ศาลล้มละลายตามกฎหมายว่าด้วยการจัดตั้งศาลแรงงานและวิธีพิจารณาคดีล้มละลาย\r\n5. ศาลเยาวชนและครอบครัวตามกฎหมายว่าด้วยศาลเยาวชนและครอบครัวและวิธีพิจารณาคดีเยาวชนและครอบครัว",
    source:
      "พระราชบัญญัติจัดตั้งศาลอุทธรณ์คดีชำนาญพิเศษ พ.ศ. 2558. (2558, 14 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 120 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/120/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "กฎหมาย",
    firstalpha: "ศ"
  },
  {
    keyword: "สถานการณ์ฉุกเฉิน",
    meaning:
      "สถานการณ์อันกระทบหรืออาจกระทบต่อ\r\nความสงบเรียบร้อยของประชาชนหรือเป็นภัยต่อความมั่นคงของรัฐหรืออาจทําให้ประเทศหรือส่วนใด\r\nส่วนหนึ่งของประเทศตกอยู่ในภาวะคับขันหรือมีการกระทําความผิดเกี่ยวกับการก่อการร้ายตามประมวลกฎหมายอาญา การรบหรือการสงคราม ซึ่งจําเป็นต้องมีมาตรการเร่งด่วนเพื่อรักษาไว้ซึ่งการ\r\nปกครองระบอบประชาธิปไตยอันมีพระมหากษัตริย์ทรงเป็นประมุขตามรัฐธรรมนูญแห่งราชอาณาจักร\r\nไทย เอกราชและบูรณภาพแห่งอาณาเขต ผลประโยชน์ของชาติการปฏิบัติตามกฎหมาย ความ\r\nปลอดภัยของประชาชน การดํารงชีวิตโดยปกติสุขของประชาชน การคุ้มครองสิทธิเสรีภาพ ความสงบ\r\nเรียบร้อยหรือประโยชน์ส่วนรวม หรือการป้องปัดหรือแก้ไขเยียวยาความเสียหายจากภัยพิบัติ\r\nสาธารณะอันมีมาอย่างฉุกเฉินและร้ายแรง",
    source:
      "พระราชกำหนดการบริหารราชการในสถานการณ์ฉุกเฉิน พ.ศ. 2548. (2548, 16 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 122 ตอนที่ 58 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2548/00166932.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันการเงินประชาชน",
    meaning:
      "องค์กรการเงินชุมชนซึ่งได้จดทะเบียนเป็นสถาบันการเงินประชาชนตามพระราชบัญญัติ",
    source:
      "พระราชบัญญัติสถาบันการเงินประชาชน พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก หน้า 46. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0045.PDF",
    sappear: "",
    mappear: "",
    rappear: 9,
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สัญญาการซื้อขายไฟฟ้า (Power Purchasing Agreement:PPA)",
    meaning:
      "ข้อตกลงเป็นลายลักษณ์อักษรเพื่อซื้อขายไฟฟ้าระหว่างผู้ผลิตไฟฟ้าขนาดเล็กมากกับการไฟฟ้าฝ่ายจําหน่าย \r\n1. ให้ผู้ยื่นขอผลิตไฟฟ้าขนาดเล็กมากที่ผ่านการคัดเลือกทําสัญญาซื้อขายไฟฟ้ากับการไฟฟ้าฝ่ายจําหน่ายตามแบบสัญญาซื้อขายไฟฟ้าที่การไฟฟ้าฝ่ายจําหน่ายกําหนด โดยความเห็นชอบของ กกพ. \r\n2. ห้ามผู้ผลิตไฟฟ้าขนาดเล็กมากโอนสิทธิและหน้าที่ตามคําเสนอขอขายไฟฟ้าหรือในสัญญาซื้อขายไฟฟ้าให้กับผู้อื่น เว้นแต่จะได้รับการยินยอมจากการไฟฟ้าฝ่ายจําหน่ายตามหลักเกณฑ์ของการไฟฟ้าฝ่ายจําหน่ายที่ได้รับความเห็นชอบจาก กกพ. ",
    source:
      "ระเบียบคณะกรรมการกํากับกิจการพลังงานว่าด้วยการจัดหาไฟฟ้าจากผู้ผลิตไฟฟ้าขนาดเล็กมากโครงการผลิตไฟฟ้าจากพลังงานหมุนเวียน พ.ศ. 2561. (2561, 9 มีนาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนพิเศษ 54 ง หน้า 16. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/E/054/15.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สิ่งแวดล้อม",
    meaning:
      "สิ่งต่าง ๆ ที่มีลักษณะทางกายภาพและชีวภาพที่อยู่รอบตัวมนุษย์ซึ่งเกิดขึ้นโดยธรรมชาติและสิ่งที่มนุษย์ได้ทําขึ้น",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สินค้าเกษตร",
    meaning:
      "ผลิตผลหรือผลิตภัณฑ์อันเกิดจากการกสิกรรม การประมง การปศุสัตว์ หรือการป่าไม้ และผลพลอยได้\r\nของผลิตผลหรือผลิตภัณฑ์ดังกล่าว",
    source:
      "พระราชบัญญัติมาตรฐานสินค้าเกษตร พ.ศ. 2551. (2551, 22 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 125 ตอนที่ 37 ก หน้า 2 .http://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/037/1.PDF",
    sappear: "",
    mappear: 3,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สื่อปลอดภัยและสร้างสรรค์",
    meaning:
      "สื่อที่มีเนื้อหาส่งเสริมศีลธรรม จริยธรรม วัฒนธรรมและความมั่นคง ส่งเสริมความคิดสร้างสรรค์ การเรียนรู้ทักษะการใช้ชีวิตของประชาชนโโยเฉพาะเด็กและเยาวชน และส่งเสริมความสัมพันธ์ที่ดีในครอบครัวและสังคม รวมถึงการส่งเสริมให้ประชาชนมีความสามัคคีและสามารถใช้ชีวิตในสังคมที่มีความหลากหลายได้อย่างเป็นสุข",
    source:
      "พระราชบัญญัติกองทุนพัฒนาสื่อปลอดภัยและสร้างสรรค์ พ.ศ. 2558. (2558, 26 มีนาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 21 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/021/30.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "หนี้สาธารณะ",
    meaning:
      "หนี้ที่กระทรวงการคลัง หน่วยงานของรัฐ หรือรัฐวิสาหกิจกู้ หรือหนี้ที่กระทรวงการคลังค้ําประกัน แต่ไม่รวมถึงหนี้ของรัฐวิสาหกิจที่ทําธุรกิจให้กู้ยืมเงินธุรกิจบริหารสินทรัพย์ หรือธุรกิจประกันสินเชื่อ โดยกระทรวงการคลังไม่ได้ค้ําประกัน และ\r\nหนี้ของธนาคารแห่งประเทศไทย",
    source:
      "พระราชบัญญัติการบริหารหนี้สาธารณะ (ฉบับที่ 3) พ.ศ. 2560. (2560, 27 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 131 ก หน้า 32. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/131/31.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ห"
  },
  {
    keyword: "อนุรักษ์พลังงาน",
    meaning: "ผลิตและใช้พลังงานอย่างมีประสิทธิภาพและประหยัด",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน 2535. (2535, 2 เมษายน). ราชกิจานุเบกษา. เล่ม 109 ตอน 33 หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "เกษตรพันธสัญญา",
    meaning:
      "ระบบการผลิตผลิตผลหรือบริการทางการเกษตรที่เกิดขึ้นจากสัญญา\r\nการผลิตผลิตผลหรือบริการทางการเกษตรประเภทเดียวกันระหว่าง\r\nผู้ประกอบธุรกิจ ทางการเกษตรฝ่ายหนึ่งกับบุคคลธรรมดาซึ่งประกอบอาชีพเกษตรกรรมตั้งแต่สิบรายขึ้นไป หรือกับสหกรณ์การเกษตรหรือ\r\nกลุ่มเกษตรกรตามกฎหมายว่าด้วยสหกรณ์ หรือกับวิสาหกิจชุมชนหรือเครือข่ายวิสาหกิจชุมชนตามกฎหมายว่าด้วยการส่งเสริมวิสาหกิจชุมชนซึ่งประกอบอาชีพเกษตรกรรมอีกฝ่ายหนึ่งที่มีเงื่อนไขในการผลิต จําหน่าย หรือจ้างผลิตผลิตผลหรือบริการทางการเกษตรอย่างหนึ่งอย่างใด \r\nโดยเกษตรกรตกลงที่จะผลิต จําหน่าย หรือรับจ้างผลิตผลิตผลทางการเกษตรตามจํานวน คุณภาพ ราคา หรือระยะเวลาที่กําหนดไว้ และ\r\nผู้ประกอบธุรกิจทางการเกษตรตกลงที่จะซื้อผลิตผลดังกล่าวหรือ\r\nจ่ายค่าตอบแทนตามที่กําหนดไว้ตามสัญญา โดยผู้ประกอบธุรกิจทางการเกษตรเข้าไปมีส่วนในกระบวนการผลิตเช่น เป็นผู้กําหนดวิธีการผลิต จัดหาพันธุ์ เมล็ดพันธุ์ ผลิตภัณฑ์ทางการเกษตร หรือปัจจัยการผลิตให้แก่เกษตรกร",
    source:
      "พระราชบัญญัติส่งเสริมและพัฒนาระบบเกษตรพันธสัญญา พ.ศ. 2560 (2560, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 131. หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/056/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "เงินบำนาญ",
    meaning:
      "เงินที่จ่ายให้แก่สมาชิกเป็นรายเดือนเมื่อสมาชิกภาพของสมาชิกสิ้นสุดลง",
    source:
      "พระราชบัญญัติกองทุนบำเหน็จบำนาญข้าราชการ พ.ศ. 2539 (2539, 26 กันยายน). ราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 42 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2539/A/042/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ง"
  },
  {
    keyword: "โทษปรับทางอาญา",
    meaning:
      "โทษปรับทางอาญา จะต้องชำระเงินตามจำนวนที่กำหนดไว้ในคำพิพากษาต่อศาล",
    source:
      "พระราชบัญญัติให้ใช้ประมวลกฎหมายอาญา พ.ศ. 2499 (13 พฤศจิกายน 2499). มาตรา 28. http://www.krisdika.go.th/librarian/get?sysid=772817&ext=html",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "กฎหมาย",
    firstalpha: "ท"
  },
  {
    keyword: "โทษอาญา",
    meaning:
      "โทษสำหรับลงแก่ผู้กระทำความผิด มีดังนี้\r\n1. ประหารชีวิต\r\n2. จำคุก\r\n3. กักขัง\r\n4. ปรับ\r\n5. ริบทรัพย์สิน",
    source:
      "พระราชบัญญัติให้ใช้ประมวลกฎหมายอาญา พ.ศ. 2499 (13 พฤศจิกายน 2499). มาตรา 18 .http://www.krisdika.go.th/librarian/get?sysid=772817&ext=html",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "กฎหมาย",
    firstalpha: "ท"
  },
  {
    keyword: "ป่าชุมชน",
    meaning:
      "ป่านอกเขตป่าอนุรักษ์หรือพื้นที่อื่นของรัฐนอกเขตป่าอนุรักษ์ ที่ได้รับอนุมัติให้จัดตั้งเป็นป่าชุมชน โดยชุมชนร่วมกับรัฐในการอนุรักษ์ ฟื้นฟูจัดการบำรุงรักษา ตลอดจนใช้ประโยชน์จากทรัพยากรธรรมชาติ สิ่งแวดล้อม และความหลากหลายทางชีวภาพในป่าชุมชน อย่างสมดุลและยั่งยืน",
    source:
      "พระราชบัญญัติป่าชุมชน พ.ศ. 2562 (29 พฤษภาคม 2562). ราชกิจจานุเบกษา เล่ม 136 ตอนที่ 71 ก หน้า 72. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0071.PDF",
    sappear: 5,
    mappear: 18,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ป"
  },
  {
    keyword: "พยานหลักฐาน",
    meaning:
      "พยานวัตถุ พยานเอกสาร หรือพยานบุคคลซึ่งน่าจะพิสูจน์ได้ว่าจำเลยมีผิดหรือบริสุทธิ์ ให้อ้างเป็นพยานหลักฐานได้ แต่ต้องเป็นพยานชนิดที่มิได้เกิดขึ้นจากการจูงใจ มีคำมั่นสัญญา ขู่เข็ญ หลอกลวงหรือโดยมิชอบประการอื่น ",
    source:
      "พระราชบัญญัติให้ใช้ประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477. (2477, 7 มีนาคม 2477). มาตรา 226 หน้า 74. http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: 22,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "พ"
  },
  {
    keyword: "สวนพฤกษศาสตร์",
    meaning:
      "พื้นที่ที่มีการจัดรวบรวมพรรณไม้ โดยมีการจัดแยกพรรณไม้ออกเป็นหมวดหมู่ตามหลักพฤกษศาสตร์หรือตามหลักอนุกรมวิธานพืชเพื่อให้เป็นแหล่งอนุรักษ์ความหลากหลายทางชีวภาพ เป็นสถานที่ศึกษาค้นคว้าวิจัยทางวิชาการ และใช้เป็นสถานที่พักผ่อนหย่อนใจของประชาชน",
    source:
      "พระราชบัญญัติอุทยานแห่งชาติ พ.ศ. 2562 (2562, 29 พฤษภาคม 2562). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 71 ก หน้า 146.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0145.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิบัตร",
    meaning:
      "หนังสือสำคัญที่ออกให้เพื่อคุ้มครองการประดิษฐ์ หรือการออกแบบผลิตภัณฑ์ ",
    source:
      "พระราชบัญญัติสิทธิบัตร 2522 (2522, 16 มีนาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 35. หน้า 2 http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/035/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "หน่วยงานของรัฐ",
    meaning:
      "หมายความว่า หน่วยงานที่เป็นของรัฐไม่ว่าจะเป็นส่วนราชการ รัฐวิสาหกิจ องค์การมหาชน หรือในรูปแบบอื่นใด และไม่ว่าจะเป็นองค์กรในฝ่ายบริหาร ฝ่ายนิติบัญญัติ ฝ่ายตุลาการหรือเป็นองค์กรอิสระหรือองค์กรอัยการ",
    source:
      "พระราชบัญญัติการจัดทำยุทธศาสตร์ชาติ พ.ศ. 2560 (2560, 31 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 79 ก หน้า 1.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/079/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "กฎหมาย",
    firstalpha: "ห"
  },
  {
    keyword: "องค์กรอิสระ",
    meaning:
      "องค์กรอิสระเป็นองค์กรที่จัดตั้งขึ้นให้มีความอิสระในการปฏิบัติหน้าที่ ให้เป็นไปตามรัฐธรรมนูญและกฎหมายการปฏิบัติหน้าที่และการใช้อํานาจขององค์กรอิสระต้องเป็นไปโดยสุจริต เที่ยงธรรม กล้าหาญและปราศจากอคติทั้งปวงในการใช้ดุลพินิจ",
    source:
      "รัฐธรรมนูญแห่งราชอาณาจักรไทย พ.ศ. 2560 (2560, 6 เมษายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 40 ก หน้า 62.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/040/1.PDF",
    sappear: 6,
    mappear: 20,
    rappear: 1,
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "องค์การมหาชน",
    meaning:
      "องค์การมหาชนที่จัดตั้งขึ้นโดยพระราชกฤษฎีกาที่ออกตามความในพระราชบัญญัติองค์การมหาชน พ.ศ. 2542 โดยรัฐบาลมีแผนงานหรือนโยบายด้านใดด้านหนึ่งโดยเฉพาะเพื่อจัดทำบริการสาธารณะ และมีความมุ่งหมายให้มีการใช้ประโยชน์ทรัพยากรและบุคลากรให้เกิดประสิทธิภาพสูงสุด",
    source:
      "พระราชบัญญัติองค์การมหาชน พ.ศ. 2542 (2542, 24 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 9 ก. หน้า 5.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/009/5.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: "1,2",
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "อาชญากรรมทางไซเบอร์ในโลกดิจิทัล",
    meaning:
      "การก่อภัยคุกคามทางไซเบอร์ ซึ่งเป็นการกระทำหรือการดำเนินการใด ๆ โดยมิชอบโดยใช้คอมพิวเตอร์หรือระบบคอมพิวเตอร์หรือโปรแกรมไม่พึงประสงค์โดยมุ่งหมายให้เกิดการประทุษร้ายต่อระบบคอมพิวเตอร์ ข้อมูลคอมพิวเตอร์ หรือข้อมูลอื่นที่เกี่ยวข้อง ",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงปลอดภัยไซเบอร์ พ.ศ. 2562 (2562, 27 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 69 ก. หน้า 21. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0020.PDF\r\n \r\n",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "อาชญาบัตร",
    meaning: "ใบอนุญาตซึ่งพนักงานเจ้าหน้าที่ออกให้แก่ผู้รับอนุญาต",
    source:
      "พระราชบัญญัติการประมง พ.ศ. 2490. (27 เมษายน 2552). มาตรา 4 (10).\r\nhttp://web.krisdika.go.th/data/law/law2/%A125/%A125-20-9999-update.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "EIA",
    meaning:
      "หรือ Environmental Impact Assessment หมายถึง การประเมินผลกระทบสิ่งแวดล้อม ซึ่งเป็นกระบวนการศึกษาและประเมินผลที่อาจเกิดขึ้นจากการดําเนินโครงการหรือกิจการหรือการดําเนินการใดของรัฐหรือที่รัฐจะอนุญาตให้มีการดําเนินการที่อาจมีผลกระทบต่อทรัพยากรธรรมชาติ คุณภาพสิ่งแวดล้อม สุขภาพ อนามัย คุณภาพชีวิตหรือส่วนได้เสียอื่นใดของประชาชนหรือชุมชน ทั้งทางตรงและทางอ้อม โดยผ่านกระบวนการการมีส่วนร่วมของประชาชน เพื่อกําหนดมาตรการป้องกันแก้ไขผลกระทบดังกล่าว ผลการศึกษาเรียกว่า รายงานการประเมินผลกระทบสิ่งแวดล้อม",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ (ฉบับที่ 2) พ.ศ. 2561 (2561, 19 เมษายน). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 27 ก หน้า 30.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/027/29.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: ""
  },
  {
    keyword: "เทคโนโลยีอวกาศ",
    meaning: "เทคโนโลยีที่พัฒนาเพื่อใช้ประโยชน์จากอวกาศ",
    source:
      "พระราชกฤษฎีกาจัดตั้งสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ(องค์การมหาชน) (ฉบับที่ 2) พ.ศ. 2562) (2562,31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 72 ก หน้า 104. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0103.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "กฎหมาย",
    firstalpha: "ท"
  },
  {
    keyword: "ข้อมูลทะเบียนราษฎร",
    meaning:
      "ข้อมูลตัวบุคคลเกี่ยวกับชื่อ ชื่อสกุล เพศ วันเดือนปีเกิดและตาย สัญชาติ ศาสนา ภูมิลำเนา สถานะ การสมรส วุฒิการศึกษา ชื่อบิดามารดาหรือผู้รับบุตรบุญธรรม ชื่อคู่สมรส และชื่อบุตร และข้อมูลอื่นที่จำเป็นเพื่อการดำเนินงานทะเบียนต่าง ๆ ",
    source:
      "พระราชบัญญัติการทะเบียนราษฎร พ.ศ. 2534. (2534, 22 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 108 ตอนที่ 203 หน้า 98. http://www.ratchakitcha.soc.go.th/DATA/PDF/2534/A/203/97.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "กฎหมาย",
    firstalpha: "ข"
  },
  {
    keyword: "ความหลากหลายทางชีวภาพ",
    meaning:
      "ความหลากหลายของสิ่งมีชีวิตทั้งมวล และให้หมายความรวมถึงความหลากหลายทางพันธุกรรม ทางชนิดพันธุ์ และทางระบบนิเวศอันเป็นถิ่นกำเนิดของสิ่งมีชีวิตเหล่านั้น",
    source:
      "พระราชบัญญัติป่าชุมชน พ.ศ. 2562 (2562, 29 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 71 ก หน้า 73.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0071.PDF",
    sappear: "2,4,5",
    mappear: "3,4,18,19,23",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "ค"
  },
  {
    keyword: "ผู้ด้อยโอกาส",
    meaning:
      "ผู้ประสบปัญหาความเดือดร้อนและได้รับผลกระทบในด้านเศรษฐกิจ สังคม การศึกษา สาธารณสุข การเมือง กฎหมาย วัฒนธรรม ภัยธรรมชาติ และภัยสงคราม รวมถึงผู้ที่ขาดโอกาสที่จะเข้าถึงบริการขั้นพื้นฐานของรัฐ อันจะส่งผลให้ไม่สามารถดำรงชีวิตได้เท่าเทียมกับผู้อื่น ได้แก่ คนยากจน คนเร่ร่อน คนไร้สัญชาติ ผู้พ้นโทษ ผู้ติดเชื้อเอชไอวี และผู้ป่วยเอดส์และครอบครัว\r\n",
    source:
      "ระเบียบสำนักงานส่งเสริมสวัสดิภาพและพิทักษ์เด็ก เยาวชน ผู้ด้อยโอกาส คนพิการ และผู้สูงอายุ พ.ศ. 2550 (2551, 25 มกราคม). ราชกิจจานุเบกษา. เล่ม 125 ตอนพิเศษ 18 ง หน้า 36. http://www.ratchakitcha.soc.go.th/DATA/PDF/2551/E/018/35.PDF",
    sappear: "",
    mappear: 22,
    rappear: 9,
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "ภูมิสารสนเทศ",
    meaning:
      "เทคโนโลยีสารสนเทศเพื่อบูรณาการเทคโนโลยีด้านการสำรวจการทำแผนที่ และการวิเคราะห์ข้อมูลทางพื้นที่เข้าด้วยกัน เพื่อศึกษาเกี่ยวกับโลก ได้แก่ ระบบกำหนดตำแหน่งบนพื้นโลก ระบบการรับรู้จากระยะไกล และระบบสารสนเทศภูมิศาสตร์",
    source:
      "พระราชกฤษฎีกาจัดตั้งสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ(องค์การมหาชน) (ฉบับที่ 2) พ.ศ. 2562 (2562, 31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 72 ก หน้า 104.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0103.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "กฎหมาย",
    firstalpha: "ภ"
  },
  {
    keyword: "วิสาหกิจ",
    meaning:
      "กิจการผลิตสินค้า กิจการให้บริการ กิจการค้าส่ง กิจการค้าปลีก หรือกิจการอื่นตามที่รัฐมนตรีประกาศในราชกิจจานุเบกษา",
    source:
      "พระราชบัญญัติส่งเสริมวิสาหกิจขนาดกลางและขนาดย่อม พ.ศ. 2543. (2543,17 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 117 ตอนที่ 9 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/00018688.PDF",
    sappear: "",
    mappear: 8,
    rappear: 3,
    type: "กฎหมาย",
    firstalpha: "ว"
  },
  {
    keyword: "หลักการบริหารบ้านเมืองที่ดี",
    meaning:
      "การบริหารกิจการบ้านเมืองที่ดี ได้แก่ การบริหารราชการเพื่อบรรลุเป้าหมาย ดังต่อไปนี้ 1. เกิดประโยชน์สุขของประชาชน 2. เกิดผลสัมฤธิ์ต่อภารกิจของรัฐ 3. มีประสิทธิภาพและเกิดความคุ้มค่าในเชิงภารกิจของรัฐ 4. ไม่มีขั้นตอนการปฏิบัติงานเกินความจำเป็น 5. มีการปรับปรุงภารกิจของส่วนราชการให้ทันต่อสถานการณ์ 6. ประชาชนได้รับการอำนวยความสะดวกและได้รับการตอบสนองความต้องการ 7. มีการประเมินผลการปฏิบัติราชการอย่างสม่ำเสมอ",
    source:
      "พระราชกฤษฎีกาว่าด้วยหลักเกณฑ์และวิธีการบริหารกิจการบ้านเมืองที่ดี พ.ศ. 2546 (2546, ตุลาคม 9). ราชกิจจานุเบกษา. เล่มที่ 120 ตอนที่ 100 ก หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/00130026.PDF",
    sappear: "",
    mappear: 20,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ห"
  },
  {
    keyword: "องค์กรอัยการ",
    meaning:
      "องค์กรอัยการประกอบด้วย ก.อ. อัยการสูงสุดและพนักงานอัยการอื่น โดยมีสำนักงานอัยการสูงสุดเป็นหน่วยธุรการ\r\nสำนักงานอัยการสูงสุดเป็นส่วนราชการที่มีอิสระในการบริหารงานบุคคล การงบประมาณและการดำเนินการอื่นๆ และนิติบุคคล โดยมีอัยการสุงสุดเป็นผู้บังคับบัญชาและเป็นผู้แทนนิติบุคคล",
    source:
      "พระราชบัญญัติองค์กรอัยการและพนักงานอัยการ พ.ศ. 2553 (2553, 7 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 127 ตอนที่ 75 ก หน้า 40. http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/A/075/38.PDF",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "รัฐบาลดิจิทัล",
    meaning:
      "การนำเทคโนโลยีดิจิทัลมาใช้เป็นเครื่องมือในการบริหารงาน ภาครัฐและการบริการสาธารณะ โดยปรับปรุงการบริหารจัดการและบูรณาการข้อมูลภาครัฐและการทำงานให้มีความสอดคล้องและเชื่อมโยงเข้าด้วยกันอย่างมั่นคงปลอดภัยและมีธรรมาภิบาล เพื่อเพิ่มประสิทธิภาพ และอำนวยความสะดวกในการให้บริการประชาชน ในการเปิดเผยข้อมูลภาครัฐต่อสาธารณชน และสร้างการมีส่วนร่วมของทุกภาคส่วน",
    source:
      "พระราชบัญญัติการบริหารงานและการให้บริการภาครัฐผ่านระบบดิจิทัล พ.ศ. 2562 (2562, 22 พฤษภาคม).ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 57.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0057.PDF",
    sappear: "",
    mappear: 20,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ร"
  },
  {
    keyword: "สวนรุกขชาติ",
    meaning:
      "พื้นที่ที่มีการรวบรวมและอนุรักษ์พรรณไม้ที่มีค่า หายาก หรือ ใกล้สูญพันธุ์ซึ่งมีอยู่ในท้องถิ่น เพื่อให้ได้รับความรู้เกี่ยวกับพันธุ์ไม้ และการพักผ่อนหย่อนใจของประชาชน",
    source:
      "พระราชบัญญัติอุทยานแห่งชาติ พ.ศ. 2562 (2562, 29 พฤษภาคม 2562). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 71 ก หน้า 146.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0145.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "เชื้อเพลิง",
    meaning:
      "ถ่านหิน หินน้ำมัน ทรายน้ำมัน น้ำมันเชื้อเพลิง ก๊าซเชื้อเพลิง เชื้อเพลิงสังเคราะห์ ฟืน ไม้ แกลบ กากอ้อย ขยะ และสิ่งอื่นตามที่คณะกรรมการนโยบายพลังงานแห่งชาติกำหนดโดยประกาศในราชกิจจานุเบกษา",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน พ.ศ. 2535. (2535, 23 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 109 ตอนที่ 33 หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "ช"
  },
  {
    keyword: "น้ำมันเชื้อเพลิง",
    meaning:
      "ก๊าซ นำมันเบนซิน น้ำมันเชื้อเพลิงสำหรับเครื่องบิน น้ำมันก๊าด น้ำมันดีเซล น้ำมันเตา น้ำมันอื่น ๆ ที่คล้ายกับน้ำมันที่ได้ออกชื่อมาแล้วและผลิตภัณฑ์ปิโตเลียมอื่นตามที่คณะกรรมการนโยบายพลังงานแห่งชาติกำหนดโดยประกาศในราชกิจกานุเบกษา",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน พ.ศ. 2535. (2535, 23 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 109 ตอนที่ 33 หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "น"
  },
  {
    keyword: "โรงกลั่น",
    meaning:
      "โรงกลั่นน้ำมันเชื้อเพลิง สถานที่ผลิตและจำหน่ายน้ำมันเชื้อเพลิง และหมายความรวมถึงโรงแยกก๊าซและโรงงานอุตสาหกรรมเคมีปิโตรเลียมและสารละลายด้วย",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน พ.ศ. 2535. (2535, 23 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 109 ตอนที่ 33 หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "ร"
  },
  {
    keyword: "กิจการพลังงาน",
    meaning: "กิจการไฟฟ้า กิจการก๊าซธรรมชาติ หรือกิจการระบบโครงข่ายพลังงาน",
    source:
      "พระราชบัญญัติการประกอบกิจการพลังงาน พ.ศ. 2550. (2550, 9 ธันวาคม). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 89 ก หน้าที่ 13. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "อัตราค่าบริการ",
    meaning:
      "ราคาพลังงานต่อหน่วย ค่าตอบแทน หรือเงื่อนไขสำหรับการให้บริการ ค่าธรรมเนียมอื่นๆ ที่ผู้รับใบอนุญาติเรียกเก็บจากผู้ใช้พลังงาน",
    source:
      "พระราชบัญญัติการประกอบกิจการพลังงาน พ.ศ. 2550. (2550, 9 ธันวาคม). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 89 ก หน้าที่ 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "ระบบโครงข่ายไฟฟ้า",
    meaning: "ระบบส่งไฟฟ้าหรือระบบจำหน่ายไฟฟ้า",
    source:
      "พระราชบัญญัติการประกอบกิจการพลังงาน พ.ศ. 2550. (2550, 9 ธันวาคม). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 89 ก หน้าที่ 13. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "ร"
  },
  {
    keyword: "ก๊าซปิโตรเลียมเหลว (Liquefied Petroleum Gas: LPG)",
    meaning:
      "ก๊าซปิโตรเลียมที่ประกอบด้วยโพรเพน โพรพิลีน\r\nนอร์แมลบิวเทน ไอโซบิวเทน หรือบิวทิลีน อย่างใดอย่างหนึ่งหรือหลายอย่างผสมกันเป็นส่วนใหญ่",
    source:
      "พระราชบัญญัติกองทุนน้ำมันเชื้อเพลิง พ.ศ. 2562. (2562, 24 พฤษภาคม). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 69 ก หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0001.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "เขตเกษตรเศรษฐกิจ",
    meaning:
      "เขตการผลิตทางการเกษตรซึ่งรวมทั้งการเลี้ยงสัตว์และการปลูกป่าที่กำหนดขึ้นให้เหมาะสมกับภาวะตลาดและเศรษฐกิจการเกษตรของประเทศ โดยคำนึงถึงสภาพที่คล้ายคลึงกันของปัจจัยหลัก เช่น ดินฟ้าอากาศ แหล่งน้ำ พืชที่ปลูก สัตว์ที่เลี้ยง ประเภทของเกษตรกรรมและรายได้หลักของเกษตรกร",
    source:
      "พระราชบัญญัติเศรษฐกิจการเกษตร พ.ศ. 2522 (2522, 23 มีนาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 40 หน้า 20. http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/040/19.PDF",
    sappear: "",
    mappear: 6,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ข"
  },
  {
    keyword: "แผนแม่บทภายใต้ยุทธศาสตร์ชาติ",
    meaning: "แผนแม่บทเพื่อบรรลุเป้าหมายตามที่กำหนดไว้ในยุทธศาสตร์ชาติ",
    source:
      "พระราชบัญญัติการจัดทำยุทธศาสตร์ชาติ พ.ศ. 2560 (2560, 31 กรกฎาคม). ราชกิจจานุเบกษา. เล่มที่ 134 ตอนที่ 79 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/079/1.PDF",
    sappear: "",
    mappear: "15,16,7",
    rappear: 2,
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "แอ่งน้ำบาดาล",
    meaning:
      "น้ำที่เป็นกลุ่มย่อยของน้ำใต้ดินที่สามารถสูบขึ้นมาใช้ได้เท่านั้น จะกําหนดถึงความลึกน้อยกว่าสิบเมตรไม่ได้",
    source:
      "พระราชบัญญัติน้ำบาดาล พ.ศ. 2520 (2520, 28 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 94 ตอนที่ 69 หน้า 9.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2520/A/069/8.PDF",
    sappear: "",
    mappear: 19,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "ก๊าซธรรมชาติ",
    meaning:
      "สารประกอบไฮโดรคาร์บอนที่ประกอบด้วยมีเทนเป็นส่วนใหญ่ที่มีสภาพเป็นก๊าซหรือของเหลว",
    source:
      "พระราชบัญญัติ การประกอบกิจการพลังงาน พ.ศ. 2550 (2550, 10 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 124 ตอนที่ 89 ก หน้า 13.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/089/12.PDF",
    sappear: "",
    mappear: 7,
    rappear: 10,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การแข่งขันทางการค้า",
    meaning:
      "การที่ผู้ประกอบธุรกิจแต่ละราย ซึ่งอาจเป็นผู้จำหน่าย ผู้ผลิต ผู้ส่งหรือผู้นำเข้ามาในราชอาณาจักร \r\nผู้ซื้อเพื่อผลิตหรือจำหน่ายสินค้าหรือบริการอย่างหนึ่งอย่างใด สามารถที่จะกำหนดราคาหรือปริมาณการขายสินค้าหรือบริการได้โดยไม่ถูกจำกัดด้วยข้อตกลงหรือเงื่อนไขใดๆไม่ว่าโดยทางตรงหรือทางอ้อมให้ต้องระงับ ลด หรือจำกัดการบริการ การผลิต การจำหน่ายหรือส่งมอบให้ต่ำกว่าความต้องการของตลาดและไม่ถูกแทรกแซงในการประกอบธุรกิจซึ่งมีผลทำให้ราคาสินค้าและบริการเป็นไปตามความความต้องการของตลาดและผู้บริโภคหรือผู้ใช้บริการมีอิสระในการเลือกซื้อสินค้าและบริการได้อย่างเต็มที่ตามความต้องการของตนเอง",
    source:
      "พระราชบัญญัติการแข่งขันทางการค้า พ.ศ. 2542 (2542, 31 มีนาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 22 ก.ttp://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/022/7.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การแพทย์แผนไทย",
    meaning:
      "การประกอบโรคศิลปะตามความรู้หรือตําราแบบไทยที่ถ่ายทอดและพัฒนาสืบต่อกันมา หรือตามการศึกษาจากสถานศึกษาที่คณะกรรมการรับรอง",
    source:
      "พระราชบัญญัติการประกอบโรคศิลปะ พ.ศ. 2542. (2542, 10 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 39 ก หน้า 29. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/039/28.PDF",
    sappear: "",
    mappear: "4,5",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดผังเมือง",
    meaning:
      "การวาง จัดทำและดำเนินการให้เป็นไปตามผังเมืองรวมและผังเมืองโดยเฉพาะในบริเวณเมืองและบริเวณที่เกี่ยวข้องหรือชนบทเพื่อสร้างหรือพัฒนาเมืองหรือส่วนของเมืองขึ้นใหม่ หรือแทนเมือง/ส่วนของเมืองที่ได้รับความเสียหายเพื่อให้มีหรือทำให้ดียิ่งขึ้น ให้มีสุขลักษณะ ความสะดวกสบาย ความเป็นระเบียบ ความสวยงาม การใช้ประโยชน์ในทรัพย์สิน ความปลอดภัยของประชาชนและสวัสดิภาพของสังคม เพื่อส่งเสริมการเศรษฐกิจและสภาพแวดล้อมเพื่อดำรงรักษาหรือบูรณะสถานที่และวัตถุที่มีประโยชน์หรือคุณค่าในทางศิลปกรรม สถาปัตยกรรม ประวัติศาสตร์ และโบราณคดี เพื่อบำรุงรักษาทรัพยากรธรรมชาติ ภูมิประเทศที่งดงามและมีคุณค่าทางธรรมชาติ",
    source:
      "พระราชบัญญัติการผังเมือง พ.ศ. 2518 (2518, 5 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 92 ตอน 33 ฉบับพิเศษ หน้า1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0027.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "ครุภัณฑ์การแพทย์",
    meaning:
      "(1) เครื่องมือ เครื่องใช้ เครื่องกล วัตถุที่ใช้ใส่เข้าไปในร่างกายมนุษย์หรือสัตว์ น้ำยาที่ใช้ตรวจในห้องปฏิบัติการ ผลิตภัณฑ์ ซอฟต์แวร์ หรือวัตถุอื่นใด ที่ผู้ผลิตมุ่งหมายเฉพาะสำหรับใช้อย่างหนึ่งอย่างใดดังต่อไปนี้ ไม่ว่าจะใช้โดยลำพัง ใช้ร่วมกันหรือใช้ประกอบกับสิ่งอื่นใด\r\n(2) อุปกรณ์ หรือส่วนประกอบของเครื่องมือ เครื่องใช้ เครื่องกล ผลิตภัณฑ์ หรือวัตถุตาม(1)\r\n(3) เครื่องมือ เครื่องใช้ เครื่องกล ผลิตภัณฑ์ หรือวัถุอื่นที่รัฐมนตรีประกาศกำหนดว่าเป็นเครื่องมือแพทย์",
    source:
      "พระราชบัญญัติเครื่องมือแพทย์ พ.ศ. 2551 (2551, 5 มีนาคม). ราชกิจจานุเบกษา. เล่ม 125 ตอนที่ 43 ก หน้า 26. http://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/043/25.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ค"
  },
  {
    keyword: "จำเลย",
    meaning: "บุคคลซึ่งถูกฟ้องยังศาลแล้วโดยข้อหาว่าได้กระทำความผิด",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม.http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "จ"
  },
  {
    keyword: "ดิจิทัล",
    meaning:
      "เทคโนโลยีที่ใช้วิธีการนำสัญลักษณ์ศูนย์และหนึ่ง หรือสัญลักษณ์อื่น มาแทนค่าสิ่งทั้งปวง เพื่อใช้สร้างหรือก่อให้เกิดระบบต่าง ๆ เพื่อให้มนุษย์ใช้ประโยชน์",
    source:
      "พระราชบัญญัติการบริหารงานและการให้บริการภาครัฐผ่านระบบดิจิทัล พ.ศ. 2562 (2562, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 57. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0057.PDF",
    sappear: "",
    mappear: "8,12",
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ด"
  },
  {
    keyword: "บริการสุขภาพ",
    meaning:
      '"สุขภาพ” หมายความว่า ภาวะของมนุษย์ที่สมบูรณ์ทั้งทางกาย ทางจิต ทางปัญญา และทางสังคมเชื่อมโยงกันเป็นองค์รวมอย่างสมดุล\r\n“ระบบสุขภาพ” หมายความว่า ระบบความสัมพันธ์ทั้งมวลที่เกี่ยวข้องกับสุขภาพ\r\n“บริการสาธารณสุข” หมายความว่า บริการต่าง ๆ อันเกี่ยวกับการสร้างเสริมสุขภาพการป้องกันและควบคุมโรคและปัจจัยที่คุกคามสุขภาพ การตรวจวินิจฉัยและบําบัดสภาวะความเจ็บป่วย และการฟื้นฟูสมรรถภาพของบุคคล ครอบครัวและชุมชน\r\n\r\n',
    source:
      "พระราชบัญญัติสุขภาพแห่งชาติ พ.ศ. 2550. (2550, 19 มีนาคม). ราชกิจจานุเบกษา. เล่ม 124 \r\nตอนที่ 16 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/016/1.PDF\r\n\r\n",
    sappear: "",
    mappear: 11,
    rappear: 5,
    type: "กฎหมาย",
    firstalpha: "บ"
  },
  {
    keyword: "ภัยคุกคามไซเบอร์",
    meaning:
      "การกระทำหรือการดำเนินการใด ๆ โดยมิชอบโดยใช้คอมพิวเตอร์หรือระบบคอมพิวเตอร์หรือโปรแกรมไม่พึงประสงค์โดยมุ่งหมายให้เกิดการประทุษร้ายต่อระบบคอมพิวเตอร์ ข้อมูลคอมพิวเตอร์ หรือข้อมูลอื่นที่เกี่ยวข้อง และเป็นภยันตรายที่ใกล้จะถึงที่จะก่อให้เกิดความเสียหายหรือส่งผลกระทบต่อการทำงานขอคอมพิวเตอร์ ระบบคอมพิวเตอร์ หรือข้อมูลอื่นที่เกี่ยวข้อง",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงปลอดภัยไซเบอร์ พ.ศ. 2562. (2562, 27 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอน 69 ก หน้า 21. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0020.PDF",
    sappear: 2,
    mappear: 7,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ภ"
  },
  {
    keyword: "ยุทธศาสตร์ชาติ",
    meaning:
      "ยุทธศาสตร์ชาติตามกฎหมายว่าด้วยการจัดทำยุทธศาสตร์ชาติ \r\nซึ่งเป็นเป้าหมายการพัฒนาประเทศอย่างยั่งยืนตามหลักธรรมาภิบาล เพื่อใช้เป็นกรอบในการจัดทำแผนต่าง ๆ ให้สอดคล้องและบูรณาการกันเพื่อให้เกิดเป็นพลังผลักดันร่วมกันไปสู่เป้าหมายดังกล่าว",
    source:
      "รัฐธรรมนูญแห่งราชอาณาจักรไทย พ.ศ. 2560 หมวด 6 แนวนโยบายแห่งรัฐ มาตรา 65 (2560, 6 เมษายน) \r\nราชกิจจานุเบกษา เล่ม 134 ตอนที่ 40 ก หน้า 17. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/040/1.PDF",
    sappear: 4,
    mappear: "15,16,17",
    rappear: 2,
    type: "กฎหมาย",
    firstalpha: "ย"
  },
  {
    keyword: "วิสาหกิจเพื่อสังคม",
    meaning:
      "บริษัท ห้างหุ้นส่วนนิติบุคคล หรือนิติบุคคลอื่น ที่ตั้งขึ้นตามกฎหมายไทย ซึ่งดำเนินกิจการเกี่ยวกับการผลิต การจำหน่ายสินค้าหรือการบริการ โดยมีวัตถุประสงค์เพื่อสังคมเป็นเป้าหมายหลักของกิจการ และได้รับการจดทะเบียนตามพระราชบัญญัติส่งเสริมวิสาหกิจเพื่อสังคม พ.ศ. ๒๕๖๒",
    source:
      "พระราชบัญญัติส่งเสริมวิสาหกิจเพื่อสังคม พ.ศ. 2562 (2562, 19 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 33. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0032.PDF",
    sappear: "2,4",
    mappear: "8,10,16",
    rappear: "5,9",
    type: "กฎหมาย",
    firstalpha: "ว"
  },
  {
    keyword: "วิสาหกิจชุมชน",
    meaning:
      "กิจการของชุมชนเกี่ยวกับการผลิตสินค้า การให้บริการ หรือการอื่น ๆ ที่ดำเนินการโดยคณะบุคคลที่มีความผูกพัน มีวิถีชีวิตร่วมกันและรวมตัวกันประกอบกิจการดังกล่าว ไม่ว่าจะเป็นนิติบุคคลในรูปแบบใดหรือไม่เป็นนิติบุคคล เพื่อสร้างรายได้และเพื่อการพึ่งพาตนเองของครอบครัว ชุมชน และระหว่างชุมชน",
    source:
      "พระราชบัญญัติส่งเสริมวิสาหกิจชุมชน พ.ศ. 2548. (2548, 18 มกราคม). ราชกิจจานุเบกษา. เล่ม 122 ตอนที่ 6 ก หน้า 1.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/0A/00152770.PDF",
    sappear: "2,5",
    mappear: "4,8,16",
    rappear: "5,6,9",
    type: "กฎหมาย",
    firstalpha: "ว"
  },
  {
    keyword: "สถาบันเกษตรกร",
    meaning:
      "กลุ่มเกษตรกร สหกรณ์การเกษตร ชุมนุมสหกรณ์การเกษตรตามกฎหมายว่าด้วยสหกรณ์",
    source:
      "พระราชบัญญัติการปฏิรูปที่ดินเพื่อเกษตรกรรม พ.ศ.2518 (2518, 5 มีนาคม). ราชกิจจานุเบกษา. เล่ม 92 ตอนที่ 54 หน้า 12. http://www.ratchakitcha.soc.go.th/DATA/PDF/2518/A/054/10.PDF",
    sappear: "",
    mappear: 3,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สวัสดิการทางสังคม",
    meaning:
      "ระบบการจัดบริการทางสังคม เกี่ยวกับการป้องกัน  การแก้ไขปัญหา  การพัฒนาและการส่งเสริมความมั่นคงทางสังคม  ตอบสนองความจำเป็นขั้นพื้นฐานของประชาชน  มีคุณภาพชีวิต และพึ่งตนเองได้ทั่วถึง  เหมาะสม  เป็นธรรม ตามมาตรฐาน ทั้งทางด้านการศึกษา สุขภาพอนามัย ที่อยู่อาศัย การทำงานและการมีรายได้ นันทนาการ กระบวนการยุติธรรมและบริการทางสังคมทั่วไป  \r\nโดยคำนึงถึงศักดิ์ศรีความเป็นมนุษย์  สิทธิที่ประชาชนจะต้องได้รับ  และมีส่วนร่วมในการจัดสวัสดิการสังคมทุกระดับ",
    source:
      "พระราชบัญญัติส่งเสริมการจัดสวัสดิการสังคม พ.ศ. 2546 (2546, 24 กันยายน). ราชกิจจานุเบกษา. เล่ม 120 ตอนที่ 94 ก หน้า 6. http://www.ratchakitcha.soc.go.th/DATA/PDF/00130692.PDF",
    sappear: 4,
    mappear: 15,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สาธารณภัย",
    meaning:
      "อัคคีภัย วาตภัย อุทกภัย ภัยแล้ง โรคระบาดในมนุษย์โรคระบาดสัตว์ โรคระบาดสัตว์น้ำ การระบาดของศัตรูพืช ตลอดจนภัยอื่นๆ อันมีผลกระทบต่อสาธารณชน ไม่ว่าเกิดจากธรรมชาติ มีผู้ทำให้เกิดขึ้น อุบัติเหตุ หรือเหตุอื่นใด ซึ่งก่อให้เกิดอันตรายแก่ชีวิต ร่างกายของประชาชน หรือความเสียหายแก่ทรัพย์สินของประชาชน หรือของรัฐ และให้หมายความรวมถึงภัยทางอากาศ และการก่อวินาศกรรมด้วย\r\n",
    source:
      "พระราชบัญญัติป้องกันและบรรเทาสาธารณภัย พ.ศ. 2550 (2550, 28 สิงหาคม). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 52 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/052/1.PDF",
    sappear: "",
    mappear: 1,
    rappear: 8,
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิมนุษยชน",
    meaning:
      "ศักดิ์ศรีความเป็นมนุษย์ สิทธิ เสรีภาพและความเสมอภาคของบุคคล บรรดาที่ได้รับการรับรองหรือคุ้มครองตามรัฐธรรมนูญ ตามกฎหมาย หรือตามหนังสือสัญญาที่ประเทศไทยเป็นภาคีและมีพันธกรณีที่จะต้องปฏิบัติตาม",
    source:
      "พระราชบัญญัติประกอบรัฐธรรมนูญว่าด้วยคณะกรรมการสิทธิมนุษยชนแห่งชาติ พ.ศ. 2560 (2560, 12 ธันวาคม). ราชกิจจานุเบกษา.  เล่ม 134 ตอนที่ 123 กhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/123/1.PDF",
    sappear: 4,
    mappear: 15,
    rappear: 1,
    type: "กฎหมาย",
    firstalpha: "ส"
  },
  {
    keyword: "อุตสาหกรรมท่องเที่ยว",
    meaning:
      "อุตสาหกรรมที่จัดให้มีหรือให้บริการเกี่ยวกับการท่องเที่ยวทั้งภายในและภายนอกราชอาณาจักรโดยมีค่าตอบแทน และหมายความรวมถึง \r\n(1) ธุรกิจนําเที่ยว\r\n(2) ธุรกิจโรงแรมนักท่องเที่ยว\r\n(3) ธุรกิจภัตตาคาร สถานบริการและสถานที่ตากอากาศสําหรับนักท่องเที่ยว\r\n(4) ธุรกิจการขายของที่ระลึกหรือสินค้าสําหรับนักท่องเที่ยว\r\n(5) ธุรกิจการกีฬาสําหรับนักท่องเที่ยว\r\n(6) การดําเนินงานนิทรรศการ งานแสดง งานออกร้าน การโฆษณาเผยแพร่ หรือการดําเนินงานอื่นใดโดยมีความมุ่งหมายเพื่อชักนําหรือส่งเสริมให้มีการเดินทางท่องเที่ยว\r\n",
    source:
      "พระราชบัญญัติการท่องเที่ยวแห่งประเทศไทย พ.ศ. 2522 (2522, 4 พฤษภาคม). ราชกิจจานุเบกษา. เล่มที่ 96 ตอนที่ 72 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/072/1.PDF",
    sappear: "",
    mappear: 5,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมป้องกันประเทศ",
    meaning:
      "การวิจัย การพัฒนา การผลิต การประกอบรวม การปรับปรุง การซ่อมสร้าง การเปลี่ยนลักษณะ การแปรสภาพ หรือการให้บริการซึ่งผลิตภัณฑ์ที่ใช้ในการป้องกันประเทศโดยอาจมีค่าตอบแทนหรือไม่ก็ได้",
    source:
      "พระราชบัญญัติเทคโนโลยีป้องกันประเทศ พ.ศ. 2562.  (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก หน้า 18.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0017.PDF",
    sappear: 2,
    mappear: 4,
    rappear: "",
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "เศรษฐกิจชุมชน",
    meaning:
      "เศรษฐกิจทุกสาขาของชุมชนและหมู่บ้าน ซึ่งดำเนินอยู่บนพื้นฐานการใช้ประโยชน์จากทรัพยากรและสิ่งแวดล้อมอย่างเหมาะสม คุ้มค่าและยั่งยืน เป็นการผลิตที่เลี้ยงชีวิต ครอบครัวและชุมชนได้อย่างพอเพียง ส่วนเกินแห่งผลผลิตนี้เป็นเศรษฐกิจแห่งการแลกเปลี่ยน ซื้อขายหรือแปรรูปตามกำลังและวัฒนธรรมของชุมชนเอง",
    source:
      "ระเบียบกระทรวงมหาดไทยว่าด้วยการดำเนินงานโครงการเศรษฐกิจชุมชน พ.ศ. 2541 (2553, 17 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 127 ตอนพิเศษ 60 ง หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/E/060/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 9,
    type: "กฎหมาย",
    firstalpha: "ศ"
  },
  {
    keyword: "การไต่สวนมูลฟ้อง",
    meaning: "กระบวนไต่สวนของศาลเพื่อวินิจฉัยถึงมูลคดีซึ่งจำเลยต้องหา",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม. http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การคุมประพฤติ",
    meaning:
      "การสืบเสาะและพินิจ และการคุมความประพฤติผู้ถูกคุมความประพฤติให้ปฏิบัติตามเงื่อนไขที่กำหนดไว้ตามคำสั่งหรือหนังสือแจ้งของศาล หรือเจ้าพนักงานผู้มีอำนาจ รวมทั้งการใช้มาตรการแก้ไขฟื้นฟูผู้กระทำผิด",
    source:
      "พระราชบัญญัติคุมประพฤติ พ.ศ. 2559 (2559, 3 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 88 ก\r\nหน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/088/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "การศึกษาขั้นพื้นฐาน",
    meaning: "การศึกษาก่อนระดับอุดมศึกษา",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542 (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 9,
    type: "กฎหมาย",
    firstalpha: "ก"
  },
  {
    keyword: "คดีมโนสาเร่",
    meaning:
      "คดีที่มีคำขอให้ปลดเปลื้องทุกข์อันอาจคำนวณเป็นราคาเงินได้และฟ้องคดีขับไล่บุคคลใดๆ ออกจากอสังหาริมทรัพย์อันมีค่าเช่าหรืออาจให้เช่าได้",
    source:
      "พระราชกฤษฎีกากำหนดจำนวนเงินในคดีมโนสาเร่ พ.ศ. 2546 (2546, 30 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 120 ตอนที่ 107 ก หน้า 37. http://www.ratchakitcha.soc.go.th/DATA/PDF/00131730.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ค"
  },
  {
    keyword: "คำร้องทุกข์",
    meaning:
      "การที่ผู้เสียหายได้กล่าวหาต่อเจ้าหน้าที่ตามบทบัญญัติแห่งประมวลกฎหมายนี้ ว่ามีผู้กระทำความผิดขึ้น จะรู้ตัวผู้กระทำความผิดหรือไม่ก็ตามซึ่งกระทำให้เกิดความเสียหายแก่ผู้เสียหาย และการกล่าวหาเช่นนั้นได้กล่าวโดยมีเจตนาจะให้ผู้กระทำความผิดได้รับโทษ",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม.  http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ค"
  },
  {
    keyword: "นวัตกรรม",
    meaning:
      "ผลิตภัณฑ์ สิ่งประดิษฐ์ บริการ กรรมวิธีที่เกี่ยวกับการผลิต การจัดโครงสร้างองค์กร ระบบบริหารจัดการ การบริหารการเงิน ธุรกิจ การตลาด หรือในการอื่นใด\r\nทั้งนี้ ซึ่งเป็นสิ่งใหม่หรือพัฒนาให้ดีขึ้นกว่าเดิมอย่างมีนัยสำาคัญ และนำไปใช้ประโยชน์ได้ในวงกว้างทั้งในเชิงพาณิชย์และสาธารณะ",
    source:
      "พระราชบัญญัติสภานโยบายการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมแห่งชาติ พ.ศ. 2562 (2562, 1 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม139 ตอนที่ 57 ก หน้า 9. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/057/T_0008.PDF",
    sappear: "1,2,3,4,5,6",
    mappear: "8,9,15,16,18",
    rappear: 2,
    type: "กฎหมาย",
    firstalpha: "น"
  },
  {
    keyword: "บำเหน็จ",
    meaning:
      "เงินที่จ่ายให้แก่สมาชิกโดยจ่ายให้ครั้งเดียวเมื่อสมาชิกภาพของสมาชิกสิ้นสุดลง",
    source:
      "พระราชบัญญัติกองทุนบำเหน็จบำนาญข้าราชการ พ.ศ.2539 (2539, 27 กันยายน). ราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 42 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2539/A/042/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "บ"
  },
  {
    keyword: "ผู้ต้องหา",
    meaning: "บุคคลผู้ถูกหาว่าได้กระทำความผิด แต่ยังมิได้ถูกฟ้องต่อศาล",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม. http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "ผ"
  },
  {
    keyword: "พนักงานสอบสวน",
    meaning: "เจ้าพนักงานซึ่งกฎหมายให้มีอำนาจและหน้าที่ทำการสอบสวน",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม.http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "พ"
  },
  {
    keyword: "พนักงานอัยการ",
    meaning:
      "เจ้าพนักงานผู้มีหน้าที่ฟ้องผู้ต้องหาต่อศาล  ทั้งนี้ จะเป็นข้าราชการในกรมอัยการหรือเจ้าพนักงานอื่นผู้มีอำนาจเช่นนั้นก็ได้",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม.http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "กฎหมาย",
    firstalpha: "พ"
  },
  {
    keyword: "วิสาหกิจขนาดกลางและขนาดย่อม",
    meaning:
      "วิสาหกิจขนาดกลางหรือวิสาหกิจขนาดย่อม ได้แก่ วิสาหกิจที่มีจำนวน การจ้างงาน รายได้ มูลค่าสินทรัพย์ถาวร หรือทุนจดทะเบียนที่ชำระแล้ว ตามหลักเกณฑ์ที่กำหนด ในกฎกระทรวง\r\nวิสาหกิจขนาดย่อม ได้แก่ กิจการที่มีลักษณะดังต่อไปนี้\r\n- กิจการผลิตสินค้า ที่มีจำนวนการจ้างงานไม่เกิน 50 คน หรือมีมูลค่าสินทรัพย์ถาวรไม่เกิน 50 ล้านบาท\r\n- กิจการให้บริการที่มีจำนวนการจ้างงานไม่เกิน 50 คน หรือมีมูลค่าสินทรัพย์ถาวรไม่เกิน 50 ล้านบาท\r\n- กิจการค้าส่งที่มีจำนวนการจ้างงานไม่เกิน 25 คน หรือมีมูลค่าสินทรัพย์ถาวรไม่เกิน 50 ล้านบาท\r\n- กิจการค้าปลีกที่มีจำนวนการจ้างงานไม่เกิน 15 คน หรือมีมูลค่าสินทรัพย์ถาวรไม่เกิน 30 ล้านบาท\r\nวิสาหกิจขนาดกลาง ได้แก่ กิจการที่มีลักษณะดังต่อไปนี้\r\n- กิจการผลิตสินค้า ที่มีจำนวนการจ้างงานเกินกว่า 50 คน แต่ไม่เกิน 200 คนหรือมีมูลค่าสินทรัพย์ถาวรเกินกว่า 50 ล้านบาท แต่ไม่เกิน 200 ล้านบาท\r\n- กิจการให้บริการ ที่มีจำนวนการจ้างงานเกินกว่า 50 คน แต่ไม่เกิน 200 คนหรือมีมูลค่าสินทรัพย์ถาวรเกินกว่า 50 ล้านบาท แต่ไม่เกิน 200 ล้านบาท\r\n- กิจการค้าส่ง ที่มีจำนวนการจ้างงานเกินกว่า 25 คน แต่ไม่เกิน 50 คน หรือมีมูลค่าสินทรัพย์ถาวรเกินกว่า 50 ล้านบาท แต่ไม่เกิน 100 ล้านบาท\r\n- กิจการค้าปลีก ที่มีจำนวนการจ้างงานเกินกว่า 15 คน แต่ไม่เกิน 30 คน หรือมีมูลค่าสินทรัพย์ถาวรเกินกว่า 30 ล้านบาท แต่ไม่เกิน 60 ล้านบาท",
    source:
      "​พระราชบัญญัติส่งเสริมวิสาหกิจขนาดกลางและขนาดย่อม (ฉบับที่ 2) พ.ศ. 2561 (2561,19 เมษายน). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 27 ก หน้า 24.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/027/24.PDF\r\nกฎกระทรวงกำหนดจำนวนการจ้างงานและมูลค่าสินทรัพย์ถาวรของวิสาหกิจขนาดกลางและขนาดย่อม พ.ศ. 2545 (2545,20 กันยายน). ราชกิจจานุเบกษา. เล่ม 119 ตอนที่ 93 ก หน้า 17. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/00102303.PDF\r\nสำนักงานส่งเสริมวิสาหกิจขนาดกลางและขนาดย่อม. https://www.sme.go.th/upload/mod_download/%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%B2%E0%B8%A1%20SMEs.pdf\r\n",
    sappear: "",
    mappear: 8,
    rappear: 3,
    type: "กฎหมาย",
    firstalpha: "ว"
  },
  {
    keyword: "อนามัยเจริญพันธุ์",
    meaning:
      "ภาวะความแข็งแรงสมบูรณ์ของร่างกายและจิตใจที่เป็นผลอันเกิดจากกระบวนการทำหน้าที่ของระบบสุขภาพทางเพศและการเจริญพันธุ์ตลอดช่วงชีวิต ซึ่งทําให้ประชาชนมีคุณภาพชีวิตที่ดีและอยู่ในสังคมได้อย่างมีความสุข",
    source:
      "พระราชบัญญัติ การป้องกันและแก้ไขปัญหาการตั้งครรภ์ในวัยรุ่น พ.ศ. 2559 (2559, 31 มีนาคม).\r\nราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 30 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/030/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 9,
    type: "กฎหมาย",
    firstalpha: "อ"
  },
  {
    keyword: "เวชภัณฑ์",
    meaning: "สิ่งของเครื่องมือเครื่องใช้เกี่ยวกับการแพทย์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เวชภัณฑ์, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: 2,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "โครงข่ายคมนาคม",
    meaning: "การติดต่อไปมาถึงกัน, การสื่อสาร",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. คมนาคม, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 7,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ค"
  },
  {
    keyword: "การฟอกเงิน",
    meaning:
      "การโอน รับโอน หรือเปลี่ยนสภาพทรัพย์สินที่เกี่ยวกับการกระทำความผิดบางประการ เพื่อซุกซ่อนหรือปกปิดแหล่งที่มาของทรัพย์สินนั้น หรือเพื่อช่วยเหลือผู้อื่นมิให้ต้องรับโทษหรือรับโทษน้อยลง หรือการปกปิดอำพรางการได้มา ฯลฯ ซึ่งเป็นทรัพย์สินที่เกี่ยวกับการกระทำความผิด",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nฟอกเงิน, 17 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ก"
  },
  {
    keyword: "การอภัยโทษ",
    meaning: "การยกโทษ เปลี่ยนโทษหนักเป็นเบา หรือลดโทษให้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. \r\nอภัยโทษ, 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ก"
  },
  {
    keyword: "ความยากจน",
    meaning:
      "สภาพที่ประชาชนมีความเป็นอยู่ที่ต่ำกว่ามาตรฐาน กล่าวคือ ไม่มีรายได้เพียงพอที่จะใช้จ่ายในการซื้อสิ่งจำเป็นขั้นพื้นฐานในการครองชีพ เช่น อาหาร เครื่องนุ่งห่ม ที่อยู่อาศัย ความยากจนอาจวัดได้ใน ๒ ลักษณะ คือ ความยากจนสัมบูรณ์ (absolute poverty) กับความยากจนสัมพัทธ์ (relative poverty) ความยากจนสัมบูรณ์ คือสภาพที่ประชาชนไม่มีรายได้เพียงพอที่จะมีชีวิตอยู่ได้ ซึ่งอาจแก้ไขได้ด้วยการพัฒนาเศรษฐกิจ หรือมีเทคโนโลยีที่ดีขึ้น ก็จะช่วยขจัดความยากจนนั้นได้ ส่วนความยากจนสัมพัทธ์เป็นการเปรียบเทียบระหว่างกลุ่มของประชาชนที่มีรายได้แตกต่างกัน ดังนั้น ความยากจนสัมพัทธ์จึงจะมีอยู่ตลอดเวลา แม้ว่ากลุ่มประชาชนที่ยากจนที่สุดมีรายได้เพียงพอที่จะใช้จ่ายในการครองชีพได้ก็ตาม",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2552). ความยากจน, 27 มิถุนายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A2%E0%B8%B2%E0%B8%81%E0%B8%88%E0%B8%99-%E0%B9%98-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%92",
    sappear: 4,
    mappear: "16,17",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ค"
  },
  {
    keyword: "ฎีกา",
    meaning:
      "การคัดค้านคําพิพากษาหรือคําสั่งศาลอุทธรณ์ที่คู่ความยื่นต่อศาลชั้นต้น เพื่อเสนอให้ศาลฎีกาพิจารณาพิพากษาหรือวินิจฉัย\r\nชี้ขาด",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2556). ฎีกา, 18 กรกฎาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%8E%E0%B8%B5%E0%B8%81%E0%B8%B2-%E0%B9%94-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ฎ"
  },
  {
    keyword: "บูรณาการ",
    meaning:
      "กระบวนการผสมผสานเชื่อมโยงองค์ความรู้ตั้งแต่ ๒ องค์ความรู้ขึ้นไปเข้าด้วยกันอย่างสอดคล้องเป็นระบบ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บูรณาการ, 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 4,
    mappear: 15,
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "บ"
  },
  {
    keyword: "ผู้พิพากษา",
    meaning: "ผู้มีอำนาจและหน้าที่ในการพิจารณาพิพากษาอรรถคดีในศาล",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nผู้พิพากษา, 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ผ"
  },
  {
    keyword: "พยาน",
    meaning:
      "หลักฐานเครื่องพิสูจน์ข้อเท็จจริง, ผู้ที่รู้เห็นเหตุการณ์หรือข้อเท็จจริงที่ใช้เป็นหลักฐานเครื่องพิสูจน์ได้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nพยาน, 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "พ"
  },
  {
    keyword: "พลวัต (dynamic) ",
    meaning:
      "สิ่งที่ไม่หยุดนิ่งอยู่กับที่ และมีความสามารถเคลื่อนที่ไปข้างหน้าด้วยพลังในตัวเอง เช่น ภาษามีความเป็นพลวัต คือมีความเปลี่ยนแปลงตลอดเวลา.",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2555). พลวัต, \r\n30 สิงหาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%\r\n9E%E0%B8%A5%E0%B8%A7%E0%B8%B1%E0%B8%95-%E0%B9%96-%E0%B8%AA%E0%B8%B4%E0%B8%\r\n87%E0%B8%AB%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%95",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "พ"
  },
  {
    keyword: "ยุคโลกาภิวัตน์",
    meaning:
      "การแพร่กระจายไปทั่วโลก; การที่ประชาคมโลกไม่ว่าจะอยู่ ณ จุดใด สามารถรับรู้ สัมพันธ์ หรือรับผลกระทบจากสิ่งที่เกิดขึ้นได้อย่างรวดเร็วกว้างขวาง ซึ่งเนื่องมาจากการพัฒนาระบบสารสนเทศ",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2558).  globalisa(za)tion-โลกาภิวัตน์, 29 สิงหาคม 2562. http://www.royin.go.th/?\r\nknowledges=globalisazation-%E0%B9%82%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A0%E0%\r\nB8%B4%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%99%E0%B9%8C",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ย"
  },
  {
    keyword: "วิสัยทัศน์",
    meaning: "การมองการณ์ไกล, วิทัศน์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิสัยทัศน์, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: 15,
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "สัมมาชีพ",
    meaning:
      "อาชีพที่สุจริต, อาชีพที่ชอบธรรม เช่น การทำไร่ทำนานับว่าเป็นสัมมาชีพอย่างหนึ่ง",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สัมมาชีพ, 30 สิงหาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 11,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "อนุวัติ",
    meaning: "ทำตาม, ประพฤติตาม, ปฏิบัติตาม",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nอนุวัติ, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "อัตลักษณ์",
    meaning:
      "ผลรวมของลักษณะเฉพาะของสิ่งใดสิ่งหนึ่งซึ่งทำให้สิ่งนั้นเป็นที่รู้จักหรือจำได้",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2550). อัตลักษณ์, \r\n19 มิถุนายน 2562. http://www.royin.go.th/?knowledges=อัตลักษณ์-๑๖-มิถุนายน-๒๕",
    sappear: 5,
    mappear: 2,
    rappear: 8,
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรม",
    meaning:
      "กิจกรรมที่ใช้ทุนและแรงงานเพื่อผลิตสิ่งของหรือจัดให้มีบริการ มักเป็นการประกอบธุรกิจขนาดใหญ่ที่ต้องใช้แรงงานและเงินทุนมาก และหมายถึง งานที่ต้องใช้คนจำนวนมากและใช้เทคโนโลยี\r\n\r\n\r\n",
    source:
      "สำนักงานราชบัณฑิตยสภา พ.ศ. 2554. อุตสาหกรรม, 30 สิงหาคม 2562. http://www.royin.go.th\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n",
    sappear: 2,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "อุทธรณ์",
    meaning:
      "ขอให้พิจารณาใหม่ในทางศาล หมายถึง ยื่นคำร้องหรือคำคัดค้านต่อศาลอุทธรณ์",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2551). อุทธรณ์, \r\n29 สิงหาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%AD%E0%B8%B8%E0%B8%97%E0%B8%98%E0%B8%A3%E0%B8%93%E0%B9%8C-%E0%B9%96-%E0%B8%A1%E0%B8%81%E0%B8%A3%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%91",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "เคมีภัณฑ์",
    meaning: "สารบริสุทธิ์ที่เตรียมได้โดยกรรมวิธีเคมีหรือที่ใช้ในกรรมวิธีเคมี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เคมีภัณฑ์. 12 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 1,
    rappear: 10,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ค"
  },
  {
    keyword: "เวชศาสตร์",
    meaning: "ชื่อตํารารักษาโรคแผนโบราณวิชาว่าด้วยการรักษาโรคโดยการใช้ยา",
    source:
      "พจนานุกรมแปล ไทย-ไทย ราชบัณฑิตยสถาน. เวชศาสตร์. 8 กรกฎาคม 2562. https://dictionary.sanook.com/search/dict-th-th-royal-institute/%E0%B9%80%E0%B8%A7%E0%B8%8A%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "เศรษฐกิจพอเพียง",
    meaning:
      "ปรัชญาที่พระบาทสมเด็จพระเจ้าอยู่หัวรัชกาลที่ 9 พระราชทานเป็น แนวทางการดำรงชีวิตและปฏิบัติตนของประชาชนตั้งแต่ระดับครอบครัว ระดับชุมชน จนถึงระดับรัฐ ให้ดำเนินไปในทางสายกลาง ไม่ประมาท ไม่โลภ ไม่เบียดเบียนผู้อื่น คำนึงถึงความพอประมาณ ความมีเหตุผล มีภูมิคุ้มกันในตัว ตลอดจนใช้ความรู้และคุณธรรม เป็นพื้นฐานในการดำรงชีวิตให้รอดพ้นจากวิกฤติ มีความมั่นคงและยั่งยืนท่ามกลางกระแสโลกาภิวัตน์และความเปลี่ยนแปลงต่าง ๆ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ธนาคารโลก. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: 5,
    mappear: 18,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐศาสตร์",
    meaning:
      "วิชาว่าด้วยการผลิต การจำหน่ายจ่ายแจกและการบริโภคใช้สอยสิ่งต่าง ๆ ของชุมชน โดยสามารถแบ่งแยกย่อยได้เป็น 2 สาขาใหญ่ๆ คือ \r\n1. เศรษฐศาสตร์จุลภาค ได้แก่ เศรษฐศาสตร์ภาคที่ศึกษาปัญหาเศรษฐกิจส่วนเอกชน หรือ ปัญหาการตลาด กลไกราคา เป็นต้น \r\n2. เศรษฐศาสตร์มหัพภาค ได้แก่ เศรษฐศาสตร์ภาคที่ศึกษาปัญหาเศรษฐกิจของประเทศโดยส่วนรวม เช่น ปัญหาเรื่องรายได้ของประชาชาติ การออมทรัพย์ของประชากร ปัญหาการลงทุน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เศรษฐศาสตร์. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: 5,
    mappear: 18,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ศ"
  },
  {
    keyword: "เสถียรภาพ",
    meaning:
      "ความมั่นคง, ความคงตัว, ความไม่เปลี่ยนแปลง, เช่น เสถียรภาพทางการเมือง เศรษฐกิจไม่ดีรัฐบาลก็ไม่มีเสถียรภาพ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เสถียรภาพ. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "กระบวนทัศน์",
    meaning:
      "หรือ paradigm คือ กรอบความคิดหรือแนวทางทั่วไปที่ใช้ในการมองโลก หรือหมายถึง ระบบคิด วิธีคิด หรือแบบของการคิดที่ใช้เป็นแนวในการศึกษาวิจัยเรื่องใดเรื่องหนึ่ง หรือเป็นแนวในการจัดระบบในสังคม",
    source:
      "สำนักงานราชบัณฑิตยสภา พ.ศ. 2550. กระบวนทัศน์. 6 มิถุนายน 2562. http://www.royin.go.th/?knowledges=กระบวนทัศน์-๑๘-เมษายน-๒๕",
    sappear: 5,
    mappear: "2,10,18",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ก"
  },
  {
    keyword: "การพาณิชย์",
    meaning:
      "การค้าขาย, ชื่อกระทรวงที่มีอำนาจหน้าที่เกี่ยวกับการพาณิชย์ และกิจการทางเศรษฐกิจที่เกี่ยวเนื่องกับการพาณิชย์รวมตลอดทั้งการซื้อขายและแลกเปลี่ยนสินค้า การควบคุมและส่งเสริมเกี่ยวกับกิจการค้าและการประกันภัย",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. พาณิชย์. 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ก"
  },
  {
    keyword: "จิตสาธารณะ",
    meaning:
      " จิตสาธารณะ  ประกอบด้วยคำว่า จิต กับ สาธารณะ.  จิต หมายถึง ใจ หรือสิ่งที่ทำหน้าที่คิด นึก และรู้.  สาธารณะ หมายถึง ทั่วไป เพื่อประชาชนทั่วไป จิตสาธารณะ หมายถึง สำนึกหรือความคิดที่จะทำสิ่งที่เป็นประโยชน์ให้แก่สังคม หรือคนทั่วไป",
    source:
      "สำนักงานราชบัณฑิตยสภา. จิตสาธารณะ. 19 มิถุนายน 2562.\r\nhttp://www.royin.go.th/?knowledges=%E0%B8%88%E0%B8%B4%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%98%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B8%B0-%E0%B9%99-%E0%B8%A1%E0%B8%81%E0%B8%A3%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%94",
    sappear: "1,3",
    mappear: 1,
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "จ"
  },
  {
    keyword: "ทัศนคติ",
    meaning: "แนวความคิดเห็น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ทัศนคติ. 23 กรกฎาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ท"
  },
  {
    keyword: "ทัศนศิลป์",
    meaning:
      "ศิลปกรรมประเภทหนึ่งซึ่งแสดงออกด้วยลักษณะที่เป็นรูปภาพหรือรูปทรง รับรู้ได้ด้วยการเห็นและสัมผัสได้ด้วยการจับต้อง เช่น ภาพจิตรกรรม ภาพพิมพ์ งานประติมากรรม งานสถาปัตยกรรม",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ทัศนศิลป์. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ท"
  },
  {
    keyword: "ธรณีวิทยา",
    meaning: "วิชาว่าด้วยความรู้เกี่ยวกับประวัติ โครงสร้าง และสภาพของโลก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ธรณีวิทยา. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ธ"
  },
  {
    keyword: "ธรรมาธิปไตย",
    meaning: "การถือธรรมเป็นใหญ่, การถือความถูกต้องเป็นหลัก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ธรรมาธิปไตย. 23 กรกฎาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ธ"
  },
  {
    keyword: "นิติธรรม",
    meaning:
      "หลักพื้นฐานแห่งกฎหมายที่บุคคลทุกคนต้องอยู่ภายใต้บังคับแห่งกฎหมายอย่างเท่าเทียมกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. นิติธรรม. 25 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: 3,
    type: "ราชบัณฑิตฯ",
    firstalpha: "น"
  },
  {
    keyword: "นิติวิทยาศาสตร์",
    meaning:
      "วิชาที่ว่าด้วยการนำหลักวิทยาศาสตร์สาขาต่าง ๆ มาประยุกต์เพื่อแก้ปัญหาทางกฎหมาย และการพิสูจน์ข้อเท็จจริงเกี่ยวกับคดีความ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. นิติวิทยาศาสตร์. 20 พฤศจิกายน2562. http://www.royin.go.th/dictionary/index.php",
    sappear: 6,
    mappear: 22,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "น"
  },
  {
    keyword: "บริการสาธารณะ",
    meaning:
      "กิจการอันจำเป็นและเป็นประโยชน์ต่อประชาชนเป็นส่วนรวมที่รัฐหรือองค์กรปกครองส่วนท้องถิ่นจัดทำขึ้นเพื่อบริการแก่ประชาชน เช่น กิจการสาธารณูปโภค กิจการขนส่งคนโดยสาร",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บริการสาธารณะ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 6,
    mappear: 20,
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "บ"
  },
  {
    keyword: "ประชาสังคม",
    meaning:
      "ประชาสังคมเป็นรูปแบบของสังคมที่ให้ความสำคัญต่อกิจกรรมสาธารณะแตกต่างกับกิจกรรมของครอบครัวและกิจกรรมของรัฐดั้งเดิม กิจกรรมประชาสังคมดำเนินการภายใต้กรอบนิติกรรม และมีขอบเขตครอบคลุมประเด็นการมีส่วนร่วมสาธารณะ องค์การ อาสาสมัคร สื่อสารมวลชน องค์การวิชาชีพ สหภาพแรงงาน ฯลฯ\r\nประชาสังคมมีลักษณะเป็นพลวัตซึ่งรวมความหมายถึงขบวนการทางสังคม หรือหมายถึงความเป็นพลเมืองในแง่ที่เป็นพลวัตของความเป็นประชาชนที่เกี่ยวข้องกับกระบวนการพิจารณา ตรวจสอบ ทบทวน และกำหนดนิยามใหม่ของสิทธิและหน้าที่ของประชาชน บางครั้ง ประชาสังคมใช้คำว่า “ภาคที่ 3” (third sector) แทน ซึ่งหมายถึง ภาคที่ไม่ใช่รัฐบาลและธุรกิจ หากแต่เป็นภาคอิสระ (independent sector) หรือภาคประชาชน”",
    source:
      "สำนักงานราชบัณฑิตยสภา. ประชาสังคม. 2 กรกฎาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%AA%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%A1-%E0%B9%94-%E0%B8%A1%E0%B8%B4%E0%B8%96%E0%B8%B8%E0%B8%99%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95",
    sappear: 5,
    mappear: 18,
    rappear: 11,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "ปิโตรเลียม",
    meaning:
      "นํ้ามันดิบ ประกอบด้วยสารไฮโดรคาร์บอนและสารอินทรีย์อื่น ๆ อีกมาก องค์ประกอบไม่แน่นอนแล้วแต่แหล่งที่พบ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ปิโตรเลียม. 20 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 2,
    rappear: 10,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "พหุภาคี",
    meaning:
      "1. หลายฝ่าย\r\n2. เรียกสนธิสัญญาที่มีคู่สัญญาหลายฝ่ายว่า สนธิสัญญาพหุภาคี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พหุภาคี. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: 2,
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "พ"
  },
  {
    keyword: "มนุษยธรรม",
    meaning: "ธรรมของคน, ธรรมที่มนุษย์พึงมีต่อกัน มีเมตตากรุณาเป็นต้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. มนุษยธรรม. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 1,
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ม"
  },
  {
    keyword: "รากเหง้า",
    meaning: "ต้นเหตุ เช่น โลภ โกรธ หลง เป็นรากเหง้าของความชั่วทั้งปวง",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 4,
    mappear: 15,
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ร"
  },
  {
    keyword: "วนอุทยาน",
    meaning:
      "ป่าสงวนที่มีลักษณะธรรมชาติสวยงาม เช่นมีนํ้าตก ถํ้า และทางราชการได้เข้าไปปรับปรุงตกแต่งสถานที่ให้เป็นที่พักผ่อนหย่อนใจของประชาชน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วนอุทยาน. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "วัฒนธรรม",
    meaning:
      "สิ่งที่ทำความเจริญงอกงามให้แก่หมู่คณะ เช่น วัฒนธรรมไทย วัฒนธรรมในการแต่งกาย, วิถีชีวิตของหมู่คณะ เช่น วัฒนธรรมพื้นบ้าน วัฒนธรรมชาวเขา",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วัฒนธรรม. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: 18,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "วาตภัย",
    meaning: "ภัยอันตรายที่เกิดจากพายุ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วาตภัย. 18 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "วุฒิสภา",
    meaning:
      "สภานิติบัญญัติสภาหนึ่ง อาจประกอบด้วยสมาชิกที่มาจากการแต่งตั้ง เลือกตั้ง หรือแต่งตั้งและเลือกตั้งผสมกัน มีหน้าที่กลั่นกรองกฎหมายและหน้าที่อื่นตามที่รัฐธรรมนูญกำหนด",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. วุฒิสภา. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "ศักยภาพ",
    meaning:
      "ภาวะแฝง, อำนาจหรือคุณสมบัติที่มีแฝงอยู่ในสิ่งต่าง ๆ อาจทำให้พัฒนาหรือให้ปรากฏเป็นสิ่งที่ประจักษ์ได้ เช่น เขามีศักยภาพในการทำงานสูง น้ำตกขนาดใหญ่มีศักยภาพในการให้พลังงานได้มาก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. ศักยภาพ. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ศ"
  },
  {
    keyword: "สมานฉันท์",
    meaning: "ความพอใจร่วมกัน, ความเห็นพ้องกัน, เช่น มีความเห็นเป็นสมานฉันท์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สมานฉันท์. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สหประชาชาติ",
    meaning:
      "องค์การระหว่างประเทศที่จัดตั้งขึ้นโดยมีวัตถุประสงค์สำคัญ คือ การป้องกันสงคราม การยืนยันรับรองสิทธิมนุษยชนขั้นพื้นฐาน การเคารพและปฏิบัติตามพันธกรณีที่เกิดจากสนธิสัญญาและกฎหมายระหว่างประเทศ, เรียกชื่อเต็มว่า องค์การสหประชาชาติ (United Nations Organization)",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. ธนาคารโลก. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: 2,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สันติวิธี",
    meaning: "วิธีที่จะก่อให้เกิดความสงบ เช่น เจรจาสงบศึกโดยสันติวิธี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สันติวิธี. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สาธารณูปโภค",
    meaning:
      "บริการสาธารณะที่จัดทำเพื่ออำนวยประโยชน์แก่ประชาชนในสิ่งอุปโภคที่จำเป็นต่อการดำเนินชีวิต เช่น การไฟฟ้า การประปา การเดินรถประจำทาง โทรศัพท์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สาธารณูปโภค. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สาธารณูปการ",
    meaning:
      "กิจการเกี่ยวกับการสงเคราะห์บุคคลที่ไม่สามารถช่วยตัวเองได้ เช่น คนชรา คนพิการ เด็กกำพร้า.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สาธารณูปโภค. 18 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สารัตถะ",
    meaning: "เนื้อหาหลัก, ใจความสำคัญ, ความคิดสำคัญของเรื่อง",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สารัตถะ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สิ่งปฏิกูล",
    meaning: "สิ่งสกปรกน่ารังเกียจ เช่น ขยะเป็นสิ่งปฏิกูล",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สิ่งปฏิกูล. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สินไถ่",
    meaning: "จำนวนเงินที่ชำระเพื่อไถ่ทรัพย์สินคืนจากการขายฝาก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สินไถ่. 18 พฤศจิกายน 2562 http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สินทรัพย์",
    meaning: "บรรดาทรัพย์สินซึ่งบุคคลเป็นเจ้าของ เช่น เงิน ทรัพย์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "หัตถกรรม",
    meaning: "งานช่างที่ทำด้วยมือ โดยถือประโยชน์ใช้สอยเป็นหลัก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ห"
  },
  {
    keyword: "องค์กรปกครองส่วนท้องถิ่น",
    meaning:
      "องค์กรของราชการบริหารส่วนท้องถิ่นที่จัดตั้งขึ้นในรูปแบบต่าง ๆ โดยราชการบริหารส่วนท้องถิ่น คือ การปกครอง ดูแล จัดการ และการให้บริการของรัฐ ที่รัฐกระจายอำนาจให้ประชาชนในท้องถิ่นเข้ามามีส่วนในการดำเนินการ เพื่อสนองความต้องการส่วนรวมของประชาชนในท้องที่นั้น โดยจัดเป็นองค์กรในรูปแบบต่าง ๆ คือ องค์การบริหารส่วนจังหวัด เทศบาล องค์การบริหารส่วนตำบล และรูปแบบอื่นที่มีกฎหมายจัดตั้งขึ้นเป็นการเฉพาะ เช่น กรุงเทพมหานคร เมืองพัทยา\r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. องค์กรปกครองส่วนท้องถิ่น. 18 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 18,
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "องค์ความรู้",
    meaning:
      "ความรู้ซึ่งได้มาจากการวิเคราะห์และสังเคราะห์ แล้วนำมาบูรณาการเข้าเป็นความรู้ในระดับที่สูงขึ้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. องค์ความรู้. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "เจตจำนง",
    meaning: "ความตั้งใจมุ่งหมาย, ความจงใจ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เจตจำนง. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "จ"
  },
  {
    keyword: "เจตนารมณ์",
    meaning: "ความมุ่งหมายและมักเป็นความมุ่งหมายในทางที่ดี",
    source:
      "สำนักงานราชบัณฑิตยสภา. เจตนารมณ์. 6 มิถุนายน 2562. http://www.royin.go.th/?knowledges=%E0%B9%80%E0%B8%88%E0%B8%95%E0%B8%99%E0%B8%B2-%E0%B9%80%E0%B8%88%E0%B8%95%E0%B8%99%E0%B8%B2%E0%B8%A3%E0%B8%A1%E0%B8%93%E0%B9%8C-%E0%B9%92%E0%B9%99-%E0%B8%A1%E0%B8%B5%E0%B8%99%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "ราชบัณฑิตฯ",
    firstalpha: "จ"
  },
  {
    keyword: "เอกภาพ",
    meaning: "ความเป็นอันหนึ่งอันเดียวกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เอกภาพ. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "ไต่สวน",
    meaning: "สอบสวนข้อเท็จจริงเพื่อวินิจฉัยว่าถูกต้องหรือไม่",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ไต่สวน. 19 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ต"
  },
  {
    keyword: "การปฏิวัติ",
    meaning:
      "การเปลี่ยนแปลงระบบ เช่น ปฏิวัติอุตสาหกรรม, การเปลี่ยนแปลงระบอบการบริหารบ้านเมือง เช่น ปฏิวัติการปกครอง",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ปฏิวัติ. 20 พฤศจิกายน 2562 \r\nhttp://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ก"
  },
  {
    keyword: "การลงมติ",
    meaning: "ลงความเห็นร่วมกันอย่างใดอย่างหนึ่ง.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ลงมติ. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ก"
  },
  {
    keyword: "ขนบธรรมเนียม",
    meaning: "แบบอย่างที่นิยมกันมา",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ขนบธรรมเนียม. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ข"
  },
  {
    keyword: "ความลักลั่น",
    meaning:
      "ขาดความเป็นระเบียบทำให้เกิดเหลื่อมล้ำไม่เป็นไปตามกฎตามแบบตามลำดับ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ค"
  },
  {
    keyword: "ค่านิยม",
    meaning:
      "สิ่งที่สังคมถือว่ามีค่าพึงปราถนาต้องการให้เป็นเป้าหมายของสังคมและปลูกฝังให้สมาชิกของสังคมยึดถือเป็นเป้าหมายในการดำเนินชีวิต",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. ค่านิยม. 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/ ",
    sappear: 3,
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ค"
  },
  {
    keyword: "จรรยาบรรณ",
    meaning:
      "ประมวลความประพฤติที่ผู้ประกอบอาชีพการงานแต่ละอย่างกำหนดขึ้น เพื่อรักษาและส่งเสริมเกียรติคุณชื่อเสียงและฐานะของสมาชิก อาจเขียนเป็นลายลักษณ์อักษรหรือไม่ก็ได้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. จรรยาบรรณ. 21 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "จ"
  },
  {
    keyword: "จารีตประเพณี",
    meaning:
      "จารีตประเพณี คือประเพณีที่สังคมถือว่าถ้าใครในสังคมฝ่าฝืนหรืองดเว้นไม่กระทำตาม ถือว่าเป็นความผิดความชั่วจารีตประเพณีเป็นจรรยาและศีลธรรมของสังคม ",
    source:
      "สำนักงานราชบัณฑิตยสภา. ประเพณี. 30 สิงหาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%\r\n9E%E0%B8%93%E0%B8%B5-%E0%B9%92%E0%B9%91-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%\r\nB8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%94",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "จ"
  },
  {
    keyword: "ชาติพันธุ์",
    meaning:
      "กลุ่มที่มีพันธะเกี่ยวข้องกัน และที่แสดงเอกลักษณ์ออกมา โดยการผูกพันลักษณาการของเชื้อชาติและสัญชาติเข้าด้วยกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2542. ชาติพันธุ์. 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ช"
  },
  {
    keyword: "นโยบาย",
    meaning: "หลักและวิธีปฏิบัติซึ่งถือเป็นแนวดำเนินการ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. นโยบาย. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "น"
  },
  {
    keyword: "นิติบุคคล",
    meaning:
      "นิติบุคคล หมายถึง กลุ่มบุคคล องค์กร หรือทรัพย์สินที่จัดสรรไว้เป็นกองทุนเพื่อดำเนินกิจการอันใดอันหนึ่ง ซึ่งกฎหมายบัญญัติให้เป็นบุคคลอีกประเภทหนึ่งที่มิใช่บุคคลธรรมดา นิติบุคคลจะมีขึ้นได้ก็แต่ด้วยอาศัยอำนาจแห่งประมวลกฎหมายแพ่งและพาณิชย์หรือกฎหมายอื่น นิติบุคคลย่อมมีสิทธิและหน้าที่ตามบทบัญญัติแห่งประมวลกฎหมายแพ่งและพาณิชย์หรือกฎหมายอื่น ภายในขอบแห่งอำนาจหน้าที่หรือวัตถุประสงค์ดังได้บัญญัติหรือกำหนดไว้ในกฎหมาย ข้อบังคับ หรือตราสารจัดตั้ง นอกจากนั้น นิติบุคคลย่อมมีสิทธิและหน้าที่เช่นเดียวกับบุคคลธรรมดา เว้นแต่สิทธิและหน้าที่ซึ่งโดยสภาพจะพึงมีพึงเป็นได้เฉพาะแก่บุคคลธรรมดาเท่านั้น เช่น กระทรวง ทบวง กรม องค์การบริหารส่วนจังหวัด เทศบาล องค์การบริหารส่วนตำบล กรุงเทพมหานคร เมืองพัทยา",
    source:
      "สำนักราชบัณฑิตยสภา. บุคคล/บุคคลธรรมดา/นิติบุคคล. 25 มิถุนายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%94%E0%B8%B2%E0%B8%99%E0%B8%B4%E0%B8%95%E0%B8%B4%E0%B8%9A%E0%B8%B8e",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "น"
  },
  {
    keyword: "นิติสัมพันธ์",
    meaning: "ความเกี่ยวพันทางกฎหมาย",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554 นิติสัมพันธ์. 20 พฤศจิกายน 2562. \r\nhttp://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "ราชบัณฑิตฯ",
    firstalpha: "น"
  },
  {
    keyword: "บรรทัดฐาน",
    meaning: "แบบแผนสำหรับยึดถือเป็นแนวทางปฏิบัติ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บรรทัดฐาน. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "บ"
  },
  {
    keyword: "ประชามติ",
    meaning:
      "1. มติของประชาชนส่วนใหญ่ในประเทศที่แสดงออกในเรื่องใดเรื่องหนึ่งหรือที่ใดที่หนึ่ง\r\n2. มติของประชาชนที่รัฐให้สิทธิออกเสียงลงคะแนนรับรองร่างกฎหมายสำคัญที่ได้ผ่านสภานิติบัญญัติแล้ว หรือให้ตัดสินในปัญหาสำคัญในการบริหารประเทศ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประชามติ. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "ประนีประนอม",
    meaning: "ผ่อนหนักผ่อนเบาให้แก่กัน, ปรองดองกัน, อะลุ้มอล่วยกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประนีประนอม. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "ประสิทธิภาพ",
    meaning: "ความสามารถที่ทำให้เกิดผลในการงาน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประสิทธิภาพ. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "พระบรมราชโองการ",
    meaning:
      "คำสั่งราชการของพระมหากษัตริย์หรือพระบาทสมเด็จพระเจ้าอยู่หัวฯ เรียกว่า พระบรมราชโองการ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พระบรมราชโองการ. 5 มิถุนายน 2562. \r\nhttp://www.royin.go.th/?knowledges=%E0%B8%9A%E0%B8%A3%E0%B8%A1-%E0%B9%92%E0%B9%94-%E0%B8%A1%E0%B8%B5%E0%B8%99%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%90",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "พ"
  },
  {
    keyword: "พระราชบัญญัติ",
    meaning:
      "รูปแบบของกฎหมายที่พระมหากษัตริย์ทรงตราขึ้นโดยคำแนะนำและยินยอมของฝ่ายนิติบัญญัติ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พระราชบัญญัติ. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "พ"
  },
  {
    keyword: "พสกนิกร",
    meaning:
      "คนที่อยู่ในประเทศ ไม่ว่าจะเป็นพลเมืองของประเทศนั้นหรือคนต่างด้าวที่มาอาศัยอยู่ก็ตาม",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พสกนิกร. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "พ"
  },
  {
    keyword: "พันธมิตร",
    meaning:
      "ความสัมพันธ์ระหว่างรัฐที่จะช่วยเหลือกันตามสนธิสัญญาที่ทำไว้ เพื่อร่วมรบหรือเพื่อการป้องกันร่วมกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. พันธมิตร. 25 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "พ"
  },
  {
    keyword: "ภาวะฉุกเฉิน",
    meaning:
      "ภาวะอันอาจเป็นภัยต่อความมั่นคงหรือความปลอดภัยแห่งราชอาณาจักร หรืออันอาจทำให้ประเทศตกอยู่ในภาวะคับขันหรือภาวการณ์รบหรือการสงคราม\r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ภาวะฉุกเฉิน. 19 สิงหาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ภ"
  },
  {
    keyword: "มหาอำนาจ",
    meaning:
      "เรียกประเทศที่มีพลังทางด้านเศรษฐกิจหรือทางทหารสูง ว่า ประเทศมหาอำนาจ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. มหาอำนาจ. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ม"
  },
  {
    keyword: "รัฐธรรมนูญ",
    meaning:
      "บทกฎหมายสูงสุดที่จัดระเบียบการปกครองประเทศ กำหนดรูปแบบและระบอบการปกครองของประเทศ สิทธิ เสรีภาพ และหน้าที่ของประชาชน อำนาจหน้าที่ขององค์กร และความสัมพันธ์ระหว่างองค์กร",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. รัฐธรรมนูญ. 20 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ร"
  },
  {
    keyword: "รัฐประหาร",
    meaning: "หมายถึงการใช้กำลังเปลี่ยนแปลงคณะรัฐบาลโดยฉับพลัน ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. รัฐประหาร. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ร"
  },
  {
    keyword: "ราชการส่วนกลาง",
    meaning:
      "การปกครอง ดูแล และการปฏิบัติภารกิจของรัฐในฐานะเป็นศูนย์กลางของการบริหารราชการแผ่นดิน โดยจัดแบ่งองค์กรในการปฏิบัติหน้าที่เป็นสำนักนายกรัฐมนตรี กระทรวง ทบวง กรม หรือส่วนราชการที่เรียกชื่ออย่างอื่นและมีฐานะเป็นกรม เช่น ราชบัณฑิตยสถาน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ราชการส่วนกลาง. 17 กันยายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ร"
  },
  {
    keyword: "ราชการส่วนท้องถิ่น",
    meaning:
      "การปกครอง ดูแล จัดการ และการให้บริการของรัฐ ที่รัฐกระจายอำนาจให้ประชาชนในท้องถิ่นเข้ามามีส่วนในการดำเนินการ เพื่อสนองความต้องการส่วนรวมของประชาชนในท้องที่นั้น โดยจัดเป็นองค์กรในรูปแบบต่าง ๆ คือ องค์การบริหารส่วนจังหวัด เทศบาล องค์การบริหารส่วนตำบล และรูปแบบอื่นที่มีกฎหมายจัดตั้งขึ้นเป็นการเฉพาะ เช่น กรุงเทพมหานคร เมืองพัทยา",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ราชการส่วนท้องถิ่น,17 กันยายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ร"
  },
  {
    keyword: "ราชการส่วนภูมิภาค",
    meaning:
      "การปกครอง ดูแล จัดการ และการปฏิบัติภารกิจของรัฐ ที่แยกไปดำเนินงานในพื้นที่นอกเขตนครหลวง เพื่ออำนวยความสะดวกแก่ประชาชนในท้องที่ในฐานะตัวแทนของราชการบริหารส่วนกลาง โดยแบ่งเขตการดำเนินงานออกเป็น จังหวัด อำเภอ ตำบล และหมู่บ้าน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ราชการส่วนภูมิภาค.17 กันยายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ร"
  },
  {
    keyword: "ราชกิจจานุเบกษา",
    meaning:
      "สิ่งพิมพ์ของทางราชการที่จัดให้มีขึ้นเป็นการเฉพาะเพื่อเป็นที่ประกาศข้อมูลข่าวสารของทางราชการที่ประสงค์จะให้ประชาชนได้ทราบ เช่น กฎหมาย ประกาศคนล้มละลาย การจัดตั้งห้างหุ่นส่วนบริษัท\r\n     ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ราชกิจจานุเบกษา. 16 กันยายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ร"
  },
  {
    keyword: "ล้มละลาย",
    meaning: "สิ้นเนื้อประดาตัว, หมดทรัพย์สมบัติของตัว\r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ล้มละลาย. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/\r\n",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ล"
  },
  {
    keyword: "วิจารณญาณ",
    meaning: "ปัญญาที่สามารถรู้หรือให้เหตุผลที่ถูกต้องได้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "วินิจฉัย",
    meaning: "ตัดสิน, ชี้ขาด,ไตร่ตรอง, ใคร่ครวญ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วินิจฉัย. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "สภาวการณ์",
    meaning: "เหตุการณ์ที่เป็นไปตามธรรมชาติ ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สภาวการณ์. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "อำนาจอธิปไตย",
    meaning: "อำนาจสูงสุดของรัฐที่จะใช้บังคับบัญชาภายในอาณาเขตของตน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. อำนาจอธิปไตย. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "อุบัติภัย",
    meaning: "ภัยที่เกิดจากอุบัติเหตุ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554 อุบัติภัย. 20 สิงหาคม 2562 \r\nhttp://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "การบริการใหม่ที่เป็นพลวัต",
    meaning:
      "การบริการใหม่ที่ไม่หยุดนิ่งอยู่กับที่ และมีความสามารถเคลื่อนที่ไปข้างหน้าด้วยพลังในตัวเอง",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2555). พลวัต. 18 ตุลาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%9E%E0%B8%A5%E0%B8%A7%E0%B8%B1%E0%B8%95-%E0%B9%96-%E0%B8%AA%E0%B8%B4%E0%B8%87%E0%B8%AB%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%95",
    sappear: "",
    mappear: 20,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ก"
  },
  {
    keyword: "คมนาคม",
    meaning: "การติดต่อไปมาถึงกัน, การสื่อสาร",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. คมนาคม. 17 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: 18,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ค"
  },
  {
    keyword: "ความชอบธรรม",
    meaning: " ถูกตามหลักธรรม, ถูกตามนิตินัย.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ชอบธรรม. \r\n22 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ค"
  },
  {
    keyword: "ทวิภาคี",
    meaning:
      "2 ฝ่าย,เรียกสัญญาระหว่างประเทศที่มีคู่สัญญา 2 ฝ่าย ว่า สัญญาทวิภาคี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ทวิภาคี. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: 2,
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ท"
  },
  {
    keyword: "ประสิทธิผล",
    meaning: "ผลสำเร็จ, ผลที่เกิดขึ้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประสิทธิผล. 22 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: "1,2",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "ผลสัมฤทธิ์",
    meaning: "ความสำเร็จ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สัมฤทธิ์. 22 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ผ"
  },
  {
    keyword: "ฝ่ายตุลาการ",
    meaning: "ผู้มีอำนาจและหน้าที่ในการพิจารณาพิพากษาอรรถคดี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ตุลาการ. 22 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ฝ"
  },
  {
    keyword: "รูปธรรม",
    meaning:
      "1. สิ่งที่รู้ได้ทางตา หู จมูก ลิ้น กาย อันได้แก่ รูป เสียง กลิ่น รส และสิ่งที่สามารถสัมผัสได้ด้วยกาย, คู่กับ นามธรรม คือสิ่งที่รู้ได้เฉพาะทางใจเท่านั้น\r\n2. สิ่งที่สามารถแสดงออกมาให้ปรากฏเป็นจริงเป็นจังมิใช่เป็นเพียงทฤษฎีเท่านั้น, สิ่งที่สามารถปฏิบัติได้, เช่น ต้องทำโครงการพัฒนาชนบทให้เป็นรูปธรรมด้วยการจัดให้มีนํ้ากินนํ้าใช้เป็นต้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. รูปธรรม. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ร"
  },
  {
    keyword: "สัตยาบัน",
    meaning:
      "การยืนยันรับรองความตกลงระหว่างประเทศที่ได้กระทำขึ้นไว้ การรับรองนิติกรรมที่เป็นโมฆียะอันเป็นผลให้นิติกรรมนั้นสมบูรณ์มาแต่เริ่มแรก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สัตยาบัน. 22 ตุลาคม 2562. http://www.royin.go.th/dictionar  ",
    sappear: "",
    mappear: "",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "สาธารณูปโภคพื้นฐาน",
    meaning:
      "บริการสาธารณะที่จัดทำเพื่ออำนวยประโยชน์แก่ประชาชนในสิ่งอุปโภคที่จำเป็นต่อการดำเนินชีวิต",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. สาธารณูปโภค. 25 ตุลาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ส"
  },
  {
    keyword: "transaction",
    meaning: "การประกอบกิจกรรมอย่างใดอย่างหนึ่ง โดยเฉพาะด้านธุรกิจและการเงิน ",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2550). ธุรการและธุรกรรมมีความหมายต่างกัน, 4 ธันวาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%98%E0%B8%B8%E0%B8%A3%E0%B8%81%E0%B8%B2%E0%B8%A3-%E0%B9%81%E0%B8%A5%E0%B8%B0-%E0%B8%98%E0%B8%B8%E0%B8%A3%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1-%E0%B8%A1%E0%B8%B5%E0%B8%84%E0%B8%A7%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 8,
    type: "ราชบัณฑิตฯ",
    firstalpha: "t"
  },
  {
    keyword: "เชื้อเพลิงสะอาด",
    meaning:
      "พลังงานหมุนเวียนเป็นพลังงานที่สะอาด  ไม่มีผลกระทบต่อสิ่งแวดล้อม  และเป็นพลังงานที่หาง่ายมีอยู่ทั่วไปในท้องถิ่น  พลังงานหมุนเวียนมีข้อดีคือช่วยลดมลพิษเนื่องจากการผลิตไฟฟ้าจากเชื้อเพลิง   ช่วยลดการนำเข้าน้ำมันจากต่างประเทศ  ลดปริมาณก๊าซเรือนกระจกซึ่งทำให้เกิดภาวะโลกร้อน  ส่งเสริมให้ชุมชนหรือเอกชนสามารถผลิตพลังงานเอง  เช่นการผลิตไฟฟ้าจากพลังงานแสงอาทิตย์  พลังงานไฟฟ้าจากน้ำตก  เป็นต้น",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2556). พลังงานหมุนเวียน, 4 ธันวาคม 2562.\r\nhttp://www.royin.go.th/?knowledges=%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%AB%E0%B8%A1%E0%B8%B8%E0%B8%99%E0%B9%80%E0%B8%A7%E0%B8%B5%E0%B8%A2%E0%B8%99-%E0%B9%91%E0%B9%96-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ช"
  },
  {
    keyword: "บริการอนามัย",
    meaning: "การบริการเกี่ยวกับสุขภาพ ที่ถูกสุขลักษณะ",
    source:
      "สำนักงานราชบัณฑิตยสถาน. (2556). อนามัย, 12 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%AD%E0%B8%99%E0%B8%B2%E0%B8%A1%E0%B8%B1%E0%B8%A2-%E0%B9%91%E0%B9%93-%E0%B8%9E%E0%B8%A4%E0%B8%A9%E0%B8%A0%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: "",
    mappear: 13,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "บ"
  },
  {
    keyword: "บริบท",
    meaning:
      "คำ ข้อความ หรือสถานการณ์แวดล้อมเพื่อช่วยให้เข้าใจความหมายของภาษาหรือของถ้อยคำ, ปริบท ก็ว่า.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บริบท, 21 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "บ"
  },
  {
    keyword: "ประกาศเจตนารมณ์",
    meaning: "การประกาศความมุ่งหมายและมักเป็นความมุ่งหมายในทางที่ดี ",
    source:
      "สำนักงานราชบัณฑิตยสถาน. (2550). เจตนา – เจตนารมณ์, 12 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B9%80%E0%B8%88%E0%B8%95%E0%B8%99%E0%B8%B2-%E0%B9%80%E0%B8%88%E0%B8%95%E0%B8%99%E0%B8%B2%E0%B8%A3%E0%B8%A1%E0%B8%93%E0%B9%8C-%E0%B9%92%E0%B9%99-%E0%B8%A1%E0%B8%B5%E0%B8%99%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "ประกาศอุดมการณ์",
    meaning:
      "ประกาศหลักการที่วางระเบียบไว้เป็นแนวปฏิบัติเพื่อให้บรรลุเป้าหมายที่กำหนดไว้",
    source:
      "สำนักงานราชบัณฑิตยสถาน. (2556). อุดมการณ์, 11 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%AD%E0%B8%B8%E0%B8%94%E0%B8%A1%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B9%8C-%E0%B9%97-%E0%B8%9E%E0%B8%A4%E0%B8%A9%E0%B8%A0%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "ประทานบัตร",
    meaning:
      "หนังสือสำคัญที่ออกให้ตามกฎหมายว่าด้วยแร่ เพื่อให้มีสิทธิทำเหมืองแร่ภายในเขตที่กำหนดในหนังสือสำคัญนั้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประทานบัตร. 18 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 2,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ป"
  },
  {
    keyword: "พลเมืองที่ดี",
    meaning:
      "ตระหนักถึงสิทธิของตนเองและต้องทำหน้าที่ที่กฎหมายรัฐธรรมนูญกำหนดด้วย เช่น เสียภาษีให้รัฐ  อนุรักษ์ทรัพยากรธรรมชาติและสิ่งแวดล้อม.",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2556). พลเมือง, 30 กันยายน 2562.\r\nhttp://www.royin.go.th/?knowledges=%E0%B8%9E%E0%B8%A5%E0%B9%80%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%87-%E0%B9%93%E0%B9%91-%E0%B8%98%E0%B8%B1%E0%B8%99%E0%B8%A7%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: 3,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "พ"
  },
  {
    keyword: "ภูมิปัญญา",
    meaning: "พื้นความรู้ความสามารถ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ภูมิปัญญา , \r\n5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "3,4",
    mappear: "15,16",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ภ"
  },
  {
    keyword: "ยกระดับกระบวนทัศน์",
    meaning:
      "ยกระดับระบบคิด วิธีคิด หรือแบบของการคิดที่ใช้เป็นแนวในการศึกษาวิจัยเรื่องใดเรื่องหนึ่ง หรือเป็นแนวในการจัดระบบในสังคม",
    source:
      "สำนักงานราชบัณฑิตยสถาน. (2550). กระบวนทัศน์, 11 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%81%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%A7%E0%B8%99%E0%B8%97%E0%B8%B1%E0%B8%A8%E0%B8%99%E0%B9%8C-%E0%B9%91%E0%B9%98-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ย"
  },
  {
    keyword: "ยุทโธปกรณ์",
    meaning:
      "วัสดุอุปกรณ์ทั้งปวงและยุทธภัณฑ์ทุกชนิดซึ่งใช้ในราชการทหาร รวมทั้งเครื่องมือยานยนต์ ชิ้นส่วนอะไหล่สาธารณูปโภคอันจำเป็นเพื่อปฏิบัติการรบหรือเพื่อดำรงและสนับสนุนกิจกรรมทางทหารโดยไม่คำนึงถึงว่าจะมีความมุ่งหมายทางธุรการหรือทางการรบ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ยุทโธปกรณ์ , 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: "",
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ย"
  },
  {
    keyword: "วัฏจักร ",
    meaning:
      "ช่วงระยะเวลาของเหตุการณ์หรือกิจกรรมชุดหนึ่ง ซึ่งเกิดขึ้นและดำเนินติดต่อกันไปอย่างมีระเบียบจนจบลง ณ จุดเริ่มต้นนั้นอีก เช่น วัฏจักรแห่งฤดูกาล วัฏจักรแห่งพืช.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วัฏจักร, 21 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "วิสามัญฆาตกรรม",
    meaning:
      "การสังหารชีวิตผู้กระทำผิดกฎหมายอาญาร้ายแรง โดยเจ้าพนักงานไม่มีเจตนาที่จะฆ่าผู้กระทำความผิด เพียงแต่ใช้สิทธิในการป้องกันตนเองเนื่องจากผู้กระทำผิดขัดขืนการจับกุมด้วยการใช้อาวุธร้ายแรงซึ่งอาจเป็นอันตรายต่อเจ้าพนักงานหรือผู้บริสุทธิ์ได้",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2554). วิสามัญฆาตกรรม, 26 กันยายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%A7%E0%B8%B4%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%B1%E0%B8%8D%E0%B8%86%E0%B8%B2%E0%B8%95%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1-%E0%B9%92%E0%B9%90-%E0%B8%A1%E0%B8%B5%E0%B8%99%E0%B8%B2%E0%B8%84%E0%B8%A1",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ว"
  },
  {
    keyword: "หลักประชามติ",
    meaning:
      "(๑) มติของประชาชนส่วนใหญ่ในประเทศที่แสดงออกในเรื่องใดเรื่องหนึ่งหรือที่ใดที่หนึ่ง (Plebiscite)\r\n(๒) มติประชาชนที่รัฐให้สิทธิออกเสียงลงคะแนนรับรองร่างกฎหมายที่สำคัญที่ได้ผ่านสภานิติบัญญัติแล้ว หรือให้ตัดสินในปัญหาที่สำคัญในการบริหารประเทศ (Referendum) \r\n \r\n \r\n \r\n \r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประชามติ, 17 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ห"
  },
  {
    keyword: "หลักปรัชญาเศรษฐกิจพอเพียง",
    meaning:
      "ปรัชญาที่พระบาทสมเด็จพระเจ้าอยู่หัวพระราชทานเป็นแนวทางการดำรงชีวิตและปฏิบัติตนของประชาชนตั้งแต่ระดับครอบครัว ระดับชุมชน จนถึงระดับรัฐ ให้ดำเนินไปในทางสายกลาง ไม่ประมาท ไม่โลภ ไม่เบียดเบียนผู้อื่น คำนึงถึงความพอประมาณ ความมีเหตุผล มีภูมิคุ้มกันในตัว ตลอดจนใช้ความรู้และคุณธรรม เป็นพื้นฐานในการดำรงชีวิตให้รอดพ้นจากวิกฤติ มีความมั่นคงและยั่งยืนท่ามกลางกระแสโลกาภิวัตน์และความเปลี่ยนแปลงต่าง ๆ.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เศรษฐกิจพอเพียง, 17 มิถุนายน 2562.\r\nhttp://www.royin.go.th/dictionary/",
    sappear: "4,5",
    mappear: "1,15,16,19",
    rappear: 2,
    type: "ราชบัณฑิตฯ",
    firstalpha: "ห"
  },
  {
    keyword: "อิเล็กทรอนิกส์",
    meaning:
      "วิทยาศาสตร์กายภาพแขนงหนึ่งที่นำมาประยุกต์ใช้กับการศึกษาวงจรไฟฟ้าที่ใช้สารกึ่งตัวนำและอุปกรณ์อื่น ๆ ซึ่งควบคุมการเคลื่อนที่ของอิเล็กตรอนได้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. อิเล็กทรอนิกส์, 21 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "ราชบัณฑิตฯ",
    firstalpha: "อ"
  },
  {
    keyword: "(GAT-PAT)",
    meaning:
      "การทดสอบเพื่อเข้าศึกษาต่อในระดับมหาวิทยาลัย ทั้งในระบบรับตรงและระบบแอดมิชชั่นกลาง ดังนี้\r\nGAT (General Aptitude Test) คือ การทดสอบวิชาความถนัดทั่วไป ประกอบด้วย 2 ส่วน ได้แก่\r\n- ส่วนที่ 1 ความสามารถในการอ่าน การเขียน การคิดเชิงวิเคราะห์ และการแก้โจทย์ปัญหา\r\n- ส่วนที่ 2 ความสามารถในการสื่อสารด้วยภาษาอังกฤษ\r\nPAT (Professional and Academic Aptitude Test) คือ การทดสอบวิชาความถนัดทางวิชาการและวิชาชีพเพื่อวัดความรู้พื้นฐานกับศักยภาพที่จะเรียนในวิชาชีพนั้น ๆ ให้ประสบความสำเร็จ 7 วิชา  ได้แก่ \r\nความถนัดทางคณิตศาสตร์ /ความถนัดทางวิทยาศาสตร์ /ความถนัดทางวิศวกรรมศาสตร์/ความถนัดทางสถาปัตยกรรมศาสตร์/ความถนัดทางวิชาชีพครู/ความถนัดทางศิลปกรรมศาสตร์/ความถนัดทางภาษาต่างประเทศ \r\n\r\n* เกณฑ์คะแนนการผ่านของแต่ละวิชาขึ้นอยู่กับการกำหนดของแต่ละคณะ/ภาควิชา และสถาบันการศึกษาที่แตกต่างกัน",
    source:
      "สถาบันทดสอบทางการศึกษาแห่งชาติ (องค์การมหาชน) กระทรวงศึกษาธิการ. (2558). GAT/PAT, 2 พฤษภาคม 2562. http://www.niets.or.th/th/catalog/view/234 \r\n\r\n",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "(O–NET)",
    meaning:
      "Ordinary National Education(O-net) คือ การทดสอบทางการศึกษาระดับชาติขั้นพื้นฐาน  เป็นการทดสอบเพื่อวัดความรู้และความคิดของนักเรียนชั้นประถมศึกษาปีที่ 6 มัธยมศึกษาปีที่ 3 และมัธยมศึกษาปีที่ 6 โดยประเมินตามมาตรฐานการเรียนรู้ในหลักสูตรแกนกลางการศึกษาขั้นพื้นฐาน พ.ศ. 2551 เพื่อชี้วัดคุณภาพและมาตรฐานทางการศึกษาของประเทศ \r\nซึ่งข้อสอบ O-net ประกอบด้วย 8 วิชา โดยแต่ละวิชามีคะแนนเต็ม 100 คะแนน ประกอบด้วย\r\n1. วิชาภาษาไทย\r\n2. วิชาสังคมศึกษา\r\n3. วิชาภาษาอังกฤษ\r\n4. วิชาคณิตศาสตร์\r\n5. วิชาวิทยาศาสตร์ \r\n6. วิชาสุขศึกษาและพลศึกษา \r\n7. วิชาศิลปะ \r\n8. วิชาการงานอาชีพและเทคโนโลยี\r\nทั้งนี้ วิชาที่นำมาคำนวณคะแนนแอดมิชชั่นมีเพียง 5 วิชาแรกเท่านั้น",
    source:
      "สถาบันทดสอบทางการศึกษาแห่งชาติ (องค์การมหาชน) กระทรวงศึกษาธิการ. (2558). O-NET (Ordinary National Educational Test), 4 มิถุนายน 2562. http://www.niets.or.th/th/catalog/view/211",
    sappear: "",
    mappear: "",
    rappear: 1,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "ACMECS",
    meaning:
      "ยุทธศาสตร์ความร่วมมือทางเศรษฐกิจอิรวดี-เจ้าพระยา-แม่โขง (Ayeyawady-Chao Phraya-Mekong Economic Cooperation Strategy: ACMECS)  ประกอบด้วยประเทศสมาชิก 5 ประเทศ ได้แก่ กัมพูชา สาธารณรัฐประชาธิปไตยประชาชนลาว เมียนมา เวียดนาม และประเทศไทย เป็นกรอบความร่วมมือระดับอนุภูมิภาค โดยมีเป้าหมายหลักคือการส่งเสริมความร่วมมือทางเศรษฐกิจ เช่น การค้าการลงทุน การท่องเที่ยว และการเกษตร โดยไทยมีบทบาทนําในฐานะประเทศผู้ใหญ่ผ่านกลไก 2 หน่วยงาน คือ สํานักงานความร่วมมือพัฒนาเศรษฐกิจกับประเทศเพื่อนบ้าน (องค์กรมหาชน) หรือ NEDA และกรมความร่วมมือระหว่างประเทศ กระทรวงการต่างประเทศในการให้ความช่วยเหลือด้านโครงสร้างพื้นฐาน และด้านวิชาการ มุ่งเน้นการนำความเจริญไปสู่แนวชายแดน เพื่อปูทางไปสู่การค้าการลงทุนตามแนวชายแดน ซึ่งจะช่วยในการสร้างงาน สร้างรายได้และลดความเหลื่อมล้ำ/ ช่องว่างการพัฒนา",
    source:
      "กระทรวงการต่างประเทศ. ทำความรู้จัก ACMECS ความร่วมมือสามแม่น้ำ, 2 กันยายน 2562. http://www.mfa.go.th/main/th/information/8149/88649-%E0%B8%97%E0%B8%B3%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B8%B9%E0%B9%89-ACMECS-%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B9%88%E0%B8%A7%E0%B8%A1%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B9%81%E0%B8%A1%E0%B9%88%E0%B8%99%E0%B9%89%E0%B8%B3.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "Agenda - Based",
    meaning:
      "ภารกิจยุทธศาสตร์ แนวทางปฏิรูปภาครัฐ นโยบายเร่งด่วน หรือภารกิจที่ได้รับมอบหมายเป็นพิเศษ",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน. คู่มือการประเมินข้าราชการพลเรือนประเภทบริหารระดับสูง: สำหรับผู้รับการประเมิน, 25 กันยายน 2562. https://www.ocsc.go.th/sites/default/files/attachment/article/manual_guide_executive_.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "หน่วยงาน",
    firstalpha: "g"
  },
  {
    keyword: "Agri Map",
    meaning:
      "เครื่องมือแสดงผลข้อมูลเชิงภูมิสารสนเทศ พร้อมระบบแนะนำผลการปรับเปลี่ยนกิจกรรมการผลิตด้วยพืชทดแทน ในรูปแบบเว็บแผนที่แบบออนไลน์ ซึ่งอำนวยความสะดวกให้กับผู้ใช้งานสามารถใช้งานได้จากทุกที่ทุกเวลาผ่านทางระบบอินเตอร์เน็ต เพื่อให้ผู้ใช้งานสามารถใช้งานอย่างมีประสิทธิภาพ จึงขอแนะนำสิ่งที่ผู้ใช้ควรตรวจสอบก่อนเข้าใช้งาน",
    source:
      "กระทรวงเกษตรและสหกรณ์ (2559). ระบบแผนที่เกษตรเพื่อการบริหารจัดการเชิงรุกออนไลน์ (Agri-Map Online), 25 กันยายน 2562. http://agri-map-online.moac.go.th/static/file/agrimap-manual.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "g"
  },
  {
    keyword: "ASEAN",
    meaning:
      "จัดตั้งขึ้นตามปฏิญญากรุงเทพ (Bangkok Declaration) เมื่อวันที่ 8 สิงหาคม 2510 เพื่อร่วมมือและส่งเสริมสันติภาพ เสถียรภาพ ความเจริญทางเศรษฐกิจ ความก้าวหน้าทางสังคม วัฒนธรรม วิชาการ วิทยาศาสตร์และการบริหารในภูมิภาค โดยประกอบด้วยประเทศสมาชิก 10 ประเทศ คือ อินโดนิเซีย มาเลเซีย ฟิลิปปินส์ สิงคโปร์ ไทย บรูไนดารุสซาลาม เวียดนาม ลาว พม่า และกัมพูชา",
    source:
      "กรมอาเซียน กระทรวงการต่างประเทศ. ASEAN (Association of South-East Asian Nations), 2 กันยายน 2562.\r\nhttp://www.mfa.go.th/asean/th/code?code=asean",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "ASEAN single window",
    meaning:
      "ความตกลงว่าด้วยการอำนวยความสะดวกด้านศุลกากรด้วยระบบอิเล็กทรอนิกส์ ณ จุดเดียวของอาเซียน สืบเนื่องจากที่ประชุมรัฐมนตรีเศรษฐกิจอาเซียน ไดกำหนดแนวทางการพัฒนา “ASEAN Single Window” เพื่ออำนวยความสะดวกในทางการค้าระหว่างประเทศในการนำเข้า การสงออก การเคลื่อนย้ายสินค้าระหว่างกลุ่มประเทศอาเซียนให้สะดวกรวดเร็ว ลดต้นทุนการบริหารจัดการและการใช้ทรัพยากรต่างๆ",
    source:
      "กรมเจรจาการค้าระหว่างประเทศ. (2551). ความตกลงว่าด้วยการอำนวยความสะดวกด้านศุลกากรด้วย ระบบอิเล็กทรอนิกส์ ณ จุดเดียวของอาเซียน (ASEAN Single Window-ASW), 25 กันยายน 2562. http://www.thaifta.com/trade/script/vocab4_mar51.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "s"
  },
  {
    keyword: "ASEAN Standard",
    meaning:
      "เป็นการปรับมาตรฐานที่ใช้แตกต่างกันอยู่ในแต่ละประเทศให้สอดคล้องกับมาตรฐานที่ได้รับการยอมรับในระดับสากล",
    source:
      "สำนักงานมาตรฐานผลิตภัณฑ์อุตสาหกรรม (สมอ.) กระทรวงอุตสาหกรรม. ความร่วมมือกรอบอาเซียน, 16 ตุลาคม 2562. https://www.tisi.go.th/website/interstandard/asean",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "t"
  },
  {
    keyword: "B2B (Business to Business)",
    meaning:
      "การค้าระหว่างผู้ค้ากับหน่วยธุรกิจ แต่เป็นผู้ประกอบการครอบคลุมถึงการขายส่ง การทำการสั่งซื้อสินค้าผ่านทางระบบอิเล็กทรอนิกส์ ระบบห่วงโซ่การผลิต (Supply Chain Management) หรือเว็บไซต์ที่เป็นตัวกลางระหว่างผู้ที่ต้องการซื้อสินค้า/ บริการ กับผู้ให้บริการธุรกิจ รถเช่า ดำน้ำ สปาร์ กอล์ฟ สวนสนุก เป็นต้น",
    source:
      "กรมสรรพากร. ความรู้เกี่ยวกับอีคอมเมิร์ซ, 16 ตุลาคม 2562.  https://www.rd.go.th/publish/26228.0.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "u"
  },
  {
    keyword: "B2C (Business to Customer)",
    meaning:
      "การค้าระหว่างผู้ค้าโดยตรงถึงลูกค้าหรือผู้บริโภค เช่น เว็บไซต์ขายหนังสือออนไลน์ เน้นการขายหนังสือออนไลน์ หรือสื่อมัลติมีเดียทางการศึกษา โดยมีกลุ่มลูกค้าเป็นเด็ก นักเรียน นักศึกษา และบุคคลทั่วไป โดยการสั่งซื้อสินค้าจะทำผ่านระบบตะกร้าสินค้าอิเล็กทรอนิกส์ การชำระเงิน มีทางเลือกให้ลูกค้า เช่น โอนผ่านธนาคาร บัตรเครดิต ไปรษณีย์ธนาณัติ ในส่วนของการจัดส่งผ่านทางไปรษณีย์ หรือสามารถส่งแบบ Delivery ได้ด้วย เช่น ร้านค้าอิเล็กทรอนิกส์ ธนาคารอิเล็กทรอนิกส์ การขายอสังหาริมทรัพย์ เป็นต้น",
    source:
      "กรมสรรพากร. ความรู้เกี่ยวกับอีคอมเมิร์ซ, 16 ตุลาคม 2562. https://www.rd.go.th/publish/26228.0.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "u"
  },
  {
    keyword: "Benchmark",
    meaning:
      "Best-in-class คือเก่งที่สุดหรือดีที่อันจะเป็นต้นแบบที่จะใช้อ้างอิงเพื่อวัดหรือเปรียบเทียบ",
    source:
      "กรมตรวจบัญชีสหกรณ์. Benchmarking คืออะไร?, 25 กันยายน 2562. https://www.cad.go.th/ewtadmin/ewt/statistic/main.php?filename=news_25491117_2",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "Big Data",
    meaning:
      "ข้อมูลปริมาณมหาศาล และสามารถใช้อธิบายลักษณะของข้อมูลที่อยู่ใน\r\nรูปแบบที่หลากหลาย และมีที่มาจากแหล่งต่าง ๆ ทั้งจากระบบคอมพิวเตอร์ที่ใช้งานในองค์กรต่าง ๆ เครื่องจักร อุปกรณ์ที่ควบคุมด้วยระบบคอมพิวเตอร์ เซ็นเซอร์ต่าง ๆ ที่สร้างข้อมูลและจัดเก็บข้อมูล\r\nตลอดเวลาอย่างต่อเนื่อง",
    source:
      'สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2559). "Big Data" ในภาครัฐ, 28 สิงหาคม 2562. \r\nhttps://library2.parliament.go.th/ejournal/content_af/2559/dec2559-4.pdf',
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "หน่วยงาน",
    firstalpha: "i"
  },
  {
    keyword: "Coal Bed Methane (CBM)",
    meaning:
      "ก๊าซมีเทนในชั้นถ่านหิน (Coal Bed Methane) มีส่วนประกอบและนำมาใช้ประโยชน์ได้เช่นเดียวกับก๊าซมีเทนในก๊าซธรรมชาติ แต่ต่างกันที่พบอยู่ในชั้นถ่านหิน ก๊าซมีเทนที่เกิดขึ้นจะสะสมตัวในลักษณะละลายอยู่ในชั้นน้ำ และแทรกซึมอยู่ในรอยแตกในชั้นถ่านหิน การนำก๊าซมีเทนมาใช้ประโยชน์จะต้องสูบน้ำออกจากหลุมผลิตให้ความกดดันในหลุมผลิตลดลงมากที่สุด เพื่อให้ก๊าซมีเทนซึ่งมีความดันต่ำไหลออกมาได้ ",
    source:
      "กรมเชื้อเพลิงธรรมชาติ กระทรวงพลังงาน. (2561). ก๊าซธรรมชาติ คอนเดนเสท LPG LNG CNG LCNG ก๊าซมีเทนในชั้นถ่านหิน ก๊าซโซฮอล์ และไบโอดีเซล คืออะไร, 26 กันยายน 2562. https://dmf.go.th/public/list/data/detail/id/11261/menu/604/page/2",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Collective Action Coalition against Corruption : CAC",
    meaning: "โครงการแนวร่วมปฏิบัติของภาคเอกชนไทยในการต่อต้านทุจริต",
    source:
      "สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์. การทุจริตคอรัปชัน (Anti-corruption), 26 กันยายน 2562. https://www.sec.or.th/cgthailand/TH/Pages/corruption.aspx",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Common KPIs",
    meaning:
      "กลุ่มตัวชี้วัดร่วมกำหนดขึ้นโดยฝ่ายวางแผนและประเมินทรัพยากรบุคคล พิจารณาร่วมกับคณะทำงานปรับปรุงและกำหนดตัวชี้วัดผลการปฏิบัติงานของพนักงานรายบุคคลทุกระดับชั้น เพื่อให้ตัวชี้วัดผลการปฏิบัติงานของพนักงานสอดคล้องกับยุทธศาสตร์ และเป้าหมายขององค์กร",
    source:
      "การประปาส่วนภูมิภาค. คู่มือมาตรฐานตัวชี้วัด (KPIs Dictionary), 26 กันยายน 2562. http://www.oic.go.th/FILEWEB/CABINFOCENTER20/DRAWER038/GENERAL/DATA0000/00000096.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Competency",
    meaning:
      "กลุ่มของทักษะ ความรู้ ความสามารถ รวมทั้งพฤติกรรม คุณลักษณะและทัศนคติที่บุคลากรจำเป็นต้องมีเพื่อปฏิบัติงานอย่างมีประสิทธิภาพ ประสิทธิผล และเพื่อให้บรรลุผลสำเร็จตรงตามวัตถุประสงค์และเป้าหมายขององค์กร",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน. การพัฒนาสมรรถนะหลัก (สําหรับข้าราชการใหม่), 29 สิงหาคม 2562. https://www.ocsc.go.th/sites/default/files/attachment/page/aptitude_development.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Computer Literacy",
    meaning: "การรู้คอมพิวเตอร์ขั้นพื้นฐาน",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.). 4 ด้านของการรู้สารสนเทศ (information literacy), 26 กันยายน 2562. https://www.nstda.or.th/th/nstda-knowledge/2843-4-facets-of-information-literacy",
    sappear: "",
    mappear: "",
    rappear: 9,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Cyber Security",
    meaning:
      "ความมั่นคงปลอดภัยไซเบอร์ คือ กระบวนการหรือการกระทำทั้งหมดที่จำเป็นเพื่อทำให้องค์กรปราศจากความเสี่ยง และความเสียหายที่มีผลต่อความปลอดภัยของข้อมูลข่าวสาร (Information) ในทุกรูปแบบ รวมถึงการระวังป้องกันต่อการอาชญากรรม การโจมตี การบ่อนทำลาย การจารกรรม และความผดพลาดต่างๆ โดยควรคำนึงถึงองค์ประกอบพื้นฐานของความปลอดภัยของข้อมูล หรือ CIA 3 ประการ ได้แก่ การรักษาความลับของข้อมูล (Confidentiality) การรักษาความคงสภาพของข้อมูลหรือความสมบูรณ์ของข้อมูล (Integrity) และความพร้อมใช้งานของข้อมูล (Availability)",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). ความมั่นคงปลอดภัยทางไซเบอร์ (Cyber Security), 26 กันยายน 2562. https://dga.or.th/upload/download/file_769c60982e4c374dcd33b41c29227a31.pdf",
    sappear: "",
    mappear: "",
    rappear: 8,
    type: "หน่วยงาน",
    firstalpha: "y"
  },
  {
    keyword: "Deep Water",
    meaning: "น้ำชั้นล่างมีอุณหภูมิต่ำ ความเค็มและความหนาแน่นสูงมาก",
    source:
      "ศูนย์การเรียนรู้วิทยาศาสตร์โลกและดาราศาสตร์. น้ำทะเล, 3 ตุลาคม 2562. https://sites.google.com/a/lesa.biz/www/earth/hydrosphere/sea-water",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "Distributed Energy Resources",
    meaning: "แหล่งพลังงานทางเลือกสะอาดที่กระจายอยู่ทั่วไป",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.). (2557).  ระบบโครงข่ายไฟฟ้าอัจฉริยะ : From Smart Grid to Smart Cities, 26 กันยายน 2562. http://www2.mtec.or.th/eventnstda/Template/index.aspx?EventID=S14069&ContentID=2165",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "หน่วยงาน",
    firstalpha: "i"
  },
  {
    keyword: "Earned Income",
    meaning:
      "เงินได้เนื่องจากการทำงาน เป็นเงินได้ประเภทที่เป็นค่าตอบแทน หรือจากการใช้น้ำพักน้ำแรงจากการทำงานหรือประกอบสัมมาชีพ ",
    source:
      "สำนักงานเศรษฐกิจการคลัง. (2557). เงินโอน แก้จน คนขยัน, 3 ตุลาคม 2562. http://www.fpo.go.th/main/getattachment/General-information-public-service/FPO-symposium/8515/NIT_Symposium_Benge_25-7-57.pdf.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "a"
  },
  {
    keyword: "Eastern Seaboard",
    meaning:
      'โครงการพัฒนาพื้นที่บริเวณชายฝั่งทะเลตะวันออก (Eastern Seaboard Development Program : ESB) หรือที่ทุกคนเรียกว่า "Eastern Seaboard" ซึ่งเป็นการพัฒนาพื้นที่บริเวณภาคตะวันออกของไทย 3 จังหวัดนั้นคือ 1) แหลมฉบัง จังหวัดชลบุรี 2) มาบตาพุด จังหวัดระยอง และ3) จังหวัดฉะเชิงเทรา เป็นการเปลี่ยนแปลงจากอุตสาหกรรมเบามาเป็นอุตสาหกรรมหนัก ',
    source:
      "หน่วยวิเคราะห์เศรษฐกิจมหภาคในประเทศ ส่วนเศรษฐกิจมหภาคศูนย์วิจัยเศรษฐกิจ ธุรกิจและเศรษฐกิจฐานราก. (2561).  EEC ภาคต่อ Eastern Seaboard ก้าวสำคัญการลงทุนไทย, 2 กันยายน 2562. https://www.gsb.or.th/getattachment/a7529f4e-ae04-44cd-9d50-e2bf9588bd7f/14MC_hotissue_internet_EEC_ex.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "a"
  },
  {
    keyword: "e-government",
    meaning:
      "รัฐบาลอิเล็กทรอนิกส์ เป็นการนำเทคโนโลยีสารสนเทศ ฮาร์ดแวร์ หรือซอฟต์แวร์เข้ามามีส่วนช่วยในการพัฒนารัฐบาลอิเล็กทรอนิกส์ เพื่อลดช่องว่าง ลดความเหลื่อมล้ำทางสังคม ซึ่งเป็นการยกเลิกวิธีปฏิบัติงานแบบเดิมที่เป็นอุปสรรคในการทำงาน การปฏิรูประบบการปฏิบัติงานภาครัฐเพื่อให้บรรลุเป้าหมายอย่างมีประสิทธิภาพ",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). รายงานการศึกษาและการยกระดับ UN e - Government Readiness Ranking 2012, 30 กันยายน 2562. http://old.ega.or.th/Content.aspx?c_id=399",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "e-logistics",
    meaning:
      "กระบวนการทำงานที่เกี่ยวข้องกับการวางแผนการดำเนินการ และการควบคุมการทำงานขององค์กร รวมทั้งการบริหารจัดการข้อมูลและธุรกรรมทางการเงินที่เกี่ยวข้องให้เกิดการเคลื่อนย้าย การจัดเก็บ การรวบรวม การกระจายสินค้าวัตถุดิบชิ้นส่วนประกอบ และการบริการ ให้มีประสิทธิภาพ และประสิทธิผลสูงสุดโดยคำนึงถึงความต้องการและความพึงพอใจของลูกค้าเป็นสำคัญ และระบบโลจิสติกส์ก็เป็นกระบวนการหนึ่งของการจัดการสินค้าและบริการตลอดห่วงโซ่อุปทาน",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ). (2556). คลังความรู้ Logistics และ e-logistics, 28 สิงหาคม 2562. https://www.etda.or.th/terminology-detail/1563.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "environmental value",
    meaning:
      "คุณค่าของสิ่งแวดล้อม เป็นคุณค่าทั้งหมดรวมไปถึงคุณค่าที่ประเมินเป็นตัวเงินไม่ได้ และคุณค่าที่มนุษย์ไม่ได้เป็นผู้กำหนดเข้าไป\r\n",
    source:
      "กรมป่าไม้. (2555). ความสำคัญของนิเวศวิทยาต่อสิ่งแวดล้อม, 3 ตุลาคม 2562. http://biodiversity.forest.go.th/index.php?option=com_content&view=article&id=529:2012-08-24-09-02-42&catid=25:the-project&Itemid=68",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "Flagship Project",
    meaning:
      "โครงการสำคัญที่ตอบสนองต่อเป้าหมายเชิงยุทธศาสตร์ของประเทศใน4 ด้าน ประกอบด้วย\r\n1.การเพิ่มรายได้จากฐานเดิม\r\n2.การสร้างรายได้จากโอกาสใหม่\r\n3.การเพิ่มประสิทธิภาพในการแข่งขัน\r\n4.การลดรายจ่าย",
    source:
      "สำนักปลัดกระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. ยุทธศาสตร์กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม พ.ศ. 2556-2561, 3 ตุลาคม 2562. http://www.reo01.mnre.go.th/attachment/iu/download.php?WP=nKI4nKN5oGE3ZHkCoMOahKGtnJg4WaNjoGI3ARjkoH9axUF5nrO4MNo7o3Qo7o3Q",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "l"
  },
  {
    keyword: "Gross domestic Expenditure on R&D : GERD)",
    meaning:
      "ค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศทั้งหมด ประกอบด้วย\r\n1. ค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศรวมทั้งหมด (การลงทุนภาครัฐ การลงทุนภาคเอกชน และแหล่งทุนอื่น ๆ)\r\n2. สัดส่วนการลงทุนด้าน R&D ของภาครัฐ (งบประมาณแผ่นดิน) ต่อที่ไม่ใช่งบประมาณแผ่นดินทั้งหมด\r\n3. สัดส่วนการลงทุนด้าน R&D ของภาครัฐ (งบประมาณแผ่นดิน) ต่อภาคเอกชน\r\n4. สัดส่วนค่าใช้จ่าย R&D ที่ดำเนินการวิจัยในภาคเอกชนต่อภาคอื่น ๆ รวมทั้งหมด\r\n5. ร้อยละของค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศต่อผลิตภัณฑ์มวลรวม\r\n6. ร้อยละของงบประมาณแผ่นดินด้านการวิจัยและพัฒนาต่องบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ. 2560\r\n7. ค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศต่อจำนวนนักวิจัย 1 คน\r\n8. ค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศต่อประชากร 1 คน",
    source:
      "สำนักงานคณะกรรมการวิจัยแห่งชาติ. รายงานการสำรวจค่าใช้จ่ายและบุคลากรทางการวิจัยและพัฒนาของประเทศไทย ประจำปี 2561, 3 ตุลาคม 2562. https://www.research.chula.ac.th/wp-content/uploads/2019/12/NRCT-%E0%B8%A3%E0%B8%B2%E0%B8%A2%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%B3%E0%B8%A3%E0%B8%A7%E0%B8%88%E0%B8%84%E0%B9%88%E0%B8%B2%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%88%E0%B9%88%E0%B8%B2%E0%B8%A2%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%A5%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%A7%E0%B8%B4%E0%B8%88%E0%B8%B1.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "r"
  },
  {
    keyword: "IEC",
    meaning:
      "คณะกรรมาธิการระหว่างประเทศว่าด้วยมาตรฐานสาขาอิเล็กทรอเทคนิกส์ (International Electrotechnical Commission : IEC) \r\nเป็นองค์กรอิสระที่เริ่มก่อตั้งขึ้นเมื่อ พ.ศ. 2449 มีวัตถุประสงค์เพื่อจัดทำมาตรฐานระหว่างประเทศ ทางด้านไฟฟ้า อิเล็กทรอนิกส์ และเทคโนโลยีที่เกี่ยวข้อง นอกจากนี้ ยังดำเนินการจัดทำระบบการตรวจประเมิน เพื่อการรับรองคุณภาพให้กับมาตรฐานของ IEC เพื่อเป็นเครื่องมือในการอำนวยความสะดวกทางการค้าระหว่างประเทศ \r\nการเป็นสมาชิก IEC จะต้องมีการจัดตั้งคณะกรรมการแห่งชาติของประเทศ ซึ่งแต่ละประเทศจะมีคณะกรรมการแห่งชาติได้เพียงคณะเดียว",
    source:
      "สำนักงานมาตรฐานผลิตภัณฑ์อุตสาหกรรม (สมอ.) กระทรวงอุตสาหกรรม. IEC, 30 กันยายน 2562. https://www.tisi.go.th/website/interstandard/iec",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "IFOAM",
    meaning:
      "ระบบที่พัฒนาขึ้นโดยสหพันธ์เกษตรอินทรีย์นานาชาติ (International Federation of Organic Agriculture Movements - IFOAM) \r\nซึ่งเริ่มจัดตั้งโครงการรับรองระบบงานเกษตรอินทรีย์ IFOAM (IFOAM Accreditation Programme) ขึ้นในปี พ.ศ. 2535 เพื่อให้บริการรับรองระบบงานแก่หน่วยตรวจรับรองเกษตรอินทรีย์ต่างๆ ทั่วโลก  ต่อมา ในปี พ.ศ. 2540 สหพันธ์ฯ ได้จัดตั้ง IOAS (International Organic Accreditation Service) เป็นองค์กรไม่แสวงกำไรขึ้น เพื่อทำหน้าที่ในการให้บริการรับรองระบบงานนี้ ภายใต้กรอบของโครงการรับรองระบบงานเกษตรอินทรีย์ IFOAM ",
    source:
      "กรมการค้าภายใน กระทรวงพาณิชย์. มาตรฐาน IFOAM, 3 กันยายน 2562. \r\nhttp://www.organic.moc.go.th/th/standard/soil",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "Infrastructure Fund",
    meaning:
      "กองทุนรวมโครงสร้างพื้นฐาน กองทุนรวมประเภทหนึ่งที่ตั้งขึ้นเพื่อระดมทุนจากผู้ลงทุนทั่วไปทั้งรายย่อยและสถาบัน เพื่อลงทุนในกิจการโครงสร้างพื้นฐานที่เป็นประโยชน์สาธารณะในวงกว้างของประเทศไทย โดยกิจการโครงสร้างพื้นฐานเหล่านี้เป็นกิจการที่มีความจำาเป็น และเป็นประโยชน์ในการพัฒนาประเทศ อีกทั้งเป็นโครงการที่ใช้เงินลงทุนค่อนข้างสูง กองทุนรวมโครงสร้างพื้นฐานจึงจะสามารถช่วยแบ่งเบาภาระงบประมาณการลงทุนและการก่อหนี้สาธารณะของภาครัฐตลอดจนเป็นทางเลือกในการระดมทุนของภาคเอกชนในการพัฒนากิจการโครงสร้างพื้นฐานเหล่านี้ได",
    source:
      "สำานักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ ตลาดหลักทรัพย์แห่งประเทศไทย. กองทุนรวมโครงสร้างพื้นฐาน, 10 ตุลาคม 2562. https://www.set.or.th/th/products/listing2/files/Brochure_Infra_Fund_200514_01.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "Innovation Ecosystem",
    meaning:
      "การจัดทำมาตรการเพื่อเสริมสร้างสภาพแวดล้อมที่เอื้อต่อการพัฒนานวัตกรรม ในการสร้างสภาพแวดล้อมที่เหมาะสมต่อการพัฒนานวัตกรรมที่มีผลกระทบสูงทางเศรษฐกิจและสังคมจำต้องมีมาตรการสนับสนุนที่ครบถ้วน ประกอบด้วยมาตรการทางการเงินและทางภาษีเพื่อส่งเสริมการลงทุนด้านการวิจัยและพัฒนาเทคโนโลยีและนวัตกรรม มาตรการด้านแรงจูงใจเพื่อสนับสนุนการพัฒนาอุตสาหกรรมและคลัสเตอร์เป้าหมายของประเทศ ข้อเสนอการปรับปรุงแก้ไขหรือพัฒนากฎหมาย กฎระเบียบ ที่เอื้อต่อการลงทุนวิจัยและนวัตกรรม มาตรการสนับสนุนการพัฒนากำลังคนด้านวิจัยและนวัตกรรม และการพัฒนาโครงสร้างพื้นฐานที่เอื้อต่อกิจกรรมวิจัยและพัฒนา รวมทั้งมาตรการส่งเสริมการพัฒนามาตรฐานต่างๆ  ที่สำคัญ",
    source:
      "สำนักงานคณะกรรมการนโยบายวิทยาศาสตร์เทคโนโลยีและนวัตกรรมแห่งชาติ. (2561). แผนปฏิบัติการประจำปีงบประมาณ พ.ศ. 2562, 10 ตุลาคม 2562. http://www.nxpo.or.th/th/wp-content/uploads/2019/05/%e0%b8%a3%e0%b8%a7%e0%b8%a1%e0%b9%81%e0%b8%9c%e0%b8%99%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%9b%e0%b8%a3%e0%b8%b0%e0%b8%88%e0%b8%b3%e0%b8%9b%e0%b8%b5%e0%b8%87%e0%b8%9a%e0%b8%9b%e0%b8%a3%e0%b8%b0%e0%b8%a1%e0%b8%b2%e0%b8%93-62-V03-%e0%b9%80%e0%b8%aa%e0%b8%99%e0%b8%ad-%e0%b8%9a.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "Integrity & Transparency Assessment : ITA",
    meaning:
      "การประเมินคุณธรรมและความโปร่งใสในการดำเนินงานของหน่วยงานภาครัฐ เป็นการประเมินที่มีจุดมุ่งหมายที่จะก่อให้เกิดการปรับปรุงพัฒนาด้านคุณธรรมและความโปร่งใสในหน่วยงานภาครัฐ ซึ่งเป็นการประเมินที่ครอบคลุมหน่วยงานภาครัฐทั่วประเทศ โดยใช้แนวทางและเครื่องมือการประเมินตามที่สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ หรือ สำนักงาน ป.ป.ช. กำหนด ",
    source:
      "สำนักงานงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). (2562). ประโยชน์ของ ITA หรือการประเมินคุณธรรมและความโปร่งใสในการดำเนินงานของหน่วยงานภาครัฐ ทำแล้วดียังไง, 10 ตุลาคม 2562. https://www.dga.or.th/th/content/890/13462/",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "International Congress and Convention Association (ICCA)",
    meaning:
      "สมาคมส่งเสริมการประชุมระหว่างประเทศ เป็นสมาคมนานาชาติที่ก่อตั้งขึ้นในปี พ.ศ. 2506 (ค.ศ. 1963) เพื่ออุตสาหกรรมการประชุมนานาชาติ มีเครือข่ายสมาชิกสมาคมในทุกภาคส่วนของอุตสาหกรรมการประชุมนานาชาติใน 86 ประเทศทั่วโลก",
    source:
      "สำนักงานส่งเสริมการจัดประชุมและนิทรรศการ. รายงานตลาดการประชุมสมาคมนานาชาติในภูมิภาคเอเชียแปซิฟิกและตะวันออกกลาง, 17 ตุลาคม 2562. https://www.businesseventsthailand.com/uploads/press_media/file/190903-file-NbZz78EL1.pdf",
    sappear: 2,
    mappear: 5,
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "ISO",
    meaning:
      "ISO มาจากคำว่า International Organization for Standardization (ISO) เป็นมาตรฐานการวัดคุณภาพองค์กรต่างๆ เพื่อรับรองระบบการบริหารและการดำเนินงานขององค์กรในแต่ละประเทศเพื่อให้เป็นมาตรฐานเดียวกันทั่วโลก\r\nตัวเลขที่อยู่ด้านหลังคำว่า ISO นั้น หมายถึง สินค้าและบริการที่แตกต่างกัน เช่น โรงแรม ภัตตาคาร สนามบิน และ โรงงานอุตสาหกรรม เป็นต้น ระดับของมาตรฐานการวัดคุณภาพจะแบ่งออกเป็น 4 ระดับ ได้แก่\r\n1.        ISO9000\r\n2.        ISO9001\r\n3.        ISO9002\r\n4.        ISO9003\r\nซึ่งเป็นการวัดคุณภาพจากการจัดการขององค์กร และ ISO14000 จะเป็นเรื่องสิ่งแวดล้อม \r\nการจัดทำระบบคุณภาพ ISO มีข้อดีคือ ทำให้ผู้บริโภคมั่นใจในผลิตภัณฑ์ที่ใช้บริการว่าได้รับการคุ้มครองทั้งในเรื่องของ คุณภาพ และ ความปลอดภัย",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. ระบบ ISO คืออะไร?, 18 มิถุนายน 2562. https://www.nstda.or.th/th/vdo-nstda/sci-day-techno/3855",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "JETRO",
    meaning:
      "องค์การส่งเสริมการค้าต่างประเทศของญี่ปุ่น (Japan External Trade Organization: JETRO)เป็นหน่วยงานของรัฐที่เกี่ยวข้องกับการส่งเสริมการค้าและการลงทุนระหว่างประเทศญี่ปุ่นและต่างประเทศจัดตั้งขึ้นในปี พ.ศ.2501เพื่อส่งเสริมการส่งออกของญี่ปุ่นในต่างประเทศ",
    source:
      "กรมพัฒนาฝีมือแรงงาน กองวิเทศสัมพันธ์. ข้อมูลประกอบการเข้าเยี่ยมคารวะของ JETRO, 3 กันยายน 2562. http://home.dsd.go.th/icd/images/JETRO_25570609_for_public.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "KPI",
    meaning:
      "ดัชนีหรือหน่วยวัดความสำเร็จของการปฏิบัติงานที่กำหนดขึ้น  โดยเป็นหน่วยวัดที่แสดงผลสัมฤทธิ์ของงาน และสามารถแสดงผลเป็นข้อมูลในรูปของตัวเลขเพื่อสะท้อนประสิทธิภาพและประสิทธิผลในการทำงานขององค์กรหรือหน่วยงานต่างๆ ภายในองค์กร",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ.). (2555).  ตัวชี้วัดผลการปฏิบัติงานหลัก (Key Performance Indicators – KPIs), 30 กันยายน 2562. https://www.etda.or.th/content/1128.html",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "LNG Receiving Terminal",
    meaning:
      "กิจการเก็บรักษาและแปรสภาพก๊าซธรรมชาติจากของเหลวเป็นก๊าซ ให้บริการรับ จัดเก็บ และแปรสภาพก๊าซธรรมชาติเหลว (LNG) เป็นก๊าซธรรมชาติ ส่งเข้าสู่ระบบท่อส่งก๊าซธรรมชาติ",
    source:
      "สำนักงานคณะกรรมการกำกับกิจการพลังงาน. (2560). ร่างหลักเกณฑ์การกำหนดอัตราค่าบริการสำหรับกิจการเก็บรักษาและแปรสภาพก๊าซธรรมชาติจากของเหลวเป็นก๊าซ, 8 ตุลาคม 2562.\r\nhttp://www.erc.or.th/ERCWeb2/Upload/Document/%E0%B9%80%E0%B8%AD%E0%B8%81%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%99%E0%B8%9A2.1Hearing%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%87%E0%B8%A3%E0%B9%88%E0%B8%B2%E0%B8%87%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B9%80%E0%B8%81%E0%B8%93%E0%B8%91%E0%B9%8CLNG%20_Final2.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "LTF",
    meaning:
      "กองทุนรวมหุ้นระยะยาว (Long Term Equity Fund) เน้นลงทุนในหุ้น โดยทางการสนับสนุนให้จัดตั้งขึ้นเพื่อเพิ่มสัดส่วนผู้ลงทุนสถาบันที่จะลงทุนระยะยาวในตลาดหลักทรัพย์ฯ ซึ่งการเพิ่มผู้ลงทุนสถาบันดังกล่าวจะช่วยให้ตลาดทุนไทยมีเสถียรภาพมากขึ้น",
    source:
      "ตลาดหลักทรัพย์แห่งประเทศไทย. (2558).  LTFคืออะไร, 30 กันยายน 2562. https://www.set.or.th/education/th/begin/mutualfund_content08.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "Malaysia Plan (MP)",
    meaning:
      "แผนพัฒนาระดับชาติของมาเลเซีย มีการพัฒนาและการถ่ายระดับจากวิสัยทัศน์ระยะยาวจาก Outline Perspective Plan (OPP) 20 – 30 ปีและ Vision 2020 สู่แผนพัฒนาระยะกลาง 5 ปี หรือที่เรียกว่า Malaysia Plan (MP) ซึ่ง มี EPU เป็นหน่วยงานหลักในการยกร่างแผนฯ ผ่านกลไกการระดมสมองเพื่อรับฟังความคิดเห็นจากหน่วยงานภาครัฐที่เกี่ยวข้อง ทั้งในส่วนกลางระดับรัฐ และเขต ภาคเอกชน และผู้เชี่ยวชาญในสาขาต่างๆ ผ่าน Inter Agency Planning Group Technical Working Group และการประชุมกลุ่มย่อยมากกว่า 140 กลุ่ม เพื่อประกอบการยกร่างก่อนการนำเสนอต่อคณะกรรมการวางแผนการพัฒนาระดับชาติ (National Development Planning Committee) ซึ่งมีเลขาธิการคณะรัฐมนตรี (Chief Secretary to the Government) เป็นประธาน ก่อนนำเสนอคณะรัฐมนตรี และสภาเพื่อพิจารณาอนุมัติต่อไป กล่าวได้ว่า เป็นการวางแผนแบบ Top down และ Bottom up ซึ่งหน่วยงานวางแผนในส่วนกลาง และในระดับรัฐมีส่วนร่วมในการออกแบบแผนพัฒนาและร่วมกลั่นกรองแผนงาน/โครงการร่วมกัน มีการเปิดรับองค์ความรู้ เทคนิค และแลกเปลี่ยนข้อมูลเพื่อใช้ในการวางแผนจากภาคีการพัฒนาทั้งในประเทศและจากองค์กรระหว่างประเทศอย่างเป็นระบบ",
    source:
      "สำนักงานเลขานุการของคณะกรรมการปฏิรูปประเทศ. ร่างแผนปฏิรูปประเทศด้านเศรษฐกิจ, 7 ตุลาคม 2562. http://www.led.go.th/integration/pdf/3-2-5.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "a"
  },
  {
    keyword: "Matching Platform",
    meaning:
      "เป็นแพลตฟอร์มกลางระหว่างคนหางานและนายจ้างที่ต้องการสรรหาแรงงาน โดยนำเทคโนโลยีดิจิทัลปัญญาประดิษฐ์ เพิ่มประสิทธิภาพการให้บริการจับคู่งาน ให้มีความแม่นยำขึ้น",
    source:
      "สำนักเลขาธิการนายกรัฐมนตรี. (2561). ผลการประชุมคณะกรรมการขับเคลื่อนและเร่งรัดการดำเนินงานตามนโยบายรัฐบาล ครั้งที่ 8/2561, 17 ตุลาคม 2562. https://spm.thaigov.go.th/crtprs/spm-sp-layout6.asp?i=21111%2E81322702112113121111311",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "a"
  },
  {
    keyword: "Mega trends",
    meaning: "แนวโนมการเปลี่ยนแปลงในโลกอนาคตที่ไมสามารถหลีกเลี่ยงได",
    source:
      "ธนาคารแห่งประเทศไทย. ประเด็นชวนคิด: 6 Mega trends กับเศรษฐกิจไทย, 10 ตุลาคม 2562. https://www.bot.or.th/Thai/MonetaryPolicy/EconomicConditions/AAA/5MegaTrends.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "Methane Hydrate",
    meaning:
      "เป็นผลึกของแข็งที่ประกอบด้วยโมเลกุลของมีเทนซึ่งถูกล้อมรอบด้วยโมเลกุลของน้ำที่ล้อมรอบใน\r\nลักษณะเป็นกรง มีสูตรทางเคมีเป็น (CH4·5.75H2O) หรือ(4CH4·23H2O), แต่ถ้าจะอธิบายอย่าง\r\nง่ายๆ ก็คือสารที่ประกอบด้วยมีเทนในรูปผลึกโครงสร้างคล้ายน้ำแข็งแห้ง บางทีเราจะเรียกว่า \r\nน้ำแข็งไฟ (fire ice) ",
    source:
      "ฝ่ายตลาดท่อจัดจำหน่ายก๊าซธรรมชาติ บริษัท ปตท. จำกัด (มหาชน). (2558). จุลสารก๊าซไลน์, \r\n28 สิงหาคม 2562. https://dscng.pttplc.com/(S(2oaso1s25wzm3shqelaajr12))/Files/Gasline/\r\nGasLine_313.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "MSTQ",
    meaning:
      "ระบบการให้บริการเทคนิคด้านวิทยาศาสตร์และเทคโนโลยี(MSTQ) แบ่งเป็น 4 หมวดหลัก ได้แก่ \r\nระบบมาตรวิทยา (M:Metrology) การกำหนดมาตรฐาน (S:Standardization) การทดสอบ \r\n(T:Testing) และการรับรองคุณภาพ (Q:Quality Assurance) ระบบ MSTQ นี้เป็นโครงสร้าง\r\nพื้นฐานด้านคุณภาพ (Quality Infrastructure) ที่สำคัญในการผลักดันให้เกิดการเจริญเติบโต\r\nทางเศรษฐกิจ",
    source:
      "กระทรวงวิทยาศาสตร์และเทคโนโลยี (วท.). (2552). MSTQ ความเป็นมา, 28 สิงหาคม 2562. \r\nhttp://onestop.most.go.th/mstq/web/aboutUs",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "MTEF",
    meaning:
      "การจัดทำประมาณการงบประมาณรายจ่ายล่วงหน้าระยะปานกลาง(Medium Term Expenditure Framework (MTEF) เป็นกรอบที่เชื่อมการตัดสินใจการจัดทำงบประมาณรายจ่ายประจำปีเข้ากับกลยุทธ์การจัดสรรทรัพยากรระยะปานกลาง (สำนักงานงบประมาณ ,2542:103) หรืออีกนัยหนึ่ง คือ กระบวนการที่ช่วยให้ระบวนการวางแผนการใช้จ่าย(Financial Planning) ของภาครัฐและการวางแผนในระยะปานกลาง",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2555). คลังความรู้ MTEF, 28 สิงหาคม, 2562. https://www.etda.or.th/terminology-detail/1056.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "Multidisciplinary",
    meaning:
      "หลักสูตรที่นำเอาความรู้หลายศาสตร์หรือหลายอนุศาสตร์เข้ามาใช้ในการเรียนการสอน เพื่อประโยชน์ในการวิเคราะห์ วิจัย จนกระทั่งผู้เรียนสามารถพัฒนาความรู้ องค์ความรู้เป็นศาสตร์ใหม่ขึ้นหรือเกิดอนุศาสตร์ใหม่ขึ้น",
    source:
      "สำนักงานมาตรฐานและประกันคุณภาพการศึกษา. นิยามศัพท์, 10 ตุลาคม 2562. http://www.qa.cmru.ac.th/web/UserFiles/files/qasystem/qa_definition58.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "u"
  },
  {
    keyword: "NIDA Model",
    meaning:
      "ในปี พ.ศ. 2557 ประเทศไทยอยู่ในยุคของการปฏิรูปประเทศ สถาบันจึงได้รวบรวมคณาจารย์เพื่อนำเสนอแนวทาง การปฏิรูปประเทศใน 15 ด้าน เพื่อเสนอต่อสภาปฏิรูปแห่งชาติ (ส.ป.ช.)",
    source:
      "สถาบันบัณฑิตพัฒนบริหารศาสตร์. Good University Report 2017, 1 ตุลาคม 2562. http://www.nida.ac.th/th/images/publications/GUR_2017.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Non-Tariff Barriers",
    meaning:
      "อุปสรรคทางการค้าที่ไม่ใช่ภาษี (Non-Tariff Barriers)  เป็นกฎระเบียบข้อบังคับที่รัฐบาล ประเทศต่างๆ กำหนดขึ้นเพื่อเป็นสร้างอุปสรรคต่อการส่งออกของประเทศคู่ค้า หรือเพื่อกีดกันการนำเข้าที่ไม่สอดคล้อง กับความตกลงระหว่างประเทศ โดยทั่วไปพบว่าประเทศต่างๆ นำมาตรการที่มิใช่ภาษีมาใช้อย่างเข้มงวดเกินไป จนทำให้ ประเทศอื่นมองว่าเป็นมาตรการที่ไม่เป็นธรรม กลายเป็นอุปสรรคทางการค้าที่มิใช่ภาษีเกิดขึ้น เช่น การกำหนดคุณภาพที่ เกินมาตรฐานสากลหรือการเข้มงวดในการตรวจสอบมาตรฐานสินค้า และใช้เวลาในการตรวจสอบนานมากจนอาจทำให้ สินค้าเกิดความเสียหายตลอดจนการปฏิบัติด้านพิธีการศุลกากรที่ไม่เป็นธรรม เช่น - การบริหารโควตาภาษี (Tariffs Rate Quatas: TRQs) \r\n- สวัสดิภาพสัตว์ (Animal Welfare) \r\n- มาตรฐานสิ่งแวดล้อมที่เกี่ยวข้องกับการค้า (Trade-Related Environmental Measures) \r\n- การปิดฉลากสินค้าตัดแต่งสารพันธุกรรม (Genetically Modified Organisms: GMOs) \r\n- มาตรฐานแรงงาน (Trade and Labour Standard) เป็นต้น \r\n- การใช้มาตรการฝ่ายเดียวและอ้างว่าประเทศคู่ค้าไม่ปฏิบัติตามความตกลงของ WTO อย่างมีประสิทธิภาพ เช่น ประเด็นทรัพย์สินทางปัญญา \r\n- กฎระเบียบเกี่ยวกับกระบวนการตรวจสอบสินค้าและพิธีการศุลกากร \r\n- เงื่อนไขการลงทุนและนโยบายการแข่งขัน เป็นต้น",
    source:
      "กรมเจรจาการค้าระหว่างประเทศ กระทรวงพาณิชย์. (2556). ความรู้เบื้องต้นเกี่ยวกับ มาตรการที่มิใช่ภาษี(Non – Tariff Measures: NTMs) และอุปสรรคทางการค้าที่มิใช่ภาษี(Non-Tariff Barriers: NTBs), 7 ตุลาคม 2562. https://www.moc.go.th/index.php/moc-news-center-eng/item/non-tariff-measures-ntms-non-tariff-barriers-ntbs-11-2556.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "ombudsman",
    meaning:
      "บุคคลที่พระมหากษัตริย์ทรงแต่งตั้งตามคำแนะนำของวุฒิสภา ซึ่งเป็นบุคคลที่เป็นที่ยอมรับนับถือของประชาชน มีความรอบรู้และมีประสบการณ์ในการบริหารราชการแผ่นดิน วิสาหกิจหรือกิจกรรมอันเป็นประโยชน์ร่วมกันของสาธารณะ และมีความซื่อสัตย์สุจริตเป็นที่ประจักษ์",
    source:
      "สำนักงานผู้ตรวจการแผ่นดิน (สผผ.). ผู้ตรวจการแผ่นดิน, 1 ตุลาคม 2562. https://www.ombudsman.go.th/10/documents/brochure%20OMB.pdf",
    sappear: "",
    mappear: "",
    rappear: 8,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "One Marine Chart",
    meaning: "แผนที่การจำแนกเขตทางทะเลและชายฝั่ง",
    source:
      "กรมประชาสัมพันธ์. (2561). รัฐบาล เร่ง ปฏิรูปแก้ปัญหาการกัดเซาะชายฝั่งทั้งอ่าวไทย ด้วยการนำป่าชายเลนเป็นแนวป้องกันการกัดเซาะแทนการสร้างเขื่อนป้องกันในรูปแบบใช้น้ำจืดผลักดันน้ำเค็ม, 7 ตุลาคม 2562.\r\nhttp://thainews.prd.go.th/th/website_th/news/news_detail/TNEVN6102160010008",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "One Marine Chart",
    meaning: "แผนที่การจำแนกเขตทางทะเลและชายฝั่ง",
    source:
      "กรมประชาสัมพันธ์. (2561). รัฐบาล เร่ง ปฏิรูปแก้ปัญหาการกัดเซาะชายฝั่งทั้งอ่าวไทย ด้วยการนำป่าชายเลนเป็นแนวป้องกันการกัดเซาะแทนการสร้างเขื่อนป้องกันในรูปแบบใช้น้ำจืดผลักดันน้ำเค็ม, 7 ตุลาคม 2562.\r\nhttp://thainews.prd.go.th/th/website_th/news/news_detail/TNEVN6102160010008",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "One Stop Shop",
    meaning:
      "การรับมือกับปัญหาของการบริหารจัดการ และการประสานงานระหว่างบุคคลและระหว่างหน่วยงานปกครองต่าง ๆ ของรัฐ ทั้งในระดับเดียวกันและต่างระดับกันที่จะรับเรื่องและแจ้งผลให้ผู้ใช้บริการ ณ จุดบริการเดียว",
    source:
      "ศูนย์ข้อมูลข่าวสารอาเซียน กรมประชาสัมพันธ์. (2559). โครงการ One Stop Shop ของเวียดนาม, 30 กันยายน 2562. http://www.aseanthai.net/ewt_news.php?nid=4758&filename=aseanknowledge",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "one-stop service",
    meaning:
      "บริการดิจิทัลภาครัฐแบบเบ็ดเสร็จ ณ จุดเดียว เป็นศูนย์บริการร่วมรูปแบบออนไลน์ของภาครัฐ เพื่อการเข้าถึงข้อมูลและบริการภาครัฐแบบเบ็ดเสร็จ ณ จุดเดียว ช่วยให้ประชาชนผู้รับบริการสามารถพบกับส่วนราชการผู้ให้บริการได้ตลอดเวลา จากที่ไหนก็ได้\r\n",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทอล(องค์การมหาชน). (2561). One Stop Service(OSS), 30 กันยายน 2562. https://www.dga.or.th/upload/download/file_1207be8324f8debd0a21021c9281ed5b.pdf",
    sappear: "",
    mappear: "",
    rappear: "3,5",
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Operating budget",
    meaning:
      "งบประมาณดำเนินการ จะประกอบไปด้วยงบประมาณเหล่านี้คือ\r\n1.งบประมาณการขาย\r\n2.งบประมาณการผลิต\r\n3.งบประมาณวัตถุดิบ\r\n4.งบประมาณแรงงาน\r\n5.งบประมาณค่าใช้จ่ายโรงงาน\r\n6.งบประมาณต้นทุนการผลิต และงบประมาณต้นทุนสินค้าที่ขาย\r\n7.งบประมาณค่าใช้จ่ายในการขายและการบริหาร\r\n",
    source:
      "กรมส่งเสริมอุตสาหกรรม. การจัดทำงบประมาณ. 20 กันยายน 2562. https://bsc.dip.go.th/th/category/financial-accounting/fs-buggeting",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "p"
  },
  {
    keyword: "OSS",
    meaning:
      "OSS หรือ Open Source Software ซอฟต์แวร์ที่เปิดเผยต้นฉบับโปรแกรม ให้เสรีภาพในการแจกจ่าย เผยแพร่และปรับปรุง นับเป็นนวัตกรรมอันยิ่งใหญ่ที่ได้รับการยอมรับอย่างกว้างขวาง จากทุกวงการ ทุกประเทศ เหตุผลประการสำคัญคือการปฏิบัติที่สอดคล้องกับแนวคิดเศรษฐกิจพอเพียงตามพระราชดำริ พระบาทสมเด็จพระเจ้าอยู่หัวที่ได้พระราชทานแก่พสกนิกรชาวไทย รวมทั้งยังเป็นแนวทางที่เป็นรูปธรรมในการใช้ ICT อย่างมีคุณธรรมและจริยธรรม",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. ขุมทรัพย์ซอฟต์แวร์ OSS/Freeware, 4 กันยายน 2562. https://www.nstda.or.th/th/nstda-knowledge/2655-treasure-software-ossfreeware",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "Participatory Approach",
    meaning:
      "แนวคิดกระบวนการมีส่วนร่วมที่นับรวมผู้มีส่วนได้ส่วนเสียกับนโยบายกระบวนการเข้ามา เช่นนโยบายสาธารณะที่ใช้แนวคิดดังกล่าวประกอบก็จะมีการนับรวมประชาชนเข้ามามีส่วนร่วมกับทุกขั้นตอนในการกำหนด สร้างและขั้นใช้นโยบายด้วย เป็นต้น",
    source:
      "Unicef. PARTICIPATORY APPROACHES, 20 มิถุนายน 2562. https://www.unicef-irc.org/KM/IE/impact_5.php",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "a"
  },
  {
    keyword: "PGS",
    meaning:
      "ระบบการรับรองเกษตรอินทรีย์โดยชุมชน (Participatory Guarantee System, PGS) ตามหลักการและมาตรฐานเกษตรอินทรีย์สากล ด้วยการมีส่วนร่วมอย่างเข้มแข็ง และต่อเนื่องของผู้มีส่วนได้ส่วนเสียของชุมชน ภายใต้การสร้างพื้นฐานความไว้วางใจซึง\r\nกันและกัน การเป็นเครือข่ายทางสังคม และการแลกเปลี่ยนเรียนรู้",
    source:
      "มูลนิธิเกษตรอินทรีไทย TOAF. พีจีเอส หมายถึงอะไร. 18 พฤศจิกายน 2562.\r\nhttp://toaf.bmwbkk.com/userfiles/file/V.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "Platform",
    meaning:
      "ระบบโปรแกรมคอมพิวเตอร์ที่สามารถขยายขีดความสามารถอย่างไม่จำกัดมีการพัฒนาฟังก์ชั่นหรือโมดูลใหม่ๆ มาต่อยอดอยู่ตลอดเวลา เกิดนวัตกรรมใหม่ๆเสมอ และสามารถนำไปต่อเชื่อมกับระบบอื่นได้ แพลตฟอร์มไม่ได้จำกัดอยู่แค่ซอฟต์แวร์แต่ยังรวมไปถึงเว็บไซต์ หรือบริการที่คนอื่นสามารถเขียนโปรแกรมมาต่อเชื่อมหรือดึงข้อมูลได้โดยอัตโนมัติ",
    source:
      "กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม สำนักคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ. (ร่าง) แผนพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม. (หน้าที่ 64), 26 กันยายน 2562. ",
    sappear: "",
    mappear: "",
    rappear: 8,
    type: "หน่วยงาน",
    firstalpha: "l"
  },
  {
    keyword: "Policy Cycle",
    meaning: "วงจรของนโยบาย",
    source:
      "สถาบันชุมชนท้องถิ่นพัฒนา. (2560). การพัฒนานโยบายสาธารณะเพื่อสุขภาพแบบมีส่วนร่วม, 10 ตุลาคม 2562. https://www.ldm.in.th/cases/2937",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Policy labs",
    meaning: "การริเริ่มและทดสอบนโยบาย",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. สำนักงาน ก.พ.ร. ร่วมกับสำนักงานโครงการพัฒนาแห่งสหประชาชาติ (UNDP) และสำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ จัดการประชุม เรื่อง “ห้องปฏิบัติการนวัตกรรมภาครัฐ…พลิกโฉมนวัตกรรมงานบริการสาธารณะ”, 10 ตุลาคม 2562. https://www.opdc.go.th/content/Mjc5MA",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Policy Maker",
    meaning: "ผู้วางนโยบาย, ผู้กำหนดนโยบาย",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2560). กฎหมายซุปเปอร์โฮลดิ้ง : ปฏิรูปหรือแปรรูปรัฐวิสาหกิจ, 10 ตุลาคม 2562. http://library2.parliament.go.th/ejournal/content_af/2560/sep2560-3.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Policy Sandbox",
    meaning: "การปฏิบัติในสภาพแวดล้อมเฉพาะ",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2560). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม (พ.ศ. 2561 – 2580), 10 ตุลาคม 2562. https://www.dga.or.th/upload/download/file_d0f9c102e31944e66c6afb2cdac40722.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "PPP (Public-Private Partnership) การร่วมลงทุนระหว่างรัฐและเอกชน",
    meaning:
      "การร่วมลงทุนระหว่างภาครัฐและภาคเอกชนเพื่อจัดทำโครงการโครงสร้างพื้นฐานและบริการสาธารณะที่เป็นหน้าที่ของรัฐ โดยรัฐมอบหมายหน้าที่ให้ภาคเอกชนดำเนินการจัดทำโครงการดังกล่าวแทนผ่านสัญญาร่วมลงทุน",
    source:
      "สำนักงานคณะกรรมการนโยบายรัฐวิสาหกิจ. การให้เอกชนร่วมลงทุนในกิจการของรัฐตามพระราชบัญญัติการให้เอกชนร่วมลงทุนในกิจการของรัฐ พ.ศ. 2556\r\nhttp://www.ppp.sepo.go.th/assets/document/file/slide.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "u"
  },
  {
    keyword: "Product Champion",
    meaning:
      "ผลิตภัณฑ์ที่ได้รับการคัดเลือก ซึ่งมีความโดดเด่น ซึ่งจะสามารถมาพัฒนาและส่งเสริมให้ประสบความสำเร็จและสร้างประโยชน์ให้กับเชิงมูลค่าทางเศรษฐกิจและสร้างรายได้ให้กับประชาชนในจังหวัดได้เป็นอย่างดี",
    source:
      "สถาบันส่งเสริมการบริหารกิจการบ้านเมืองที่ดี สำนักงานคณะกรรมการพัฒนาระบบราชการ. โครงการการพัฒนาข้อมูลสถิติและสารสนเทศ ระดับพื้นที่ 76 จังหวัด/18 กลุ่มจังหวัด, 10 ตุลาคม 2562. https://www.igpthai.org/NS057/keyword.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "r"
  },
  {
    keyword: "RCEP",
    meaning:
      "Regional Comprehensive Economic Partnership (RCEP) คือ กรอบความร่วมมือทางเศรษฐกิจระหว่าง ASEAN 10 ประเทศกับคู่ภาคี ในปัจจุบันมี 6 ประเทศ คือ จีน ญี่ปุ่น เกาหลีใต้ อินเดีย ออสเตรเลีย และนิวซีแลนด์ RCEP พัฒนามาจาก ASEAN+1 โดยมุ่งหมายให้เกิดระบบการค้าเสรีที่ใช้กฎระเบียบเดียวกันของภาคีทั้งหมด 16 ประเทศเพื่อเชื่อมโยงเศรษฐกิจของอาเซียนเข้ากับเศรษฐกิจโลก (Global Supply Chain)",
    source:
      "กรมประชาสัมพันธ์. (2553). Regional Comprehensive Economic Partnership:RCEP คืออะไร, 28 สิงหาคม 2562. http://www.aseanthai.net/ewt_news.php?\r\nnid=5776&filename=aseanknowledge",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "RIA (Regulatory Impact Assessment)",
    meaning:
      "การประเมิน/วิเคราะห์ผลกระทบจากการกำหนดกฎหมาย กฎ และระเบียบ ซึ่งเป็นเครื่องมือในการวิเคราะห์ต้นทุน-ผลประโยชน์หรือ cost- benefot analysis (CBA) เพื่อประเมินว่ากฎหมาย กฎ และระเบียบ ที่ต้องการนำมาบังคับใช้นั้น มีต้นทุนที่เหมาะสมและก่อให้ผลประโยชน์สุทธิสูงสุด (net benefit) ต่อสังคม ชุมชน และประเทศ\r\n",
    source:
      "ความร่วมมือทางเศรษฐกิจเอเชีย-แปซิฟิก กระทรวงยุติธรรม และสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. แนวปฏิบัตในการวิเคราะห์ผลกระทบจากกฎหมายสำหรับหน่วยงานภาครัฐในประเทศไทย (Regulatory Impact Analysis (RIA) Guidelines for the Thailand Government, 12 กันยายน 2562, https://www.nesdb.go.th/download/RIA/ThailandRIATH.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "e"
  },
  {
    keyword: "Scenario Analysis",
    meaning:
      'กระบวนการวิเคราะห์เหตุการณ์ในอนาคต โดยการพิจารณา ทางเลือกของผลลัพธ์ต่างๆ ที่เป็นไปได้ (บางครั้งเรียกว่า "alternative worlds") ดังนั้น หลักการของ Scenario Analysis คือ การคาดการณ์ โดยไม่พยายามสร้างภาพที่จะเห็นได้ชัดแต่จะนำเสนอทางเลือกหลาย ๆ ทางที่สามารถพัฒนาได้ในอนาคต',
    source:
      "สำนักงานเลขาธิการวุฒิสภา. (2559). แผนยุทธศาสตร์สำนักงานเลขาธิการวุฒิสภาฉบับที่ ๔ (พ.ศ. ๒๕๖๐ – ๒๕๖๔) และแผนปฏิบัติราชการ ๔ ปี (พ.ศ. ๒๕๖๑ – ๒๕๖๔), 20 มิถุนายน 2562. https://www.senate.go.th/assets/portals/1/files/plan2560V4.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "c"
  },
  {
    keyword: "SDG",
    meaning:
      "SDGs มาจาก Sustainable Development Goals หมายถึง การจัดทำเป้าหมายการพัฒนาที่ยั่งยืน",
    source:
      "สถาบันแห่งชาติเพื่อการพัฒนาเด็กและครอบครัว มหาวิยาลัยมหิดล. SDGs : คืออะไร, 28 สิงหาคม 2562.\r\nhttps://personalweb.mahidol.ac.th/aree-yup/?page_id=428",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "smart farmer",
    meaning:
      "เป็นบุคคลที่มีความภาคภูมิใจในความเป็นเกษตรกร มีความรอบรู้ในระบบการผลิตด้านการเกษตรแต่ละสาขา มีความสามารถในการวิเคราะห์เชื่อมโยงและบริหารจัดการการผลิตและการตลาดโดยใช้ข้อมูลประกอบการตัดสินใจคคำนึงถึงคุณภาพ ความปลอดภัยของผู้บริโภคสังคมและสิ่งแวดล้อม",
    source:
      "การขับเคลื่อนนโยบายสำคัญของกระทรวงเกษตรและสหกรณ์ 15 โครงการ. 2561\r\nhttps://www.moac.go.th/dwl-files-401291791023",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "s"
  },
  {
    keyword: "SME",
    meaning:
      "วิสาหกิจขนาดกลางและขนาดย่อม (Small and Medium Enterprises) เป็นธุรกิจที่มีจำนวนมากในประเทศไทย ผู้ประกอบการส่วนมากประกอบการในรูปของบุคคลธรรมดา คณะบุคคลหรือห้างหุ้นส่วนสามัญที่มิใช่นิติบุคคล ห้างหุ้นส่วนจำกัด บริษัทจำกัด หรือกิจการร่วมค้า ซึ่งจะประกอบธุรกิจขายสินค้า ผลิตสินค้า หรือให้บริการ",
    source:
      "กรมสรรพากร. (2561). ลักษณะของ SMEs, 3 ตุลาคม 2562. https://www.rd.go.th/publish/38056.0.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword: "Social Inclusion",
    meaning:
      "การที่ประชาชนสามารถเข้าถึงบริการทางสังคม บริการที่รัฐจัดหา และการเข้าถึงการจ้างงานอย่างเสมอภาค เท่าเทียมกัน เข้าใจในสิทธิและหน้าที่ในฐานะพลเมืองของประเทศในการดำเนินกิจกรรมเพื่อสังคม การถูกรวมให้เป็นส่วนหนึ่งของสถาบันต่างๆ ทั้งที่เกิดขึ้นตามกฎหมาย และที่เกิดจากค่านิยม บรรทัดฐาน และวัฒนธรรมร่วมของชุมชนจนกลายเป็นความสัมพันธ์ทางสังคมที่เป็นเรื่องของชีวิตประจำวัน เช่น มีสิทธิลงคะแนนเสียงเลือกตั้ง สิทธิเด็กและสตรีการได้รับค่าแรงงานที่เป็นธรรมตามสิทธิ เป็นต้น",
    source:
      "สถาบันพระปกเกล้า. (2553).  “คุณภาพสังคมกับคุณภาพประชาธิปไตยไทย”, 10 ตุลาคม 2562. http://www.kpi.ac.th/media_kpiacth/pdf/M10_446.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Social Safety Net",
    meaning:
      "เป็นระบบสวัสดิการที่ให้ความช่วยเหลือเป็นพิเศษกล่าวคือ การให้ความช่วยเหลือประชาชนในประเทศไทยจะมีระบบหรือตาข่ายที่คอยรองรับประชาชนที่ประสบปัญหาวิกฤตเศรษฐกิจอยู่ 3 ชั้น คือ เมื่อประชาชนประสบปัญหาแล้วจะมีตาข่ายชั้นที่ 1 รองรับ แต่หากชั้นที่ 1 ไม่สามารถรองรับได้ก็จะมีตาข่ายชั้นที่ 2 รองรับ จนกระทั่งถึงตาข่ายชั้นสุดท้ายที่รองรับ เพื่อคอยรองรับประชาชนที่ประสบปัญหาให้มีความเดือดร้อนน้อยที่สุดหรือเจ็บตัวน้อยที่สุด โดยระบบที่ประเทศไทยมีไว้นี้จะเป็นเครื่องมือที่คอยให้ความช่วยเหลือประชาชนที่เดือนร้อนก่อนที่ภาครัฐจะให้เข้าไปให้ความช่วยเหลือ ขณะนี้ระบบตาข่ายความปลอดภัยทางสังคมในประเทศไทย 3 ระบบคือ 1.) ระบบการออมแบบผูกพันและไม่บังคับ 2.) ระบบการออมแบบบังคับ 3.) ระบบสวัสดิการสังคม ส่วนระบบ Social Safety Net จะเป็นระบบที่คอยรองรับประชาชนที่ตกจากตาข่ายความปลอดภัยทางสังคมทั้ง 3 ชั้นนั้นเพื่อเป็นตาข่ายขั้นสุดท้ายที่คอยรองรับประชาชนที่ประสบปัญหาวิกฤตเศรษฐกิจ ดังนั้นภาครัฐจึงได้พัฒนาระบบ Social Safety Net ให้เป็นรูปเป็นร่าง เพื่อเป็นเครื่องมือในการให้ความช่วยเหลือประชาชนที่เดือนร้อนจากปัญหาวิกฤตเศรษฐกิจโดยเป็นระบบที่ประชาชนทุกคนจะต้องได้รับโดยทั่วถึงและเข้าถึงสวัสดิการได้ง่าย และเพื่อไม่ให้เกิดความซ้ำซ้อนในการให้ความช่วยเหลือ",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2558). ศัพท์น่ารู้เกี่ยวกับเศรษฐกิจ,1 กรกฏาคม 2562.http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=96&NumRecShow=8&sort=6&search=",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "Stakeholder",
    meaning:
      "ผู้ที่ได้รับผลกระทบ ทั้งทางบวกและทางลบ ทั้งทางตรง และทางอ้อม จากการดำเนินการของส่วนราชการของท่าน เช่น ประชาชน ชุมชนในท้องถิ่น บุคลากร ในส่วนราชการ ผู้ส่งมอบงาน รวมทั้งผู้รับบริการด้วย",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ.). (2555). Stakeholders, 3 กันยายน 2562. https://www.etda.or.th/terminology-detail/1053.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "t"
  },
  {
    keyword: "Tax Credit",
    meaning:
      "การให้สินธิอันมีค่าเป็นตัวเงินสำหรับประโยชน์การคำภาษี เช่น กรณีผู้เสียได้ถูกหักภาษี ณ ที่จ่ายไว้แล้วจะสามารถนำภาษีนั้นมาถือเป็นเครดิตเพื่อหักกลบกับเงินภาษีที่ผู้เสียภาษีมีหน้าที่จะต้องชำระตามกฎหมายโดยหากเครดิตมีมากกว่าจำนวนเงินที่จะต้องชำระแล้วผู้เสียภาษีย่อมมีสิทธิได้รับคืนเงินภาษีเป็นเงิน ในบางประเทศยังได้ให้สิทธิประโยชน์เพื่อชักจูงการลงทุนระยะยาวโดยให้เครดิตภาษีแก่นักลงทุนในกรณีที่นำกำไรกลับมาลงทุนในกิจการต่อไป (มีจำนวนเป็นสัดส่วนกับเงินส่วนเพิ่มของกิจการ) (Re-investment Tax Credit )",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2549). ศัพท์น่ารู้เกี่ยวกับเศรษฐกิจ, 26 กันยายน 2562. http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=392&NumRecShow=8&sort=4&search=",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "a"
  },
  {
    keyword: "THAILAND 4.0",
    meaning:
      "โมเดลเศรษฐกิจที่จะนำพาประเทศไทยให้หลุดพ้นจากกับดักประเทศรายได้ปานกลาง กับดักความเหลื่อมล้ำ และกับดักความไม่สมดุล พร้อมๆ กับเปลี่ยนผ่านประเทศไทยไปสู่ประเทศในโลกที่หนึ่ง ที่มีความมั่นคง มั่งคั่ง และยั่งยืน ในบริบทของโลกยุค The Fourth Industrial Revolution อย่างเป็นรูปธรรม ตามแนวทางที่แผนยุทธศาสตร์ชาติ 20 ปีได้วางไว้ ด้วยการสร้างความเข้มแข็งจากภายใน ควบคู่ไปกับการเชื่อมโยงกับประชาคมโลก ตามแนวคิด “ปรัชญาเศรษฐกิจพอเพียง” โดยขับเคลื่อนผ่านกลไก“ประชารัฐ”",
    source:
      "กองบริหารงานวิจัยและประกันคุณภาพการศึกษา. (2559). Thailand 4.0 โมเดลขับเคลื่อนประเทศไทยสู่ความมั่งคั่ง มั่นคง และยั่งยืน, 26 กันยายน 2562. http://www.libarts.up.ac.th/v2/img/Thailand-4.0.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "หน่วยงาน",
    firstalpha: ""
  },
  {
    keyword:
      "The Organisation for Economic Co-operation and Development (OECD)",
    meaning:
      "องค์การเพื่อความร่วมมือทางเศรษฐกิจและการพัฒนามีบทบาทสำคัญในการเสริมความแข็งแกร่งทางด้านเศรษฐกิจให้แก่ประเทศสมาชิก โดยการปรับปรุงประสิทธิภาพการบริหารจัดการ ส่งเสริมการค้าเสรี และให้ความช่วยเหลือเพื่อพัฒนาทั้งในประเทศอุตสาหกรรมและประเทศกำลังพัฒนา",
    source:
      "กรมอาเซียน กระทรวงต่างประเทศ. (2561, 30 สิงหาคม). ประวัติและพัฒนาการ OECD, 19 มิถุนายน 2562. http://www.mfa.go.th/business/th/customize/16520-%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%B4%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A3-OECD.html",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "หน่วยงาน",
    firstalpha: "h"
  },
  {
    keyword: "Tight Gas",
    meaning:
      "ก๊าซธรรมชาติประเภท unconventional ที่พบได้ในชั้นหินหลายชนิด เช่น ชั้นหินทรายหรือชั้นหินปูน ไม่เฉพาะในชั้นหินดินดานเท่านั้น",
    source:
      "ศูนย์บริการข้อมูลธุรกิจไทยในอาร์เจนตินา. ภาคอุตสาหกรรม, 3 กันยายน 2562. http://www.thaibizargen.com/index.php?lay=show&ac=article&Id=539673734",
    sappear: "",
    mappear: "",
    rappear: 10,
    type: "หน่วยงาน",
    firstalpha: "i"
  },
  {
    keyword: "Transparency International : TI",
    meaning:
      "องค์กรเพื่อความโปร่งใสนานาชาติเป็นผู้นำในการต่อสู้และต่อต้านการคอร์รัปชัน โดยมีภารกิจที่สำคัญคือสร้างการเปลี่ยนแปลงไปในทางที่ให้โลกปราศจากการคอร์รัปชัน",
    source:
      "ศูนย์ปฏิบัติการต่อต้านการทุจริต กระทรวงอุตสาหกรรม. (2562). คะแนนดัชนีการรับรู้การทุจริต (CPI : CORRUPTION PERCEPTIONS INDEX), 26 กันยายน 2562. http://www.industry.go.th/anti_corrupt/index.php/agency/ita/cpi",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "หน่วยงาน",
    firstalpha: "r"
  },
  {
    keyword: "Treasury Centers",
    meaning:
      "นิติบุคคลที่ได้รับอนุญาตจากรัฐมนตรีว่าการกระทรวงการคลังให้ประกอบธุรกิจเกี่ยวกับการบริหารจัดการเงินตราต่างประเทศให้กับกลุ่มบริษัท",
    source:
      "ธนาคารแห่งประเทศไทย. ศูนย์บริหารเงิน (Treasury Center), 26 กันยายน 2562. https://www.bot.or.th/Thai/FinancialMarkets/ForeignExchangeRegulations/ForeignMeansOfPaymenBusinesses/Pages/TreasuryCenter.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "r"
  },
  {
    keyword: "Unearned Income",
    meaning:
      "เงินได้ที่มิได้มาจากการทำงาน เงินได้หรือผลประโยชน์อื่นใดที่เกิดจากการงอกเงยของทรัพย์สิน",
    source:
      "สำนักงานเศรษฐกิจการคลัง. (2557). เงินโอน แก้จน คนขยัน, 3 ตุลาคม 2562. http://www.fpo.go.th/main/getattachment/General-information-public-service/FPO-symposium/8515/NIT_Symposium_Benge_25-7-57.pdf.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "United Nations Convention Against Corruption : UNCAC",
    meaning:
      "เป็นกฎหมายระหว่างประเทศด้านการต่อต้านการทุจริตในระดับนานาชาติฉบับแรก โดยมีพันธกรณีต่อรัฐภาคีแบ่งออกเป็น ๓ ระดับ ได้แก่ \r\n1. พันธกรณีที่รัฐภาคีจะต้องปฏิบัติตาม \r\n2. พันธกรณีที่รัฐภาคีมีสิทธิเลือกที่จะกระทำหรือไม่ก็ได้ และ \r\n3. พันธกรณีที่รัฐภาคีจะต้องพิจารณา \r\nโดยแบ่งเนื้อหาหลักในอนุสัญญา UNCAC ได้ 5 หมวดหมู่ คือ หมวดการป้องกันการทุจริต หมวดการกำหนดความผิดทางอาญาและการบังคับใช้กฎหมาย หมวดความร่วมมือระหว่างประเทศ หมวดการติดตามทรัพย์สินคืน และหมวดความช่วยเหลือด้านเทคนิคและการแลกเปลี่ยนข้อมูล ปัจจุบัน มีรัฐภาคีรวม 186 ประเทศ รวมไทยซึ่งได้ลงนามและให้สัตยาบันเข้าเป็นภาคีอนุสัญญา UNCAC เมื่อวันที่ 9 ธ.ค. 2546 และวันที่ 1 มี.ค. 2554 ตามลำดับ",
    source:
      "ศูนย์ปฏิบัติการต่อต้านการทุจริต (ศปท.) กระทรวงการต่างประเทศ. (2561). อนุสัญญาสหประชาชาติว่าด้วยการต่อต้านการทุจริต (United Nations Convention against Corruption: UNCAC), 26 กันยายน 2562. http://www.mfa.go.th/acc/th/news/6825/92645-%E0%B8%AD%E0%B8%99%E0%B8%B8%E0%B8%AA%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2%E0%B8%AA%E0%B8%AB%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%8A%E0%B8%B2%E0%B8%95%E0%B8%B4%E0%B8%A7%E0%B9%88%E0%B8%B2%E0%B8%94%E0%B9%89%E0%B8%A7%E0%B8%A2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B9%88%E0%B8%AD%E0%B8%95%E0%B9%89%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%97%E0%B8%B8%E0%B8%88%E0%B8%A3%E0%B8%B4%E0%B8%95-(Uni.html",
    sappear: "",
    mappear: "",
    rappear: 11,
    type: "หน่วยงาน",
    firstalpha: "n"
  },
  {
    keyword: "up-cycle",
    meaning:
      "กระบวนการที่เน้นการใช้ทรัพยากรอย่างคุ้มค่าด้วยการพัฒนาให้เศษวัสดุเหลือใช้กลายเป็นผลิตภัณฑ์ใหม่ที่มีคุณภาพและมีมูลค่าสูงขึ้น",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. ระบบรับรองผลิตภัณฑ์หรือวัสดุที่ผลิตจากวัสดุเหลือใช้ที่เป็นมิตรกับสิ่งแวดล้อม (G-Upcycle) - เกี่ยวกับ G Upcycle, 3 ตุลาคม 2562. https://www.deqp.go.th/service-portal/g-green/gupcycle/%E0%B9%80%E0%B8%81-%E0%B8%A2%E0%B8%A7%E0%B8%81-%E0%B8%9A-g-upcycle/",
    sappear: "",
    mappear: "",
    rappear: 6,
    type: "หน่วยงาน",
    firstalpha: "u"
  },
  {
    keyword: "Value added",
    meaning:
      "ส่วนต่างระหว่างมูลค่าการผลิตและค่าใช้จ่ายขั้นกลางในการผลิต หรือกล่าวอีกนัยหนึ่งว่า มูลค่าเพิ่มประกอบปัจจัยการผลิตดังนี้\r\n1. ค่าจ้าง หรือค่าตอบแทนแรงงาน\r\n2. ภาษีทางอ้อม หัก เงินอุดหนุน\r\n3. ค่าเสื่อมราคา\r\n4. ส่วนเกินของการประกอบการ",
    source:
      "สำนักบัญชีประชาชาติ สำนักงานคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. คู่มือการประมวลผลสถิติบัญชีประชาชาติ, 3 ตุลาคม 2562. http://www.nesdc.go.th/ewt_dl_link.php?nid=3521&filename=national_account",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "a"
  },
  {
    keyword: "World Bank’s Ease of Doing Business Index",
    meaning:
      "การจัดอันดับความยากง่ายในการประกอบธุรกิจในประเทศต่าง ๆ ทั่วโลก โดยธนาคารโลก",
    source:
      "กรมบังคับคดี กระทรวงยุติธรรม. (2560). การประชุมเพื่อรายงานผลการจัดอันดับความยาก-ง่าย ในการประกอบธุรกิจของธนาคารโลก ประจำปี 2561, 26 กันยายน 2562.http://www.led.go.th/doing/pdf/4EODB.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "world Economic Forum (WEF)",
    meaning:
      "องค์กรระหว่างประเทศในด้านความร่วมมือระหว่างภาครัฐและเอกชน (International Organization for Public-Private Cooperation) การดำเนินกิจกรรมเพื่อเสนอแนะทิศทางในการกำหนดนโยบายด้านเศรษฐกิจ สังคม และการพัฒนาในระดับระหว่างประเทศ ผ่านเครือข่ายผู้นำภาคการเมือง ธุรกิจ และภาคประชาสังคม",
    source:
      "กองนโยบายเศรษฐกิจระหว่างประเทศ กรมเศรษฐกิจระหว่างประเทศ. (2555). World Economic Forum (WEF), 26 กันยายน 2562. http://www.mfa.go.th/business/th/cooperation/252/16479-World-Economic-Forum-(WEF).html",
    sappear: "",
    mappear: "",
    rappear: 4,
    type: "หน่วยงาน",
    firstalpha: "w"
  },
  {
    keyword: "Young Smart Farmer",
    meaning:
      "เกษตรกรรุ่นใหม่ที่ประกอบอาชีพและมีความสามารถ\r\nด้านการเกษตร สามารถทดแทนเกษตรกรรุ่นสูงอายุ นำเทคโนโลยีสมัยใหม่มาประยุกต์ใช้เพื่อเพิ่มประสิทธิภาพการผลิต การบริหารการจัดการ และการตลาดสินค้าเกษตร ไม่จำกัดเพศ อายุระหว่าง 17 – 45 ปี ",
    source:
      "กลุ่มพัฒนากลุ่มเกษตรกร กองพัฒนาสหกรณ์ภาคการเกษตรและกลุ่มเกษตรกร กรมส่งเสริมสหกรณ์. (2561). \r\nโครงการพัฒนาเกษตรกรปราดเปรื่อง (Smart Farmer)} 28 สิงหาคม 2562. \r\nhttp://office.cpd.go.th/dacfg/images/Karn2561/Smart-Farmer-2018.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "o"
  },
  {
    keyword: "เกษตรเพิ่มมูลค่า",
    meaning:
      "การนําผลิตผลทางการเกษตรมาแปรรูปโดยใช้กรรมวิธีการผลิตที่ไม่ซับซ้อน โดยเป็นการแปรรูปเพื่อให้ตรงกับความต้องการของผู้บริโภคเพื่อเพิ่มมูลค่าสินค้า สามารถจำแนกประเภทออกได้ดังนี้\r\n1. สินค้าเกษตรที่ไม่ใช่อาหาร เช่น ชานอ้อยจากโรงงานน้ำตาลที่สามารถนำไปใช้เป็นเชื้อเพลิง วัตถุดิบในการผลิตเยื่อกระดาษและไม้อัด เป็นต้น\r\n2. สินค้าเกษตรที่เป็นอาหาร ซึ่งต้องผ่านการแปรรูปให้เป็นผลิตภัณฑ์อาหารชนิดใหม่ เช่น การอบตากแห้ง การเผา คั่ว ทอด หรือการหมัก เป็นต้น",
    source:
      "กลุ่มส่งเสริมและพัฒนาผลิตภัณฑ์วิสาหกิจชุมชน กองส่งเสริมวิสาหกิจชุมชน กรมส่งเสริมการเกษตร. (ม.ป.ป). ความสำคัญของการสร้างมูลค่าเพิ่มสินค้าเกษตร, 5 มิถุนายน 2562. http://www.sceb.doae.go.th/data/ktank/ความสำคัญของการสร้างมูลค่าเพิ่มสินค้าเกษตร.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรแปรรูป",
    meaning:
      "การนำผลผลิตทางการเกษตรที่อยู่ในพื้นที่มาแปรรูปโดยผ่านกระบวนการทางวิทยาศาสตร์และเทคโนโลยีในกรรวิธีการผลิต ซึ่งมีประโยชน์ในการช่วยเก็บรักษาผลผลิตทางการเกษตรไว้บริโภคในครัวเรือนเป็นเวลานานโดยไม่เน่าเสีย หรือทำให้เกิดผลิตภัณฑ์ใหม่ๆ ที่มีรูปแบบและรสชาติแตกต่างจากไปเดิม ช่วยเพิ่มความหลากหลายให้แก่ผลผลิตทางการเกษตร ทำให้บริโภคสะดวกและง่ายขึ้น นอกจากนี้ยังช่วยเพิ่มช่องทางของตลาดให้มากขึ้น ตลอดจนช่วยกระจายปริมาณสินค้าเกษตรออกสู่ตลาดในปริมาณที่สมดุล",
    source:
      "ศูนย์ศึกษาการพัฒนาอ่าวคุ้งกระเบน กรมประมง. (2556). การแปรรูปผลผลิตทางการเกษตร, 5 มิถุนายน 2562. https://www.fisheries.go.th/cf-kung_krabaen/knowledge_14.pdf",
    sappear: 2,
    mappear: "3,9",
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรแม่นยำ",
    meaning:
      "การทำเกษตรที่มีการวิเคราะห์สภาพพื้นที่ มุ่งเน้นการเพิ่มประสิทธิภาพ (Efficiency) และเพิ่มผลผลิตต่อพื้นที่ (Productivity) โดยใช้เทคโนโลยีและเครื่องจักรกลการเกษตรอัจฉริยะ ควบคุมกระบวนการผลิตในทุกขั้นตอน",
    source:
      "สำนักอธิบดีกรมพัฒนาที่ดิน กรมพัฒนาที่ดิน. 2562. สัมมนาเกษตรอัจฉริยะ, 24 เมษายน 2562 ณ ห้องมิราเคิลแกรนด์ซี ชั้น 4 โรงแรมมิราเคิล แกรนด์ คอนเวนชั่น กรุงเทพมหานคร:  กรุงเทพมหานคร.",
    sappear: 2,
    mappear: 3,
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรกรรมยั่งยืน",
    meaning:
      "เป็นทางเลือกหนึ่งในการดำรงชีวิตและประกอบอาชีพของเกษตรกรรายย่อย โดยรูปแบบและวิธีการทำการเกษตรอย่างยั่งยืน จะขึ้นอยู่กับศักยภาพและความเหมาะสมของสภาพแวดล้อมในแต่ละพื้นที่และการตัดสินใจเลือกของเกษตรกร ซึ่งพิจารณาจากทรัพยากรธรรมชาติและสิ่งแวดล้อมที่มีอยู่ใน ภูมินิเวศ ฐานความรู้ ภูมิปัญญา และประสบการณ์การทำการเกษตรที่สั่งสมของเกษตรกร และฐานทางสังคม ที่สนับสนุนเกษตรกร มีการช่วยเหลือเกื้อกูล และแลกเปลี่ยนเรียนรู้ร่วมกัน โดยรูปแบบการทำเกษตรกรรมยั่งยืน ประกอบด้วย 5 รูปแบบหลักๆ ที่มีจุดเด่นแตกต่างกัน ดังนี้\r\n1. เกษตรทฤษฎีใหม่\r\n2. วนเกษตร\r\n3. เกษตรผสมผสาน\r\n4. เกษตรอินทรีย์\r\n5. เกษตรธรรมชาติ",
    source:
      "สำนักงานปลัดกระทรวงเกษตรและสหกรณ์, กองนโยบายเทคโนโลยีเพื่อการเกษตรและเกษตรกรรมยั่งยืน. รูปแบบการพัฒนาการเกษตรแบบยั่งยืน, 10 พฤศจิกายน 2559. https://www.opsmoac.go.th/sustainable_agri-sustainable_agri-preview-382891791792",
    sappear: "",
    mappear: 18,
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรทฤษฎีใหม่",
    meaning:
      "ระบบเกษตรที่เน้นการจัดการแหล่งน้ำ และการจัดสรรแบ่งส่วนพื้นที่ทำการเกษตรอย่างเหมาะสม ซึ่งจะทำให้เกษตรกรมีข้าวปลาอาหารไว้บริโภคอย่างพอเพียงตาม อัตตภาพ อันจะเป็นการแก้ปัญหาในเรื่องชีวิตความเป็นอยู่ของเกษตรกรแล้ว ยังก่อให้เกิดความมั่นคงทางเศรษฐกิจโดยรวมของประเทศ",
    source:
      "มูลนิธิเกษตรกรรมยั่งยืน (ประเทศไทย). เกษตรทฤษฎีใหม่ (New Theory farming), 23 กรกฎาคม 2562. http://www.sathai.org/autopagev4/show_page.php?topic_id=685&auto_id=15&TopicPk=",
    sappear: 2,
    mappear: 3,
    rappear: 5,
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรธรรมชาติ",
    meaning:
      "ระบบเกษตรที่ร่วมกับธรรมชาติได้อย่างสอดคล้อง สร้างผลผลิตพืชและสัตว์ให้เหมาะสมกับระบบนิเวศของพื้นที่ โดยไม่แบ่งแยกทุกสิ่งออกจากธรรมชาติ พยายามแทรกแซงการใช้ปัจจัยการผลิตและเทคโนโลยีทางการผลิตให้น้อยที่สุด ทำให้ระบบการเกษตรและธรรมชาติเกื้อกูลซึ่งกันและกันอย่างเป็นองค์รวม เน้นการนำกระบวนการควบคุมธรรมชาติโดยธรรมชาติ โดยไม่มีการใช้สารเคมีในการป้องกันและกำจัดศัตรูพืช รวมทั้งไม่ใช้ปุ๋ยเคมีหรือเทคโนโลยีใดๆ เข้ามาแทรกแซงหรือใช้ในการปรับปรุงทรัพยากรธรรมชาติ การดำเนินกิจกรรมธรรมชาติจะต้องไม่ไถพรวนดิน ซึ่งก่อให้เกิดการทำลายโครงสร้างดิน เนื่องจากธรรมชาติได้สร้างให้ดินมีกระบวนการที่เป็นการไถพรวนในตัวเอง ช่วยลดการใช้หรือพึ่งพาปัจจัยการผลิตจากภายนอก และลดการแทรกแซงของมนุษย์ที่มีต่อธรรมชาติให้มากที่สุด โดยหันมาใช้กลไกทางธรรมชาติในการผลิตทางการเกษตร เกษตรกรสามารถประหยัดค่าใช้จ่าย โดยสร้างภูมิคุ้มกันจากต้นทุนทางการผลิต ลดรายจ่ายของครอบครัวโดยไม่ต้องซื้อสารเคมีกำจัดศัตรูพืชหรือปุ๋ยเคมี มีวิถีชีวิตความเป็นอยู่แบบพึ่งพาตนเอง และผลิตเพื่อการบริโภคภายในครัวเรือนและมั่นคงภายใต้ระบบนิเวศที่สมดุลในพื้นที่ของตน",
    source:
      "ปราชญ์เกษตรของแผ่นดิน กองนโยบายเทคโนโลยีเพื่อการเกษตรและเกษตรกรรมยั่งยืน สำนักงานปลัดกระทรวงเกษตรและสหกรณ์. (2559). เกษตรธรรมชาติ, 5 มิถุนายน 2562. https://www.moac.go.th/philosopher-sustainable_agri-preview-382891791797",
    sappear: 2,
    mappear: 3,
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรผสมผสาน",
    meaning:
      "ระบบการเกษตรที่มีการปลูกพืชและการเลี้ยงสัตว์ มีสัตว์หลายชนิดในพื้นที่เดียวกัน \r\n โดยที่กิจกรรมการผลิตแต่ละชนิดจะต้องสามารถเกื้อกูลประโยชน์ต่อกันได้อย่างมีประสิทธิภาพ\r\n เป็นการใช้ทรัพยากรที่มีอยู่ภายในไร่นาอย่างเหมาะสมเพื่อก่อให้เกิดประโยชน์สูงสุด",
    source:
      "กองนโยบายเทคโนโลยีเพื่อการเกษตร และเกษตรกรรมยั่งยืน สำนักงานปลัดกระทรวงเกษตรและสหกรณ์. (2559). เกษตรผสมผสาน, 5 มิถุนายน 2562.\r\n https://www.moac.go.th/philosopher-sustainable_agri-preview-382891791795",
    sappear: "2,5",
    mappear: 3,
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรอินทรีย์",
    meaning:
      "ระบบจัดการการผลิตด้านการเกษตรแบบองค์รวมที่เกื้อหนุนต่อระบบนิเวศ รวมถึงความหลากหลายทางชีวภาพ วงจรชีวภาพ โดยเน้นการใช้วัสดุธรรมชาติ หลีกเลี่ยงการใช้วัตถุดิบจากการสังเคราะห์และไม่ใช้พืช สัตว์หรือจุลินทรีย์ที่ได้มาจากเทคนิคการดัดแปรพันธุกรรม (genetic modification) มีการจัดการกับผลิตภัณฑ์โดยเน้นการแปรรูปด้วยความระมัดระวัง เพื่อรักษาสภาพการเป็นเกษตรอินทรีย์และคุณภาพที่สำคัญของผลิตภัณฑ์ในทุกขั้นตอน",
    source:
      "สำนักงานมาตรฐานสินค้าเกษตรและอาหารแห่งชาติ กระทรวงเกษตรและสหกรณ์. แนวปฏิบัติในการใช้มาตรฐานสินค้าเกษตร เกษตรอินทรีย์ เล่ม 1 : การผลิต แปรรูป แสดงฉลาก และจําหน่ายผลิตผลและผลิตภัณฑ์เกษตรอินทรีย์ ตามพระราชบัญญัติมาตรฐานสินค้าเกษตร พ.ศ. 2551. (2551). , 30 กรกฎาคม 2562. https://www.acfs.go.th/standard/download/GUIDANCE_ORGANIC-PART-1_PRODUCTS-FROM-ORGANIC.pdf",
    sappear: "2,5",
    mappear: "3,6",
    rappear: 6,
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรอินทรีย์เชิงพาณิชย์",
    meaning:
      "เป็นการผลิตเพื่อจำหน่ายผ่านทางระบบตลาด ซึ่งต้องมีตรารับรองมาตรฐานทัดเทียมกับมาตรฐานสากล ทำให้ผลผลิตสามารถส่งออกไปจำหน่ายในต่างประเทศได้ ",
    source:
      "สำนักงานปลัดกระทรวงพาณิชย์. (2554). Thailand organic mapping เส้นทางสายอินทรีย์. 13 สิงหาคม 2562. http://www.organic.moc.go.th/sites/default/files/attachments/moc/part_1.pdf",
    sappear: 2,
    mappear: 3,
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "ก"
  },
  {
    keyword: "เขตเมือง",
    meaning:
      "พื้นที่มีประชากรอยู่กันอย่างหนาแน่นหรือมีจำนวนคนมากเมื่อเทียบกับพื้นที่ และประชากรส่วนใหญ่ในพื้นที่นั้นประกอบอาชีพที่มิใช่เกษตรกรรม",
    source:
      "สถาบันวิจัยประชากรและสังคม มหาวิทยาลัยมหิดล. ศัพทานุกรมการวิจัยทางประชากรและสังคม. (2557). เขตเมือง, 6 มิถุนายน 2562. http://www.popterms.mahidol.ac.th/Popterms/showmean.php?id=u00053&keyword=Urban%20area",
    sappear: 4,
    mappear: "",
    rappear: "",
    type: "หน่วยงาน",
    firstalpha: "ข"
  }
];

export default {
  _data
};
